<template>
  <div>
    <v-main transition="scroll-y-reverse-transition">
      <div class="new-background-color col-md-12 ml-sm-auto col-lg-12">
        <v-row class="no-gutters">
          <v-col cols="6" md="6" lg="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col style="text-align: end;" v-if="resCol === 'xs'">
            <v-btn :disabled="loadingRefresh" color="warning"
              style="border-radius: 20px !important;margin-right: 0px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
              @click="
                getDataDefault(),
                (searchOther = ''),
                (showColorSearch = false),
                (statusSearch = 'no')
                ">
              <v-icon color="white" left>mdi-refresh-circle</v-icon>
              รีเฟรชข้อมูล
              <template v-if="loadingRefresh">
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-col>
          <v-col cols="6" md="6" lg="6" class="v-margit_button text-right pr-0" style="background-color: #f2f7ff;" v-if="
            resCol === 'md' ||
            resCol === 'lg' ||
            resCol === 'xl' ||
            resCol === 'sm'
          ">
            <v-btn-toggle style="background-color: #f2f7ff;">
              <v-btn :loading="loadingRefresh" :disabled="loadingRefresh" color="warning"
                style="border-radius: 20px !important;margin-right: 0px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
                @click="
                  getDataDefault(),
                  (searchOther = ''),
                  (showColorSearch = false),
                  (statusSearch = 'no')
                  ">
                <v-icon color="white" left>mdi-refresh-circle</v-icon>
                รีเฟรชข้อมูล
                <template v-if="loadingRefresh">
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row v-if="resCol === 'xs'" style="margin-bottom: 10px;">
          <v-col cols="12" class="text-left">
            <template v-if="changeBackgroundColor">
              <v-row class="test px-2">
                <v-row style="justify-content: space-around;">
                  <v-col cols="6" style="display: flex;justify-content: center;">
                    <v-card style="padding: 10px; width: 230px;" :color="getSelectText === 'wait' ? '#F9DBB2' : 'white'"
                      dense elevation="0" prominent @click="
                        getSelect('wait', countWaiting, filterCloseJobValue)
                        ">
                      <div>
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#FEAE34">
                            <v-icon dark size="30" class="iconify" data-icon="ps:warning">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess1 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countWaiting }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" style="display: flex;justify-content: center;">
                    <v-card style="padding: 10px; width: 230px;"
                      :color="getSelectText === 'confirm' ? '#C9F2DC' : 'white'" dense icon="mdi-email-check" prominent
                      elevation="0" @click="
                        getSelect('confirm', countConfirm, filterCloseJobValue)
                        ">
                      <div>
                        <div class="text-center">
                          <v-avatar size="70" color="#97DDBB" style="padding:13px">
                            <v-icon dark size="40" class="iconify" data-icon="quill:mail-subbed">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess2 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countConfirm }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6" style="display: flex;justify-content: center;">
                    <v-card style="padding: 10px; width: 230px;" :color="getSelectText === 'confirmJob' ? '#F9E8F5' : 'white'
                      " dense icon="mdi-account-check" prominent elevation="0" @click="
                        getSelect('confirmJob', countJob, filterCloseJobValue)
                        ">
                      <div>
                        <div class="text-center">
                          <v-avatar color="#E5B5D8" size="70" class="pa-3">
                            <v-icon dark size="40" class="iconify" data-icon="bi:people">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess4 }}</strong>
                          <div style="text-align: center;">
                            จำนวน : <span class="notranslate">{{ countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6" style="display: flex;justify-content: center;">
                    <v-card style="padding: 10px; width: 230px;" :color="getSelectText === 'confirmSum' ? '#D7E8F9' : 'white'
                      " dense elevation="0" icon="mdi-expand-all" @click="
                        getSelect(
                          'confirmSum',
                          (countConfirm + countJob, filterCloseJobValue)
                        )
                        ">
                      <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                        <div class="text-center">
                          <v-avatar color="#76ABE5" size="70" class="pa-3">
                            <v-icon dark size="40" class="iconify" data-icon="bi:folder-plus">
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>รวมผู้เข้ารับบริการ</strong>
                          <div style="text-align: center;">
                            รวม : <span class="notranslate">{{ countConfirm + countJob + countCancel }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6" style="display: flex;justify-content: center;">
                    <v-card style="padding: 10px; width: 230px;"
                      :color="getSelectText === 'cancel' ? '#F9CACA' : 'white'" dense elevation="0"
                      icon="mdi-calendar-remove" prominent @click="
                        getSelect('cancel', countCancel, filterCloseJobValue)
                        ">
                      <div>
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#B72929">
                            <v-icon dark size="40" class="iconify" data-icon="carbon:rule-cancelled">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess3 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countCancel }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-row style="margin-bottom: 29px;" v-if="resCol !== 'xs'">
          <v-col cols="12" class="text-left">
            <template v-if="changeBackgroundColor">
              <v-row class="test">
                <v-row style="justify-content: space-around;">
                  <v-col :cols="resCol === 'md' ? '2' : 'auto'" style="display: flex;justify-content: center;">
                    <v-card :style="resCol === 'sm'
                        ? 'padding: 10px; width: 130px;'
                        : 'padding: 10px; width: 230px;'
                      " :color="getSelectText === 'confirm' ? '#C9F2DC' : 'white'" dense icon="mdi-email-check"
                      prominent elevation="0" @click="
                        getSelect('confirm', countConfirm, filterCloseJobValue)
                        ">
                      <div :style="resCol === 'lg'
                          ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                          : resCol === 'md'
                            ? ''
                            : ''
                        ">
                        <div class="text-center">
                          <v-avatar size="70" color="#97DDBB" style="padding:13px">
                            <v-icon dark size="40" class="iconify" data-icon="quill:mail-subbed">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div :style="resCol === 'md'
                            ? 'text-align: center;'
                            : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          ">
                          <strong>{{ dataTypeProcess2 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countConfirm }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col :cols="resCol === 'md' ? '2' : 'auto'" style="display: flex;justify-content: center;">
                    <v-card :style="resCol === 'sm'
                        ? 'padding: 10px; width: 130px;'
                        : 'padding: 10px; width: 230px;'
                      " :color="getSelectText === 'confirmJob' ? '#F9E8F5' : 'white'
                        " dense icon="mdi-account-check" prominent elevation="0" @click="
                        getSelect('confirmJob', countJob, filterCloseJobValue)
                        ">
                      <div :style="resCol === 'lg'
                          ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                          : resCol === 'md'
                            ? ''
                            : ''
                        ">
                        <div class="text-center">
                          <v-avatar color="#E5B5D8" size="70" class="pa-3">
                            <v-icon dark size="40" class="iconify" data-icon="bi:people">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div :style="resCol === 'md'
                            ? 'text-align: center;'
                            : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          ">
                          <strong>{{ dataTypeProcess4 }}</strong>
                          <div :style="resCol === 'md'
                              ? 'text-align: center;'
                              : 'text-align: center;left'
                            ">
                            จำนวน : <span class="notranslate">{{ countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col :cols="resCol === 'md' ? '2' : 'auto'" style="display: flex;justify-content: center;">
                    <v-card :style="resCol === 'sm'
                        ? 'padding: 10px; width: 130px;'
                        : 'padding: 10px; width: 230px;'
                      " :color="getSelectText === 'confirmSum' ? '#D7E8F9' : 'white'
                        " dense elevation="0" icon="mdi-expand-all" @click="
                        getSelect(
                          'confirmSum',
                          countConfirm + countJob,
                          filterCloseJobValue
                        )
                        ">
                      <div :style="resCol === 'lg'
                          ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                          : resCol === 'md'
                            ? ''
                            : ''
                        ">
                        <div class="text-center">
                          <v-avatar color="#76ABE5" size="70" class="pa-3">
                            <v-icon dark size="40" class="iconify" data-icon="bi:folder-plus">
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div :style="resCol === 'md'
                            ? 'text-align: center;'
                            : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          ">
                          <strong>รวมผู้เข้ารับบริการ</strong>
                          <div :style="resCol === 'md'
                              ? 'text-align: center;'
                              : 'text-align: center;left'
                            ">
                            รวม : <span class="notranslate">{{ countConfirm + countJob + countCancel }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col :cols="resCol === 'md' ? '2' : 'auto'" style="display: flex;justify-content: center;">
                    <v-card :style="resCol === 'sm'
                        ? 'padding: 10px; width: 130px;'
                        : 'padding: 10px; width: 230px;'
                      " :color="getSelectText === 'cancel' ? '#F9CACA' : 'white'" dense elevation="0"
                      icon="mdi-calendar-remove" prominent @click="
                        getSelect('cancel', countCancel, filterCloseJobValue)
                        ">
                      <div :style="resCol === 'lg'
                          ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                          : resCol === 'md'
                            ? ''
                            : ''
                        ">
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#B72929">
                            <v-icon dark size="40" class="iconify" data-icon="carbon:rule-cancelled">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div :style="resCol === 'md'
                            ? 'text-align: center;'
                            : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          ">
                          <strong>{{ dataTypeProcess3 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countCancel }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-divider v-if="resCol === 'xs'"></v-divider>
        <div class="pa-2 mb-4" v-if="resCol === 'xs'">
          <div>
            <v-menu ref="menu" v-model="menuStart" transition="scale-transition" offset-y max-width="290px"
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field hide-details background-color="white" v-model="dateStart"
                  style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                  label="เดือน/ปี" readonly outlined dense v-bind="attrs" v-on="on">
                  <template #prepend-inner>
                    <v-icon color="#69D1FD"
                      style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                      mdi-calendar
                    </v-icon>
                  </template></v-text-field>
              </template>
              <v-date-picker @input="
                (menuStart = false), (dataReady = false), getBookingList()
                " v-model="dateStart" type="month" no-title scrollable>
              </v-date-picker>
            </v-menu>
            <v-autocomplete v-model="masBranchID" background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              hide-details :items="branch" label="สาขา" outlined dense required :disabled="statusBranchReadonly"
              @change="(dataReady = false), (flowSelect = ''), getBookingList()"><template #prepend-inner>
                <v-icon color="#69D1FD"
                  style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                  mdi-map-marker-outline
                </v-icon>
              </template></v-autocomplete>
            <v-autocomplete
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              v-model="flowSelect" hide-details background-color="white" :items="DataFlowName" label="ประเภทบริการ"
              outlined dense @change="(dataReady = false), getBookingList()">
              <template #prepend-inner>
                <v-icon color="#69D1FD"
                  style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                  mdi-note-text-outline
                </v-icon>
              </template></v-autocomplete>
            <v-text-field class="textserch" background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              label="ค้นหาชื่อ และ เบอร์โทรศัพท์ ในตาราง" v-model="searchAll2" outlined hide-details dense><template
                #prepend-inner>
                <v-icon style="margin-top: 0px;">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
            <v-text-field class="textserch" background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              :label="$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
                  $session.getAll().data.category === '7'
                  ? 'ค้นหาชื่อทั้งหมด หรือ ทะเบียน'
                  : 'ค้นหาชื่อทั้งหมด'
                " v-model="searchOther" outlined hide-details dense append-icon="mdi-card-search-outline"
              @click:append="searchAny()">
            </v-text-field>
          </div>
        </div>
        <!-- panel -->
        <v-divider v-if="resCol !== 'xs'"></v-divider>
        <div class="pl-5 pb-5 pr-5 pt-0 mb-4" v-if="resCol !== 'xs'">
          <v-row style="display: flex;justify-content: space-between;margin-bottom:15px;margin-top:2px;">
            <v-col cols="auto" class="pl-0">
              <h3 style="margin-bottom: 15px;color: black;font-weight: bolder;">
                ตรวจสอบรายการนัดหมาย
              </h3>
            </v-col>
            <ModelBookingList></ModelBookingList>
          </v-row>
          <v-row>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-menu ref="menu" v-model="menuStart" transition="scale-transition" offset-y max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field hide-details background-color="white" v-model="dateStart"
                    style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;"
                    label="เดือน/ปี" readonly outlined dense v-bind="attrs" v-on="on">
                    <template #prepend-inner>
                      <v-icon color="#69D1FD"
                        style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                        mdi-calendar
                      </v-icon>
                    </template></v-text-field>
                </template>
                <v-date-picker @input="
                  (menuStart = false), (dataReady = false), getBookingList()
                  " v-model="dateStart" type="month" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-autocomplete v-model="masBranchID" background-color="white"
                style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;" hide-details
                :items="branch" label="สาขา" outlined dense required :disabled="statusBranchReadonly" @change="
                  (dataReady = false), (flowSelect = ''), getBookingList()
                  "><template #prepend-inner>
                  <v-icon color="#69D1FD"
                    style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                    mdi-map-marker-outline
                  </v-icon>
                </template></v-autocomplete>
            </v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-autocomplete style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;"
                v-model="flowSelect" hide-details background-color="white" :items="DataFlowName" label="ประเภทบริการ"
                outlined dense @change="(dataReady = false), getBookingList()">
                <template #prepend-inner>
                  <v-icon color="#69D1FD"
                    style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;">
                    mdi-note-text-outline
                  </v-icon>
                </template></v-autocomplete>
            </v-col>
            <v-col v-if="resCol !== 'sm'" cols="2"></v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '4'" class="pr-0 pl-0 pt-3">
              <v-text-field class="textserch" background-color="white" style="border-radius: 40px !important;"
                label="ค้นหาชื่อ และ เบอร์โทรศัพท์ ในตาราง" v-model="searchAll2" outlined hide-details dense><template
                  #prepend-inner>
                  <v-icon style="margin-top: 0px;">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end" v-if="(checkShopSigneture[$session.getAll().data.shopId] || false) === false">
            <v-col :cols="resCol === 'sm' ? '3' : '4'" class="pr-0 pl-0 pt-3">
              <v-text-field class="textserch" background-color="white" style="border-radius: 40px !important;" :label="$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
                  $session.getAll().data.category === '7'
                  ? 'ค้นหาชื่อทั้งหมด หรือ ทะเบียน'
                  : 'ค้นหาชื่อทั้งหมด'
                " v-model="searchOther" outlined hide-details dense prepend-inner-icon="mdi-magnify">
              </v-text-field>
            </v-col>
            <v-col cols="auto" class="pr-0 pl-1 pt-3">
              <v-btn rounded color="primary" dark @click="searchAny()">
                ค้นหา
              </v-btn>
            </v-col>
            <v-col cols="auto" class="pr-0 pl-1 pt-3" v-if="searchOther.length > 1">
              <v-btn rounded color="error" dark @click="
                getDataDefault(),
                (searchOther = ''),
                (showColorSearch = false),
                (statusSearch = 'no')
                ">
                clear
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <BookingQueue
        :branchParent="branch"
        :masBranchIDParent="masBranchID"
        :drawerParent="drawer"
        :menu1Parent="menu1"
        :timeTableParent="timeTable"
        :rulesParent="rules"
        :masterTimeParent="masterTime"
        :dataItemTimesChangeParent="dataItemTimesChange"
        :getTimesChangeParent="getTimesChange"
        :exportExcelParent="exportExcel"
        :exportExcelMazdaParent="exportExcelMazda"
        :dataRemoveExportParent="dataRemoveExport"
        :exportExcelRemoveParent="exportExcelRemove"
        :toggleParent="toggle"
        @updateTimeTable="updateTimeTablefromChild"
      ></BookingQueue>
        <v-card elevation="0" v-if="dataReady">
          <v-card-text>
            <v-row>
              <v-col col="auto">
                <v-expansion-panels
                  dense
                  accordion
                  v-if="resCol === 'xs'"
                  style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >รายการตรวจสอบ</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-btn
                        v-if="dataItem.length > 0"
                        color="blue-grey"
                        class="ma-2 white--text"
                        @click="toggle"
                        small
                      >
                        ตรวจสอบคิวจองรายวัน
                        <v-icon right dark>
                          mdi-table-eye
                        </v-icon>
                      </v-btn>
                      <!-- <v-btn
                        color="blue-grey"
                        class="ma-2 white--text"
                        small
                        @click="addDataSet()"
                      >
                        ตรวจสอบคิวจองรายเดือน
                      </v-btn> -->
                      <v-btn
                        v-if="DataFlowNameMenu.length > 0"
                        color="blue-grey"
                        class="ma-2 white--text"
                        small
                        @click="
                          (dialogShowMenuReport = true),
                            (dataShowMenuReport = []),
                            (dateStartShowMenuReport = '')
                        "
                      >
                        ตรวจสอบรายการเมนูรายวัน
                      </v-btn>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <template v-else>
                  <v-btn
                    v-if="dataItem.length > 0"
                    color="blue-grey"
                    class="ma-2 white--text"
                    @click="toggle"
                    small
                  >
                    ตรวจสอบคิวจองรายวัน
                    <v-icon right dark>
                      mdi-table-eye
                    </v-icon>
                  </v-btn>
                  <!-- <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    small
                    @click="addDataSet()"
                  >
                    ตรวจสอบคิวจองรายเดือน
                  </v-btn> -->
                  <v-btn
                    v-if="DataFlowNameMenu.length > 0"
                    color="blue-grey"
                    class="ma-2 white--text"
                    small
                    @click="
                      (dialogShowMenuReport = true),
                        (dataShowMenuReport = []),
                        (dateStartShowMenuReport = '')
                    "
                  >
                    ตรวจสอบรายการเมนูรายวัน
                  </v-btn>
                  <v-btn
                    v-if="
                      getSelectText === 'wait' &&
                        filteredSelect.length > 0 &&
                        $session.getAll().data.shopId !==
                          'Uc520945108b983b6e739ed0a8cd8dae4'
                    "
                    color="primary"
                    class="ma-2 white--text"
                    small
                    @click="exportExcelWait()"
                  >
                    <v-icon right dark>mdi-microsoft-excel</v-icon>
                    &nbsp;Export Excel
                  </v-btn>
                </template>
              </v-col>
              <v-col :cols="resCol === 'xs' ? '12' : '3'">
                <v-select
                  style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 5px;"
                  v-model="sortSelect"
                  hide-details
                  background-color="white"
                  :items="
                    getSelectText === 'wait' ? itemsSortWaiting : itemsSort
                  "
                  label="จัดเรียงข้อมูล"
                  outlined
                  dense
                  @change="checkTypeSort(sortSelect)"
                ></v-select>
                <v-radio-group v-model="sort" row @change="checkTypeSort()">
                  <v-radio
                    label="มากไปน้อย"
                    value="มากไปน้อย"
                    hide-details
                  ></v-radio>
                  <v-radio
                    label="น้อยไปมาก"
                    value="น้อยไปมาก"
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="text-right" cols="auto">
                <template v-if="getSelectText === 'confirmJob'">
                  <v-select
                    v-model="filterCloseJobValue"
                    background-color="white"
                    style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                    hide-details
                    :items="listFilterCloseJob"
                    label="สถานะบริการ"
                    outlined
                    dense
                    required
                    @change="
                      getSelect('confirmJob', countJob, filterCloseJobValue)
                    "
                  >
                    <template #prepend-inner>
                      <v-icon
                        class="mr-2 iconify"
                        data-icon="eos-icons:cronjob"
                        color="#69D1FD"
                        style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                      >
                      </v-icon>
                    </template>
                  </v-select>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div v-if="!dataReady" class="text-center">
          <waitingAlert></waitingAlert>
        </div>
        <!-- panel -->
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" v-if="dataReady">
              <v-card-text>
                <v-data-table :headers="columns" :items="dataItem" v-if="!selectedStatus" :search="searchAll2"
                  :items-per-page="10">
                  <template v-slot:[`item.cusName`]="{ item }">
                    <a @click.stop="openInfo(item)" style="cursor:hand"><u>{{ item.cusName }}</u></a>
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.dueDate`]="{ item }">
                    {{ format_date(item.dueDate) }}
                  </template>
                  <template v-slot:[`item.action2`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip filter dark v-if="
                          item.statusBt === 'confirm' ||
                          item.statusBt === 'confirmJob'
                        " :color="item.remarkConfirm1
                              ? 'green darken-2'
                              : 'grey darken-1'
                            " v-model="item.remarkConfirm1" @click.stop="
                            item.remarkConfirm1 = !item.remarkConfirm1;
                          confirmRemark(item, 'inAdvance');
                          ">
                          1 วัน
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action3`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip filter dark :color="item.fastTrack ? 'green darken-2' : 'grey darken-1'
                          " v-model="item.fastTrack" @click.stop="
                            item.fastTrack = !item.fastTrack;
                          confirmRemark(item, 'fastTrack');
                          ">
                          {{ dataTypeJob3 }}
                        </v-chip>
                      </v-col>
                      <v-col>
                        <v-chip filter dark :color="item.extraJob ? 'green darken-2' : 'grey darken-1'
                          " v-model="item.extraJob" @click.stop="
                            item.extraJob = !item.extraJob;
                          confirmRemark(item, 'extraJob');
                          ">
                          {{ dataTypeJob2 }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- confirm -->
                    <v-btn color="success" fab id="v-step-2" v-if="item.statusBt !== 'confirmJob'"
                      :disabled="item.chkConfirm" small @click.stop="confirmChk(item)">
                      <v-icon dark> mdi-phone-check </v-icon>
                    </v-btn>
                    <v-btn color="error" fab id="v-step-2" v-if="item.statusBt !== 'confirmJob'" small
                      :disabled="item.chkCancel" @click.stop="setDataRemove(item)" title="ยกเลิกนัด">
                      <v-icon dark> mdi-phone-cancel </v-icon>
                    </v-btn>
                    <v-tooltip bottom v-if="item.statusBt !== 'confirmJob'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-badge avatar bordered overlap :content="item.countChangeTime" color="warning" class="mr-1"
                          style="cursor: pointer">
                          <v-btn color="warning" fab small @click.stop="setDataChang(item)" v-bind="attrs" v-on="on">
                            <v-icon> mdi-calendar-clock </v-icon>
                          </v-btn>
                        </v-badge>
                      </template>
                      <span>เปลี่ยนเวลานัดหมาย</span>
                    </v-tooltip>

                  </template>
                </v-data-table>
                <v-data-table :headers="columnsSelected" :items="filteredSelect" v-if="selectedStatus"
                  :search="searchAll2" min-height="400px" :items-per-page="30" :item-class="getRowClass">
                  <template v-slot:[`item.dueDate`]="{ item }">
                    <div>
                      <div>
                        {{
                          item.dueDate.split(" ")[0].split("-")[2] +
                          "/" +
                          item.dueDate.split(" ")[0].split("-")[1] +
                          "/" +
                          item.dueDate.split(" ")[0].split("-")[0]
                        }}
                      </div>
                      <div>{{ item.dueDate.split(" ")[1] }} น.</div>
                    </div>
                  </template>
                  <template v-slot:[`item.cusName`]="{ item }">
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col col="auto" class="text-ceter" v-if="
                            item.userId === 'user-skip' ||
                            item.userId === '' ||
                            item.userId === null
                          ">
                            {{ item.cusName }}
                          </v-col>
                          <template v-else>
                            <v-col col="auto" class="text-ceter">
                              <a @click.stop="openHistory(item)" style="cursor:hand"><u>{{ item.cusName }}</u></a>
                            </v-col>
                          </template>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.remark`]="{ item }">
                      <p v-if="item.remark !== ''" style="color: black; margin-right: 10px">{{
                        item.remark.slice(0, 48)
                      }}</p>
                    <div v-if="item.remark.length >= 50">
                      <v-menu nudge-left="80" rounded="xl" top open-on-hover :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn rounded outlined x-small v-bind="attrs" v-on="on"
                            style="color: #1363DF;font-weight: bold;">
                            อ่านเพิ่มเติม<v-icon color="#1363DF"
                              style="font-size: 20px;margin-left: 5px;text-decoration: none;">mdi-arrow-right</v-icon>
                          </v-btn>
                        </template>
                        <v-card max-width="300">
                          <v-list>
                            <v-list-item width="200px">
                              <v-list-item-content width="200px">
                                {{ item.remark }}</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>
                  </template>
                  <template v-slot:[`item.checkStatus`]="{ item }">
                    <div class="text-center">
                      <div class="status-cloumn" style="background-color:#4CAF50;" v-if="item.checkStatus === 'จบงาน'">
                        <span>{{ item.checkStatus }}</span>
                      </div>
                      <div class="status-cloumn" style="background-color:#3F51B5;"
                        v-else-if="item.checkStatus === 'รอมอบหมายงาน'">
                        {{ item.checkStatus }}
                      </div>
                      <div class="status-cloumn" style="background-color:#FF9800;"
                        v-else-if="item.checkStatus === 'รอเริ่มงาน'">
                        {{ item.checkStatus }}
                      </div>
                      <div class="status-cloumn" style="background-color:#0097A7;"
                        v-else-if="item.checkStatus === 'กำลังดำเนินงาน'">
                        {{ item.checkStatus }}
                      </div>
                      <div class="status-cloumn" style="background-color:#F44336;"
                        v-else-if="item.checkStatus === 'ยกเลิกงาน'">
                        {{ item.checkStatus }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.actionPrint`]="{ item }">
                    <div class="text-center">
                      <PdfAirMate v-if="item.actionPrint === 'จบงาน'" :Item="item"></PdfAirMate>
                    </div>
                  </template>
                  <!-- Airmate: ปุ่มมอบหมายงาน โชว์เฉพาะที่ card ยืนยันแล้ว -->
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      @click.stop="getBookingDataJob(item, 'qrcode'),getEmpSelectAddJob(),(dialogOnsite = true)"
                      v-if="(item.statusBt === 'confirm' && showOnsite === 'ไม่แสดง') && (checkShopSigneture[$session.getAll().data.shopId])"
                      style="background-color: #E0F4FF;border-radius: 10px;font-weight: bold;"
                      class="black--text pa-5"
                      elevation="0"
                    >
                      <v-icon color="#73777B" class="mr-2">
                        mdi-account-plus
                      </v-icon>
                        มอบหมายงาน
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog v-model="dialogOnsite" persistent max-width="70%">
          <v-card class="text-center">
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>มอบหมายงานให้พนักงาน Onsite</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogOnsite = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-row>
              <v-col
                class="pb-0 pt-0"
                cols="12"
                v-if="
                  dataPackage.filter(el => {
                    return el.balanceAmount > 0;
                  }).length > 0 && dataPackageDefault === false
                "
              >
                <v-card class="pl-1">
                  <v-subheader
                    >ลูกค้ามี
                    {{
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length
                    }}
                    แพ็คเกจ</v-subheader
                  >
                  <v-subheader v-show="StatusPackage.packageName"
                    >ลูกค้าได้ทำการเลือกแพ็คเกจ
                    {{ StatusPackage.packageName }}</v-subheader
                  >
                  <v-slide-group
                    v-model="modelPackageIndexConfirmJob"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, index) in dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      })"
                      :key="index"
                    >
                      <v-card
                        class="ma-2 p-1"
                        width="340"
                        height="100"
                        color="#FFFFFF"
                        elevation="6"
                        :style="
                          item.packageId === packageId &&
                          item.token === tokenPackage
                            ? 'border: 1px solid green;'
                            : 'border: 1px solid white;'
                        "
                      >
                        <v-row>
                          <v-col cols="4" class="pr-1">
                            <v-img
                              contain
                              max-height="80"
                              max-width="200"
                              :src="item.packageImg"
                            ></v-img>
                          </v-col>
                          <v-col cols="8" class="pb-6">
                            <v-row class="font16 headline1">
                              <v-col class="pl-0 pt-2 pb-0">{{
                                item.packageName
                              }}</v-col>
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId !== packageId &&
                                    item.token !== tokenPackage
                                "
                                color="green"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ตกลง',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = true)
                                "
                                >ตกลง</v-btn
                              >
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId === packageId &&
                                    item.token !== tokenPackage
                                "
                                color="green"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ตกลง',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = true)
                                "
                                >ตกลง</v-btn
                              >
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId === packageId &&
                                    item.token === tokenPackage
                                "
                                color="red"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ยกเลิก',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = false)
                                "
                                >ยกเลิก</v-btn
                              >
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0"
                                >จำนวนการใช้ {{ item.balanceAmount }} /
                                {{ item.amount }}
                              </v-col>
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0">
                                <VueCustomTooltip
                                  label="สามารถใช้ได้"
                                  position="is-top"
                                  v-if="dateTimestamp <= item.expirePackage"
                                >
                                  <v-icon large color="teal darken-2">
                                    mdi-clock-check
                                  </v-icon>
                                </VueCustomTooltip>
                                <VueCustomTooltip
                                  label="หมดอายุแล้ว"
                                  position="is-top"
                                  v-if="dateTimestamp > item.expirePackage"
                                >
                                  <v-icon large color="red darken-2">
                                    mdi-clock-alert
                                  </v-icon>
                                </VueCustomTooltip>
                                >> วันหมดอายุ
                                {{
                                  new Date(item.expirePackage * 1000)
                                    .toLocaleString()
                                    .substr(0, 9)
                                }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-card>
                <br />
              </v-col>
              <v-col
                class="pb-0 pt-0"
                cols="12"
                v-if="
                  dataPackage.filter(el => {
                    return el.balanceAmount > 0;
                  }).length > 0 && dataPackageDefault === true
                "
              >
                <v-card class="pl-1">
                  <v-subheader
                    >ลูกค้ามี
                    {{
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length
                    }}
                    แพ็คเกจ</v-subheader
                  >
                  <v-subheader v-show="StatusPackage.packageName"
                    >ลูกค้าได้ทำการเลือกแพ็คเกจ
                    {{ StatusPackage.packageName }}</v-subheader
                  >
                  <v-slide-group
                    v-model="modelPackageIndexConfirmJob"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, index) in dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      })"
                      :key="index"
                    >
                      <v-card
                        class="ma-2 p-1"
                        width="340"
                        height="100"
                        color="#FFFFFF"
                        elevation="6"
                        :style="
                          item.packageId === packageId &&
                          item.token === tokenPackage
                            ? 'border: 1px solid green;'
                            : 'border: 1px solid white;'
                        "
                      >
                        <v-row>
                          <v-col cols="4" class="pr-1">
                            <v-img
                              contain
                              max-height="80"
                              max-width="200"
                              :src="item.packageImg"
                            ></v-img>
                          </v-col>
                          <v-col cols="8" class="pb-6">
                            <v-row class="font16 headline1">
                              <v-col class="pl-0 pt-2 pb-0">{{
                                item.packageName
                              }}</v-col>
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0"
                                >จำนวนการใช้ {{ item.balanceAmount }} /
                                {{ item.amount }}
                              </v-col>
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0">
                                <VueCustomTooltip
                                  label="สามารถใช้ได้"
                                  position="is-top"
                                  v-if="dateTimestamp <= item.expirePackage"
                                >
                                  <v-icon large color="teal darken-2">
                                    mdi-clock-check
                                  </v-icon>
                                </VueCustomTooltip>
                                <VueCustomTooltip
                                  label="หมดอายุแล้ว"
                                  position="is-top"
                                  v-if="dateTimestamp > item.expirePackage"
                                >
                                  <v-icon large color="red darken-2">
                                    mdi-clock-alert
                                  </v-icon>
                                </VueCustomTooltip>
                                >> วันหมดอายุ
                                {{
                                  new Date(item.expirePackage * 1000)
                                    .toLocaleString()
                                    .substr(0, 9)
                                }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-card>
                <br />
              </v-col>
            </v-row>
            <!-- <v-card-title>มอบหมายงานให้พนักงาน Onsite</v-card-title> -->
            <v-card-text v-if="dataEditJobReady">
              <v-container>
                <v-col
                  v-for="(item, indexitem) in BookingDataItem"
                  :key="indexitem"
                  cols="12"
                  class="pa-0"
                >
                  <v-text-field
                    :label="item.fieldName"
                    :value="item.fieldValue"
                    class="pa-0"
                    outlined
                    dense
                    readonly
                  ></v-text-field>
                </v-col>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <div v-for="(p, index) in flowfieldNameitem" :key="index">
                    <div class="pa-0" v-if="p.conditionField === ''">
                      <div>
                        <div v-if="p.fieldType == 'text'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div v-if="p.fieldType == 'number'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <v-row>
                          <v-col
                            cols="12"
                            v-if="p.fieldType == 'Autocompletes'"
                            style="padding-top: 0px;padding-bottom: 0px;"
                          >
                            <br />
                            <v-autocomplete
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              dense
                              filled
                              :label="p.fieldName"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="p.fieldType == 'Selects'"
                            style="padding-top: 0px;padding-bottom: 0px;"
                          >
                            <br />
                            <div>
                              <v-select
                                v-model="p.fieldValue"
                                :items="JSON.parse(p.optionField)"
                                menu-props="auto"
                                :label="p.fieldName"
                                hide-details
                                outlined
                                dense
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              ></v-select>
                            </div>
                          </v-col>
                        </v-row>
                        <div v-if="p.fieldType == 'Radio'" style="padding:0px;">
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        p.conditionField !== '' &&
                          flowfieldNameitem.filter(row => {
                            return row.fieldId === parseInt(p.conditionField);
                          }).length > 0
                      "
                    >
                      <div
                        v-if="
                          p.conditionValue ===
                            flowfieldNameitem.filter(row => {
                              return row.fieldId === parseInt(p.conditionField);
                            })[0].fieldValue
                        "
                      >
                        <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                          <v-autocomplete
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            dense
                            filled
                            :label="p.fieldName"
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </div>
                        <div v-if="p.fieldType == 'Selects'">
                          <v-select
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            menu-props="auto"
                            :label="p.fieldName"
                            dense
                            hide-details
                            outlined
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-select>
                        </div>
                        <div
                          v-if="p.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                    <div v-if="p.conditionField === 'flow'">
                      <div
                        v-if="
                          parseInt(p.conditionValue) ===
                            parseInt(formAdd.flowId)
                        "
                      >
                        <div v-if="p.fieldType == 'text'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div v-if="p.fieldType == 'number'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                          <v-autocomplete
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            dense
                            filled
                            :label="p.fieldName"
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </div>
                        <div v-if="p.fieldType == 'Selects'">
                          <v-select
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            menu-props="auto"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            hide-details
                            outlined
                          ></v-select>
                        </div>
                        <div
                          v-if="p.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                      <v-text-field
                        readonly
                        v-model="dueDateText"
                        outlined
                        dense
                        label="วันที่นัดหมายลูกค้า"
                        prepend-inner-icon="mdi-calendar-multiple-check"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-autocomplete
                        v-model="empSelectJob"
                        :items="empSelectStepAdd"
                        label="พนักงาน Onsite"
                        menu-props="auto"
                        outlined
                        required
                        :rules="[rules.required]"
                        dense
                        @change="checkEmpJob()"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="empSelectJob !== ''">
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet height="64">
                        <v-toolbar dense>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="prev()"
                          >
                            <v-icon small>
                              mdi-chevron-left
                            </v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="next()"
                          >
                            <v-icon small>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn>
                          <v-toolbar-title>{{
                            monthNamesThai[parseInt(today.split("-")[1])] +
                              " " +
                              today.split("-")[0]
                          }}</v-toolbar-title>
                        </v-toolbar>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="empSelectJob !== '' && checkEventInfo.length > 0"
                  >
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet>
                        <v-calendar
                          ref="calendaronsite"
                          :now="today"
                          v-model="today"
                          locale="th-TH"
                          color="primary"
                          type="month"
                        >
                          <template v-slot:day="{ date }">
                            <div v-if="eventInfo[date]">
                              <v-row>
                                <v-col class="text-center mb-1 mt-0">
                                  <v-badge
                                    avatar
                                    bordered
                                    overlap
                                    color="orange darken-1"
                                    v-if="eventInfo[date].sortNo1 > 0"
                                    class="mr-1"
                                    style="cursor: pointer"
                                    @click.native="
                                      openCalendaList(date, 'sortNo1')
                                    "
                                  >
                                    <template v-slot:badge>
                                      <v-avatar
                                        class="mb-1"
                                        color="orange darken-1"
                                      >
                                        {{ eventInfo[date].sortNo1 }}
                                      </v-avatar>
                                    </template>

                                    <v-avatar size="40" color="orange darken-3">
                                      <v-icon dark>
                                        mdi-water-plus
                                      </v-icon>
                                    </v-avatar>
                                  </v-badge>
                                  <v-badge
                                    avatar
                                    bordered
                                    overlap
                                    color="blue darken-1"
                                    v-if="eventInfo[date].sortNo2 > 0"
                                    class="mr-1"
                                    style="cursor: pointer"
                                    @click.native="
                                      openCalendaList(date, 'sortNo2')
                                    "
                                  >
                                    <template v-slot:badge>
                                      <v-avatar
                                        class="mb-1"
                                        color="blue darken-1"
                                      >
                                        {{ eventInfo[date].sortNo2 }}
                                      </v-avatar>
                                    </template>

                                    <v-avatar size="40" color="blue darken-3">
                                      <v-icon dark>
                                        mdi-water-check
                                      </v-icon>
                                    </v-avatar>
                                  </v-badge>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="empSelectJob !== '' && checkEventInfo.length === 0"
                  >
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet>
                        <v-calendar
                          ref="calendaronsite"
                          :now="today"
                          v-model="today"
                          locale="th-TH"
                          color="primary"
                          type="month"
                        ></v-calendar>
                      </v-sheet>
                    </v-col>
                    <v-col cols="12">
                      <v-alert text type="success">
                        เดือน
                        <strong>{{
                          monthNamesThai[parseInt(today.split("-")[1])]
                        }}</strong>
                        พนักงานท่านนี้ <strong>ว่างงาน</strong>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-form>
                <br />
                <template v-if="BookingDataItem.length > 0">
                  <div
                    class="text-center"
                    v-if="BookingDataItem[0].addressLatLong === null"
                  >
                    <v-alert dense outlined type="error">
                      <v-row align="center">
                        <v-col class="grow">
                          เนื่องจาก นัดหมายนี้ยังไม่มี แผนที่ กรุณานำ QR code
                          หรือ ส่งลิงค์ ให้ลูกค้ากรอกด้วย !!
                        </v-col>
                        <v-col class="shrink">
                          <v-btn
                            tile
                            color="success"
                            @click="getQrCOde(BookingDataItem[0])"
                          >
                            <v-icon left>
                              mdi-qrcode-scan
                            </v-icon>
                            เปิด QR Code
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-alert>
                  </div>
                  <div class="text-center">
                    <v-btn
                      elevation="10"
                      color="green darken-1"
                      dark
                      large
                      block
                      @click="addEmpJob()"
                      >ยืนยันนัดหมาย</v-btn
                    >
                  </div>
                </template>
              </v-container>
            </v-card-text>
            <v-card-text v-if="!dataEditJobReady">
              <v-container>
                <div class="text-center">
                  <waitingAlert></waitingAlert>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogJob" persistent :max-width="dialogwidth">
          <v-card
            style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
          >
            <v-container>
              <v-row>
                <v-col cols="12" v-if="checkShowSelectUser">
                  <div class=" text-center">
                    <v-tabs
                      v-model="tabSelectUser"
                      background-color="#1B437C"
                      centered
                      dark
                      icons-and-text
                    >
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab>
                        ลูกค้าที่นัดหมาย
                        <v-icon>mdi-card-account-phone</v-icon>
                      </v-tab>

                      <v-tab>
                        แสกน QR / Skip
                        <v-icon>mdi-qrcode-edit</v-icon>
                      </v-tab>

                      <v-tab-item
                        style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
                      >
                        <br />
                        <v-row justify="center" class="spacer" no-gutters>
                          <v-col cols="4" sm="2" md="1">
                            <v-avatar size="60px">
                              <img
                                alt="Avatar"
                                :src="dataSelectUser.picture"
                              />
                            </v-avatar>
                          </v-col>
                          <v-col cols="6" sm="4" md="2"
                            >คุณ {{ dataSelectUser.name }}</v-col
                          >
                        </v-row>
                        <v-row justify="center" class="spacer" no-gutters>
                          <v-col col="12"
                            ><strong>ลูกค้าที่นัดหมาย</strong></v-col
                          >
                        </v-row>
                      </v-tab-item>
                      <v-tab-item
                        style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
                      >
                        <br />
                        <div
                          v-if="jobitem.length > 0 && userId === ''"
                          class="avatar text-center"
                        >
                          <qrcode-vue
                            :value="value"
                            :size="size"
                            level="H"
                            :foreground="foreground"
                          />
                          <v-btn
                            color="#1B437C"
                            small
                            dark
                            @click="FunCopyQrcode(value)"
                          >
                            <v-icon left>mdi-content-copy</v-icon>
                            คัดลอกลิงค์
                          </v-btn>
                          <hr />
                          <v-btn
                            small
                            dark
                            color="#14AE5C"
                            @click="printQrcodeComfirmJob(value, jobitem)"
                            ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                          >
                        </div>
                      </v-tab-item>
                    </v-tabs>
                  </div>
                </v-col>
                <v-col cols="12" v-if="!checkShowSelectUser">
                  <div class=" text-center">
                    <br />
                    <br />
                    <h2 style="font-weight: 900; color:#FFA000">
                      ติดตามสถานะ!
                    </h2>
                    <qrcode-vue
                      v-if="userId === ''"
                      :value="value"
                      :size="size"
                      level="H"
                      :foreground="foreground"
                    />
                    <v-btn
                      v-if="userId === ''"
                      color="#1B437C"
                      small
                      dark
                      @click="FunCopyQrcode(value)"
                    >
                      <v-icon left>mdi-content-copy</v-icon>
                      คัดลอกลิงค์
                    </v-btn>
                    <div v-if="userId === ''">
                      <hr />
                      <v-btn
                        small
                        dark
                        color="#14AE5C"
                        @click="printQrcodeComfirmJob(value, jobitem)"
                        ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                      >
                    </div>
                    <template v-if="jobitem.length > 0">
                      <div v-if="userId !== ''" class="avatar text-center">
                        <v-avatar
                          v-if="memberPicture !== ''"
                          size="120"
                          style="border:5px solid #FFFFFF;"
                        >
                          <img :src="memberPicture" />
                        </v-avatar>
                        <v-avatar
                          v-if="
                            memberPicture === '' &&
                              userId === 'user-skip' &&
                              jobitem[0].recordStatus === 'D'
                          "
                          size="120"
                          style="border:5px solid #FFFFFF;"
                        >
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/OtherP.svg')"
                          ></v-img>
                        </v-avatar>
                      </div>
                    </template>
                    <div v-if="jobitem.length > 0" class="avatar text-center">
                      <qrcode-vue
                        v-if="
                          userId === 'user-skip' &&
                            jobitem[0].recordStatus === 'N'
                        "
                        :value="value"
                        :size="size"
                        level="H"
                        :foreground="foreground"
                      />
                      <v-btn
                        v-if="
                          userId === 'user-skip' &&
                            jobitem[0].recordStatus === 'N'
                        "
                        color="#1B437C"
                        small
                        dark
                        @click="FunCopyQrcode(value)"
                      >
                        <v-icon left>mdi-content-copy</v-icon>
                        คัดลอกลิงค์
                      </v-btn>
                      <div
                        v-if="
                          userId === 'user-skip' &&
                            jobitem[0].recordStatus === 'N'
                        "
                      >
                        <hr />
                        <v-btn
                          small
                          dark
                          color="#14AE5C"
                          @click="printQrcodeComfirmJob(value, jobitem)"
                          ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col cols="12">
                <v-container class="text-center">
                  <v-container>
                    <div v-for="(p, index) in jobitem" :key="index">
                      <h4>{{ p.name }} : {{ p.value }}</h4>
                    </div>
                    <div v-if="jobitem.length > 0">
                      <strong
                        style="color: red;"
                        v-if="jobitem[0].recordStatus === 'D'"
                        ><h2>รายการนี้ปิดไปแล้ว</h2></strong
                      >
                    </div>
                    <div>
                      <v-btn
                        v-if="userId !== ''"
                        color="#1B437C"
                        small
                        dark
                        @click="FunCopyQrcode(value)"
                      >
                        <v-icon left>mdi-content-copy</v-icon>
                        คัดลอกลิงค์
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="success"
                        v-if="userId !== '' && recordStatusJob === 'N'"
                        @click="(dialogCloseJob = true), setCloseJob(jobitem)"
                        dark
                      >
                        ปิดงานนี้
                        <v-icon dark right>
                          mdi-cash-usd-outline
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-container>
                  <template v-if="!checkShowSelectUser">
                    <v-btn
                      small
                      class="ma-2"
                      color="success"
                      v-if="userId === ''"
                      @click="pushMsgSelectUser"
                      dark
                    >
                      ส่ง QR Code
                      <v-icon dark right>
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-2"
                      color="primary"
                      v-if="userId === ''"
                      @click="jobConfirm"
                      dark
                    >
                      SKIP
                      <v-icon dark right>
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-2"
                      color="error"
                      @click="dialogJob = false"
                      dark
                    >
                      Close
                      <v-icon dark right>
                        mdi-minus-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-if="checkShowSelectUser">
                    <v-btn
                      small
                      class="ma-2"
                      color="success"
                      v-if="userId === '' && tabSelectUser === 1"
                      @click="pushMsgSelectUser"
                      dark
                    >
                      ส่ง QR Code
                      <v-icon dark right>
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-2"
                      color="primary"
                      v-if="userId === '' && tabSelectUser === 1"
                      @click="jobConfirm"
                      dark
                    >
                      SKIP
                      <v-icon dark right>
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-2"
                      color="primary"
                      v-if="tabSelectUser === 0 || tabSelectUser === null"
                      @click="jobConfirmUser"
                      dark
                    >
                      ลูกค้าท่านเดียวกับที่นัดหมาย
                      <v-icon dark right>
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-2"
                      color="error"
                      @click="dialogJob = false"
                      dark
                    >
                      Close
                      <v-icon dark right>
                        mdi-minus-circle
                      </v-icon>
                    </v-btn>
                  </template>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import draggable from 'vuedraggable'
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import DateRangePicker from 'vue2-daterange-picker'
// you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import { PivotTable } from '@click2buy/vue-pivot-table'
import moment from 'moment-timezone'
import 'moment/locale/th'
import BookingQueue from './BookingQueue.vue'
// import CalendarBooking from './CalendarBookingList.vue'
import CalendarBooking from './CalendarBookingList.vue' // test
import waitingAlert from '../waitingAlert.vue'
import CallLog from '../BookingListComponents/CallLog.vue'
import NotificationService from '../BookingListComponents/NotificationService.vue'
import PrintQrCodeConfirmJobLINE from '../BookingListComponents/PrintQrCodeConfirmJobLINE.vue'
import sideMenu from '../Menu/sideMenu.vue'
import GoogleCalendarCmp from '../Core/GoogleCalendarCmp.vue'
import PdfAirMate from '../PdfForm/PdfAirMate.vue'
import ModelBookingList from '../DialogModels/ModelBookingList.vue'
import QrcodeVue from 'qrcode.vue'

// import copy from 'copy-to-clipboard'

export default {
  name: 'BookingListBeauty',
  components: {
    sideMenu,
    draggable,
    'left-menu-admin': adminLeftMenu,
    DateRangePicker,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    VuetifyMoney,
    // PivotTable,
    BookingQueue,
    CalendarBooking,
    waitingAlert,
    CallLog,
    NotificationService,
    PrintQrCodeConfirmJobLINE,
    GoogleCalendarCmp,
    PdfAirMate,
    ModelBookingList,
    QrcodeVue
  },
  computed: {
    filteredSelect () {
      // console.log('tset')
      return this.dataItemSelect.filter(d => {
        return (
          this.filters.length < 1 ||
          d['dueDate']
            .toString()
            .toLowerCase()
            .includes(this.filters.toLowerCase())
        )
      })
    },
    ColsDialogAdd () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'False'
        case 'sm':
          return 'False'
        case 'md':
          return 'False'
        case 'lg':
          return 'True'
        case 'xl':
          return 'True'
      }
    },
    dialogwidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '70%'
        case 'sm':
          return '60%'
        case 'md':
          return '50%'
        case 'lg':
          return '50%'
        case 'xl':
          return '50%'
      }
    },
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'xs'
        case 'sm':
          return 'sm'
        case 'md':
          return 'md'
        case 'lg':
          return 'lg'
        case 'xl':
          return 'xl'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  watch: {
    '$route.query.bookNoNoti' (newVal, oldVal) {
      if (newVal !== '') {
        if (
          this.$route.query.customerName &&
          this.$route.query.dueDate &&
          this.$route.query.masBranchID
        ) {
          this.searchAll2 = this.$route.query.customerName
          this.dateStart = this.$route.query.dueDate
          this.masBranchID = parseInt(this.$route.query.masBranchID)
          this.checkShowDataOnsite()
        }
      }
    },
    pickerDate (newval, oldval) {
      this.getMonth(newval)
      // this.allowedDates()
      // here you can check if month changed using newval and oldval
    },
    pickerDateChang (newval, oldval) {
      // console.log('newval', newval)
      this.getMonthChang(newval)
      // this.allowedDates()
      // here you can check if month changed using newval and oldval
    }
  },
  data () {
    let startDate = null
    let endDate = null
    return {
      dialogJob: false,
      dialogOnsite: false,
      unsubscribe: null,
      // menu
      bookNoNoti: '',
      showMenu: 'False',
      dataMenuAdd: [],
      expansionMenuAdd: [0],
      drawerAdd: false,
      priceMenuAdd: 0,
      languageSelect: 0,
      // ******
      menuShowMenuReport: false,
      dataShowMenuReport: [],
      dateStartShowMenuReport: '',
      searchShowMenuReport: null,
      dataMenuShowMenuReport: [],
      BookingDataListShowMenuReport: [],
      DataFlowNameMenu: [],
      flowSelectMenu: '',
      sortSelect: null,
      expandedMenu: [],
      formResults: [],
      headersShowMenuReport: [
        {
          text: 'สถานะ',
          groupable: false,
          value: 'statusBt'
        },
        // { text: 'ชื่อลูกค้า', value: 'cusName', sortable: false, groupable: false }
        {
          text: 'วันที่/เวลา',
          value: 'dueDate',
          sortable: false,
          groupable: false
        },
        {
          text: 'บริการ',
          value: 'flowName',
          sortable: false,
          groupable: false
        },
        { text: 'ราคา', value: 'menuPrice', sortable: false, groupable: false }
        // { text: 'เบอร์โทร', value: 'tel', sortable: false, groupable: false }
      ],

      customerNameJob: '',
      timelineitem: [],
      codeColor: [
        'rgb(142, 202, 230)',
        'rgb(33, 158, 188)',
        'rgb(2, 48, 71)',
        'rgb(241, 91, 76)',
        'rgb(255, 183, 3)',
        'rgb(251, 133, 0)',
        'rgb(61,90,128)',
        'rgb(152,193,217)',
        'rgb(224,251,252)',
        'rgb(255,212,91)',
        'rgb(238,108,77)',
        'rgb(41,50,65)'
      ],
      showOnsite: 'ไม่แสดง',
      selectOnsite: '',
      menuAdd1: false,
      menuAdd2: false,
      menuAdd3: false,
      menuEdit1: false,
      menuEdit2: false,
      menuEdit3: false,

      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],

      monthNamesThai: [
        '',
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
      ],
      eventInfo: [],
      checkEventInfo: [],
      dueDateText: '',
      sortNo: '',
      dataCalendar: [],
      dataSummary: [],
      today: '',
      events: [],

      srcUpload: '',
      pickerDate: null,
      pickerDateChang: null,
      currentDate: moment().format('YYYY-MM-DD'),
      currentMonth: moment().format('YYYY-MM'),
      headersLimitBookingDate: [
        {
          text: 'เวลา',
          align: 'center',
          sortable: true,
          value: 'bookingTime'
        },
        {
          text: 'จำนวน Limit ปัจจุบัน / จำนวน Limit ที่ตั้งไว้',
          value: 'countBookingLimit',
          align: 'center'
        }
      ],
      dataLimitBookingDate: [],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 2
      },
      options1: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 1,
        precision: 0
      },
      recordStatusJob: '',
      checkPayment: 'True',
      formCloseJob: {
        jobId: '',
        jobNo: '',
        totalPrice: 0
      },
      loadingCloseJob: false,
      modelPackageIndexConfirm: null,
      modelPackageIndexConfirmJob: null,
      dataPackageDefault: false,
      jobCheckPackage: false,
      dateTimestamp: '',
      packageId: '',
      tokenPackage: '',
      dataPackage: [],
      StatusPackage: {
        status: 'ตกลง',
        color: 'green',
        packageName: '',
        token: ''
      },
      dataFlowSelectAdd: [],
      dataFlowSelectEdit: [],
      checkSelectText: '',
      pictureUrHistory: '',
      tagName: '',
      tagItem: [],
      tagData: [],
      panelDeposit: [],
      dataDepositAdd: 'ไม่มี',
      pictureUrlPreviewDeposit: null,
      pictureUrlDeposit: null,
      filesDeposit: null,
      filesDepositAdd: null,
      valid_deposit: true,
      statusDeposit: false,
      flowSelect: '',
      dueDate: '',
      statusConfirmJob: false,
      filters: '',
      loadingTag: false,
      loadingDeposit: false,
      loadingEdit: false,
      loadingAdd: false,
      loadingRefresh: false,
      menuDateSearch: false,
      timeTable: '',
      drawer: false,
      value: '',
      size: 200,
      foreground: '#173053',
      userId: '',
      skip: {
        userId: 'user-skip'
      },
      pathToweb: '',
      changeBackgroundColor: true,
      countWaiting: 0,
      countConfirm: 0,
      countCancel: 0,
      countJob: 0,
      countAll: 0,
      export_fields: {
        'Booking Id': 'bookNo',
        สาขา: 'masBranchName',
        ชื่อลูกค้า: 'cusName',
        ทะเบียนรถ: 'cusReg',
        วันและเวลานัดหมาย: 'dueDate',
        ชื่อบริการ: 'flowName',
        'สถานะ ติดต่อ': 'statusBt',
        'วันที่ ติดต่อ': 'contactDateBt',
        // 'วันที่ แจ้งเปลี่ยน': 'changDateBt',
        สถานะนำเข้ากระดาน: 'statusUseBt',
        'วันที่ สร้าง': 'CREATE_DATE',
        'วันที่ แก้ไขล่าสุด': 'LAST_DATE'
      },
      exportType: 'xls',
      exportFileName:
        'BookingList' +
        new Date()
          .toISOString()
          .substr(0, 10)
          .replace('/-/g', '') +
        '.xls',
      exportWorksheet: 'WorkSheet',
      export_data: [],
      dateRange: { startDate, endDate },
      localeData: {
        // direction: 'ltr',
        format: 'yyyy-mm-dd',
        // separator: ' - ',
        applyLabel: 'ยืนยัน',
        cancelLabel: 'ยกเลิก',
        // weekLabel: 'W',
        // customRangeLabel: 'Custom Range',
        // daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysOfWeek: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        monthNames: [
          'ม.ค',
          'ก.พ',
          'มี.ค',
          'เม.ย',
          'พ.ค',
          'มิ.ย',
          'ก.ค',
          'ส.ค',
          'ก.ย',
          'ต.ค',
          'พ.ย',
          'ธ.ค'
        ],
        // monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 1
      },
      masterTime: [
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00'
      ],
      masBranchID: '',
      masBranchIDExport: '',
      bookNo: '',
      BookingDataItem: [],
      Layout: [],
      dataItemTime: [],
      dataItemTimesChange: [],
      appendBody: true,
      dataEditReady: true,
      dataConfirmReady: true,
      dataCancelReady: true,
      dataReady: false,
      menuDate: false,
      menuDateEdit: false,
      menuDateChange: false,
      menuDataBokkAgain: false,
      date: '',
      time: '',
      empSelectAdd: '',
      dateEdit: '',
      timeEdit: '',
      empSelectEdit: '',
      session: this.$session.getAll(),
      fieldNameItem: [],
      flowfieldNameitem: [],
      sort: null,
      DataflowId: '',
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ตรวจสอบรายการนัดหมาย',
          disabled: false,
          href: '/Master/BookingJob'
        }
      ],
      branch: [],
      DataFlowName: [],
      // Data Table Config
      searchAll2: '',
      columns: [
        { text: 'หมายเลข', value: 'receiptNo' },
        { text: 'ลูกค้า', value: 'cusName' },
        { text: 'บริการ', value: 'flowName' },
        { text: 'รายการ', value: 'flowList' },
        { text: 'วันที่จองงาน', value: 'dateApp' },
        { text: 'ที่อยู่', value: 'address' },
        { text: 'ผู้ให้บริการ', value: 'empName' },
        {
          text: 'สถานะ',
          value: 'actionStatus',
          sortable: true,
          align: 'center'
        },
        { text: 'สังกัด', value: 'member' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' }
      ],
      columnsSelected: [],
      dataItem: [],
      dataItemCheck: [],
      dataexport: [],
      dataItemSelect: [],
      editedItemSeleteField: [],
      jobitem: [],
      itemsSort: [
        'เรียงตามวันที่นัดหมาย',
        'เรียงตามวันที่เปลี่ยนสถานะ',
        'เรียงตามวันที่สร้าง'
      ],
      itemsSortWaiting: ['เรียงตามวันที่นัดหมาย', 'เรียงตามวันที่สร้าง'],
      // End Data Table Config
      formAdd: {
        bookingId: null,
        fieldId: '',
        fieldValue: '',
        flowId: null,
        masBranchID: null,
        dueDate: '',
        shopId: this.$session.getAll().data.shopId,
        bookingFieldId: '',
        radiosRemark: '',
        depositStatus: '',
        depositImge: '',
        pictureUrlPreviewDeposit: '',
        depositPrice: 0
      },
      formEdit: {
        bookingId: null,
        fieldId: '',
        fieldValue: '',
        flowId: null,
        masBranchID: null,
        dueDate: '',
        shopId: this.$session.getAll().data.shopId,
        bookingFieldId: '',
        radiosRemark: ''
      },
      formUpdate: {
        masBranchCode: '',
        masBranchName: '',
        tel: '',
        map: '',
        shopId: '',
        bookNo: ''
      },
      formChange: {
        date: '',
        time: ''
      },
      dataChange: {},
      validUpdate: true,
      validAdd: true,
      validEdit: true,
      validRemove: true,
      validChange: true,
      validExport: true,
      validBookingAgain: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      menuReturn: false,
      menu: false,
      menu1: false,
      menuStart: false,
      dateStart: new Date().toISOString().substr(0, 7),
      endDate: '',
      endTime: '',
      memberPicture: '',
      memberName: '',
      dataInfo: null,
      detailInfo: null,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      getSelectText: '',
      getSelectCount: 0,
      selectedStatus: false,
      swalConfig: {
        title: null,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      },
      BookingDataList: [],
      BookingDataListTimechange: [],
      remarkRemove: '',
      bookNoRemove: '',
      timeavailable: [],
      empSelectStep: [],
      empSelectStepAdd: [],
      dataConfirm: [],
      empSelect: '',
      dataRemoveExport: [],
      dataexportRemove: [],
      BookingDataItemEdit: [],
      dataQrcode: [],
      bookNoRemark: '',
      remark: '',
      remarkReturn: '',
      dateReturn: '',
      showMap: '',
      setTimer: null,
      setTimerCalendar: null,
      searchOther: '',
      showColorSearch: false,
      dataEditJobReady: true,
      dataChangeReady: true,
      statusSearch: 'no',
      // window_open: true,
      center: null,
      address: '',
      empSelectJob: '',
      textError: '',
      dataReadyAdd: true,
      checkShowSelectUser: false,
      tabSelectUser: null,
      dataSelectUser: {},
      dataTypeJob1: '',
      dataTypeJob2: '',
      dataTypeJob3: '',
      dataTypeProcess1: '',
      dataTypeProcess2: '',
      dataTypeProcess3: '',
      dataTypeProcess4: '',
      checkDepositAdd: '',
      defaultData: [],
      phonenumItem: [],
      HistoryData: [],
      phonenum: [],
      lineUserId: '',
      booking: [],
      bookingData: [],
      loadingBookingAgain: false,
      limitBookingCheck: 'False',
      limitBookingSelect: 'False',
      limitCountBranch: 0,
      limitCountBranchOld: 0,
      countBookingLimit: 0,
      selectCountBookingLimit: 1,
      dueDateOld: '',
      dueDateTimeOld: '',
      masBranchIDLimit: '',
      flowIDLimit: '',
      dateDayoff: [],
      dateDayCustom: [],
      dateDaylimit: null,
      flowItemLimit: [],
      checkLimitBooking: {
        ID: '',
        countBooking: null,
        limitCheck: null,
        limitBooking: 0
      },
      dataEdit: '',
      statusShowDateConfiremjob: true,
      memberId: '',
      flowIdOldEdit: '',
      masBranchIDOldEdit: '',
      Redirect: '',
      depositLink: '',
      datailLinkDeposit: '',
      depositPrice: 0,
      statusdepositPrice: false,
      statusBranchReadonly: false,
      dataEmpOnsite: [],
      statusShowMap: '',
      listFilterCloseJob: ['ทั้งหมด', 'ยังไม่ปิดงาน', 'ปิดงาน'],
      filterCloseJobValue: 'ทั้งหมด',
      dataGetJob: [],
      dataCoin: [],
      productExchangeRateId: '',
      memberTel: '',
      dataLineConfig: {},
      priceMenu: null,
      dataMenu: [],
      expansionMenu: [0],
      dialogMenu: false,
      depositTextTH: '',
      statusVIP: 'False',
      statusVIPEdit: 'False',
      statusVIPChang: 'False',
      statusVIPRemove: 'False',
      masBranchIDAddJob: '',
      statusPushEndStep: 'False',
      endStepItem: [],
      ItemendStepStanby: [],
      DataFlowNameDefault: [],
      statusGoogleCalendar: '',
      statusGoogleCalendarEmp: '',
      copyTextBtTH: '',
      copyTextBtEN: '',
      copyTextStatus: false,
      showImgItem: [],
      showImg: '',
      dataCloseJob: [],
      dataCloseJobData: [],
      sendRemarkRemove: false,
      dataToday: [],
      dailyItems: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      if (this.$route.query.bookNo) {
        this.$router.push(
          '/Core/Login?bookNo=' +
          this.$route.query.bookNo +
          '&shopId=' +
          this.$route.query.shopId +
          '&type=' +
          this.$route.query.type
        )
      } else {
        this.$router.push('/Core/Login')
      }
    }
  },
  async mounted () {
    await this.getShop()
    this.dataLineConfig = await this.getDataLineConfig(
      this.$session.getAll().data.shopId
    )
    this.Redirect =
      'https://liff.line.me/' +
      this.dataLineConfig.liffMainID +
      '/BookingAddress?shopId=' +
      this.$session.getAll().data.shopId
    this.pathToweb =
      'https://liff.line.me/' +
      this.dataLineConfig.liffMainID +
      '/JobConfirm?jobId='
    if (
      this.$route.query.customerName &&
      this.$route.query.dueDate &&
      this.$route.query.masBranchID
    ) {
      this.searchAll2 = this.$route.query.customerName
      this.dateStart = this.$route.query.dueDate
      this.masBranchID = parseInt(this.$route.query.masBranchID)
      this.checkShowDataOnsite()
    } else {
      this.checkShowDataOnsite('ไม่แสดง')
    }
    this.$root.$on('dataReturn', item => {
      this.dataReturn(item)
    })
    this.$root.$on('closeSetTimeGetCalenda', () => {
      // your code goes here
      this.closeSetTimeGetCalenda()
    })
    // await this.beforeCreate()
  },
  created () {
    // this.getFirestore()
  },
  beforeDestroy () {
    this.$root.$off('dataReturn')
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  methods: {
    getRowClass (item) {
      if (this.$route.query.bookNoNoti) {
        return item.bookNo === this.$route.query.bookNoNoti
          ? 'orange lighten-5'
          : ''
      } else {
        return ''
      }
    },
    async getShop () {
      await axios
        .get(this.$DNS_IP + '/sys_shop/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          console.log('rssssssssssss', rs)
          if (rs.length > 0) {
            this.shop = rs
            this.statusGoogleCalendar = rs[0].statusGoogleCalendar
            this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
          }
        })
    },
    checkTypeSort () {
      console.log('this.sortSelect => ' + this.sortSelect)
      console.log('this.sort => ' + this.sort)
      console.log('this.dataItemSelect', this.dataItemSelect)
      if (this.sortSelect && this.sort) {
        if (this.sortSelect === 'เรียงตามวันที่นัดหมาย') {
          console.log('เรียงตามวันที่นัดหมาย')
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(b.dueDate) - new Date(a.dueDate)
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(a.dueDate) - new Date(b.dueDate)
            })
          }
        } else if (this.sortSelect === 'เรียงตามวันที่เปลี่ยนสถานะ') {
          console.log('เรียงตามวันที่เปลี่ยนสถานะ')
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return (
                new Date(b.CREATE_DATE_Status) - new Date(a.CREATE_DATE_Status)
              )
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return (
                new Date(a.CREATE_DATE_Status) - new Date(b.CREATE_DATE_Status)
              )
            })
          }
        } else if (this.sortSelect === 'เรียงตามวันที่สร้าง') {
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(b.CREATE_DATE) - new Date(a.CREATE_DATE)
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(a.CREATE_DATE) - new Date(b.CREATE_DATE)
            })
          }
        }
      }
      // console.log('this.dataItemSelect', this.dataItemSelect)
    },
    async dataReturn (item) {
      console.log('dataReturn', item)
      if (this.statusSearch === 'no') {
        await this.getBookingList()
      } else {
        await this.searchAny()
      }
      // this.getTimesChange('update')
      if (this.getSelectText) {
        this.getSelect(
          this.getSelectText,
          this.getSelectCount,
          this.filterCloseJobValue
        )
      }
    },
    async getShowOnsite () {
      // let LimitBooking = this.$session.getAll().data.showOnsite
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
          '/system_user/auth?userName=' +
          this.$session.getAll().data.userName +
          '&userPassword=' +
          this.$session.getAll().data.userPassword
        )
        .then(async response => {
          let rs = response.data[0].showOnsite
          return rs
        })
        .catch(error => {
          console.log('error function addData : ', error)
          return 'ไม่แสดง'
        })
      return LimitBooking || 'ไม่แสดง'
      // return this.$session.getAll().data.showOnsite || 'ไม่แสดง'
    },
    async updateShowOnsite (text) {
      await axios
        .post(
          this.$DNS_IP +
          '/system_user/edit/' +
          this.$session.getAll().data.userId,
          { showOnsite: text }
        )
        .then(async response => { })
    },
    async checkShowDataOnsiteSet (text) {
      if (text === 'ไม่แสดง') {
        // this.showOnsite = 'แสดง'
        // this.selectOnsite = '&checkOnsite=is null'
        await this.updateShowOnsite('ไม่แสดง')
        this.checkShowDataOnsite()
      } else {
        // this.showOnsite = 'ไม่แสดง'
        // this.selectOnsite = '&checkOnsite=True'
        await this.updateShowOnsite('แสดง')
        this.checkShowDataOnsite()
      }
    },
    async checkShowDataOnsite () {
      this.dataReady = false
      let text = await this.getShowOnsite()
      if (text === 'ไม่แสดง') {
        this.showOnsite = 'แสดง'
        this.selectOnsite = '&checkOnsite=is null'
        // this.updateShowOnsite('ไม่แสดง')
      } else {
        this.showOnsite = 'ไม่แสดง'
        this.selectOnsite = '&checkOnsite=True'
        // this.updateShowOnsite('แสดง')
      }
      if (this.$route.query.bookNo) {
        // this.beforeCreateScan()
        await this.getDataBranch()
        await this.getEmpSelectAdd()
        await this.getBookingFieldText()
        this.getCustomFieldStart()
        await this.getDataFlow()
        await this.scanQrcode()
        // this.getBookingList()
      } else {
        await this.getDataBranch()
        await this.getEmpSelectAdd()
        await this.getBookingFieldText()
        this.getCustomFieldStart()
        await this.getDataFlow()
        this.getBookingList()
      }
    },
    async getMonth (month) {
      console.log('month', month)
      // console.log('!!!!!!!!!', this.DataFlowNameDefault.filter(el => { return el.value === parseInt(this.formAdd.flowId) })[0].allData.setTimebyday)
      // const result = await axios.get(this.$DNS_IP + '/LimitBookingDate/get_LimitDate?shopId=' + this.$session.getAll().data.shopId + '&masBranchID=' + this.formAdd.masBranchID + '&bookingDate=' + month)
      const result = await axios.get(
        this.$DNS_IP +
        '/LimitBookingDate/get_LimitDate?shopId=' +
        this.$session.getAll().data.shopId +
        '&flowId=' +
        this.formAdd.flowId +
        '&bookingDate=' +
        month
      )
      if (result.data.length > 0) {
        let setTimebyday = this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formAdd.flowId)
        })[0].allData.setTimebyday
        console.log('getMonth IF', result.data)
        this.dateDaylimit = []
        // let dt = result.data
        const objectDT = result.data.reduce((acc, curr) => {
          const bookingDate = curr.bookingDate
          if (!acc[bookingDate]) {
            acc[bookingDate] = []
          }
          acc[bookingDate].push(curr)
          return acc
        }, {})

        console.log(objectDT)
        for (const dt in objectDT) {
          let statusOffDate1 = false
          // console.log(dt, objectDT[dt])
          if (objectDT[dt][0].limitBookingCheck === 'True') {
            // console.log('limitBookingCheck === True')
            objectDT[dt].forEach((v, k) => {
              // let statusOffDate2 = false
              // let statusOffDate3 = false
              if (JSON.parse(v.setTime)) {
                if (setTimebyday === 'True') {
                  // console.log('sdfsdfsdfds', JSON.parse(v.setTime).filter((items) => items.value === new Date(v.bookingDate).getDay())[0].setTime)
                  JSON.parse(v.setTime)
                    .filter(
                      items => items.value === new Date(v.bookingDate).getDay()
                    )[0]
                    .setTime.forEach((v2, k2) => {
                      // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                      if (
                        parseInt(v2.limitBooking) > 0 &&
                        v.bookingTime === v2.value
                      ) {
                        console.log(
                          v.bookingDate,
                          '----',
                          'v',
                          v.bookingTime,
                          ' ',
                          v.countBooking,
                          '    ',
                          'v2',
                          v2.value,
                          ' ',
                          v2.limitBooking
                        )
                        if (v.bookingTime === v2.value) {
                          if (v.countBooking < parseInt(v2.limitBooking)) {
                            statusOffDate1 = true
                            // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                          }
                        }
                      } else if (parseInt(v2.limitBooking) > 0) {
                        if (
                          objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                            .length === 0
                        ) {
                          console.log(v.bookingDate, '+++++', v2.value)
                          statusOffDate1 = true
                        }
                      }
                    })
                } else {
                  JSON.parse(v.setTime).forEach((v2, k2) => {
                    if (
                      parseInt(v2.limitBooking) > 0 &&
                      v.bookingTime === v2.value
                    ) {
                      console.log(
                        v.bookingDate,
                        '----',
                        'v',
                        v.bookingTime,
                        ' ',
                        v.countBooking,
                        '    ',
                        'v2',
                        v2.value,
                        ' ',
                        v2.limitBooking
                      )
                      if (v.bookingTime === v2.value) {
                        if (v.countBooking < parseInt(v2.limitBooking)) {
                          statusOffDate1 = true
                          // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                        }
                      }
                    } else if (parseInt(v2.limitBooking) > 0) {
                      if (
                        objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                          .length === 0
                      ) {
                        console.log(v.bookingDate, '+++++', v2.value)
                        statusOffDate1 = true
                      }
                    }
                  })
                }
              }
            })
            console.log('---------!!!!1--------', dt, '----', statusOffDate1)
            if (statusOffDate1 === false) {
              console.log('---------OFF--------', objectDT[dt])
              this.dateDaylimit.push(
                moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
              )
            }
          } else {
            // console.log('limitBookingCheck === False')
            this.dateDaylimit = []
          }
          // if (statusOffDate1 === false) {
          //   this.dateDaylimit.push(
          //     moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
          //   )
          // }
          console.log('this.dateDaylimit', this.dateDaylimit)
          // this.dateDaylimit = result.data.map((item) => { return this.momenDate_1(item.bookingDate) })
        }
      } else {
        console.log('getMonth ELSE')
        this.dateDaylimit = []
      }
    },
    async getMonthChang (month) {
      console.log('month', month)
      console.log('flowId', this.flowIDLimit)
      console.log('this.DataFlowNameDefault', this.DataFlowNameDefault)
      // console.log('!!!!!!!!!', this.DataFlowNameDefault.filter(el => { return el.value === parseInt(this.formAdd.flowId) })[0].allData.setTimebyday)
      // const result = await axios.get(this.$DNS_IP + '/LimitBookingDate/get_LimitDate?shopId=' + this.$session.getAll().data.shopId + '&masBranchID=' + this.formAdd.masBranchID + '&bookingDate=' + month)
      const result = await axios.get(
        this.$DNS_IP +
        '/LimitBookingDate/get_LimitDate?shopId=' +
        this.$session.getAll().data.shopId +
        '&flowId=' +
        this.flowIDLimit +
        '&bookingDate=' +
        month
      )
      if (result.data.length > 0) {
        let setTimebyday = this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        })[0].allData.setTimebyday
        console.log('getMonth IF', result.data)
        this.dateDaylimit = []
        // let dt = result.data
        const objectDT = result.data.reduce((acc, curr) => {
          const bookingDate = curr.bookingDate
          if (!acc[bookingDate]) {
            acc[bookingDate] = []
          }
          acc[bookingDate].push(curr)
          return acc
        }, {})

        console.log(objectDT)
        for (const dt in objectDT) {
          let statusOffDate1 = false
          // console.log(dt, objectDT[dt])
          if (objectDT[dt][0].limitBookingCheck === 'True') {
            // console.log('limitBookingCheck === True')
            objectDT[dt].forEach((v, k) => {
              // let statusOffDate2 = false
              // let statusOffDate3 = false
              if (JSON.parse(v.setTime)) {
                if (setTimebyday === 'True') {
                  // console.log('sdfsdfsdfds', JSON.parse(v.setTime).filter((items) => items.value === new Date(v.bookingDate).getDay())[0].setTime)
                  JSON.parse(v.setTime)
                    .filter(
                      items => items.value === new Date(v.bookingDate).getDay()
                    )[0]
                    .setTime.forEach((v2, k2) => {
                      // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                      if (
                        parseInt(v2.limitBooking) > 0 &&
                        v.bookingTime === v2.value
                      ) {
                        console.log(
                          v.bookingDate,
                          '----',
                          'v',
                          v.bookingTime,
                          ' ',
                          v.countBooking,
                          '    ',
                          'v2',
                          v2.value,
                          ' ',
                          v2.limitBooking
                        )
                        if (v.bookingTime === v2.value) {
                          if (v.countBooking < parseInt(v2.limitBooking)) {
                            statusOffDate1 = true
                            // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                          }
                        }
                      } else if (parseInt(v2.limitBooking) > 0) {
                        if (
                          objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                            .length === 0
                        ) {
                          console.log(v.bookingDate, '+++++', v2.value)
                          statusOffDate1 = true
                        }
                      }
                    })
                } else {
                  JSON.parse(v.setTime).forEach((v2, k2) => {
                    if (
                      parseInt(v2.limitBooking) > 0 &&
                      v.bookingTime === v2.value
                    ) {
                      console.log(
                        v.bookingDate,
                        '----',
                        'v',
                        v.bookingTime,
                        ' ',
                        v.countBooking,
                        '    ',
                        'v2',
                        v2.value,
                        ' ',
                        v2.limitBooking
                      )
                      if (v.bookingTime === v2.value) {
                        if (v.countBooking < parseInt(v2.limitBooking)) {
                          statusOffDate1 = true
                          // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                        }
                      }
                    } else if (parseInt(v2.limitBooking) > 0) {
                      if (
                        objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                          .length === 0
                      ) {
                        console.log(v.bookingDate, '+++++', v2.value)
                        statusOffDate1 = true
                      }
                    }
                  })
                }
              }
            })
            console.log('---------!!!!1--------', dt, '----', statusOffDate1)
            if (statusOffDate1 === false) {
              console.log('---------OFF--------', objectDT[dt])
              this.dateDaylimit.push(
                moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
              )
            }
          } else {
            // console.log('limitBookingCheck === False')
            this.dateDaylimit = []
          }
          // if (statusOffDate1 === false) {
          //   this.dateDaylimit.push(
          //     moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
          //   )
          // }
          console.log('this.dateDaylimit', this.dateDaylimit)
          // this.dateDaylimit = result.data.map((item) => { return this.momenDate_1(item.bookingDate) })
        }
      } else {
        console.log('getMonth ELSE')
        this.dateDaylimit = []
      }
    },
    async openHistory (item) {
      console.log('item', item)
      this.pictureUrHistory = item.memberPicture
      this.memberName = item.memberName
      const BookingData = await axios
        .get(
          this.$DNS_IP +
          '/BookingData/get_history?shopId=' +
          this.$session.getAll().data.shopId +
          '&userId=' +
          item.userId
        )
        .then(async response => {
          return response.data
        })
        .catch(error => {
          console.log('error function addData : ', error)
          return null
        })
      await this.ConvertHistoryData(BookingData)
    },
    async getTagData () {
      this.tagItem = await this.getDataFromAPI(
        '/Mas_Tag/get',
        'tagId',
        'tagName',
        ''
      )
    },
    async getBookingFieldText () {
      if (JSON.parse(localStorage.getItem('typeData')) === null) {
        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response => {
            let rs = response.data
            console.log('rs', rs)
            if (rs.status === false) {
              this.$swal(
                'ผิดพลาด',
                'เนื่องจากไม่สามารถเรียกชื่อกระบวนการ และประเภทงานได้',
                'success'
              )
            } else {
              localStorage.setItem('typeData', JSON.stringify(rs[0]))
              this.dataTypeJob1 =
                JSON.parse(localStorage.getItem('typeData')).typeJob1 || ''
              this.dataTypeJob2 =
                JSON.parse(localStorage.getItem('typeData')).typeJob2 || ''
              this.dataTypeJob3 =
                JSON.parse(localStorage.getItem('typeData')).typeJob3 || ''
              this.dataTypeProcess1 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess1 || ''
              this.dataTypeProcess2 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess2 || ''
              this.dataTypeProcess3 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess3 || ''
              this.dataTypeProcess4 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess4 || ''
            }
          })
      } else {
        this.dataTypeJob1 =
          JSON.parse(localStorage.getItem('typeData')).typeJob1 || ''
        this.dataTypeJob2 =
          JSON.parse(localStorage.getItem('typeData')).typeJob2 || ''
        this.dataTypeJob3 =
          JSON.parse(localStorage.getItem('typeData')).typeJob3 || ''
        this.dataTypeProcess1 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess1 || ''
        this.dataTypeProcess2 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess2 || ''
        this.dataTypeProcess3 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess3 || ''
        this.dataTypeProcess4 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess4 || ''
      }
    },
    closeSetTimeGetCalenda () {
      clearInterval(this.setTimerCalendar)
      this.setTimerCalendar = null
    },
    gotoMap () {
      window.open(
        'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=' +
        this.center.lat +
        ',' +
        this.center.lng,
        '_blank'
      )
      // window.location.href = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=' + this.center.lat + ',' + this.center.lng
    },
    async searchAny () {
      if (this.searchOther.trim().length > 1) {
        // this.dataReady = false
        this.selectedStatus = true
        // this.getSelectText = ''
        this.dataItem = []
        this.countWaiting = 0
        this.countConfirm = 0
        this.countCancel = 0
        this.countJob = 0
        this.countAll = 0
        // Clear ช่องค้นหา
        this.searchAll2 = ''
        // this.dataItemSelect = []
        var dataItemTimes = []
        var dataItems = []
        // let categoryUser = ''
        // if (
        //   this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
        //   this.$session.getAll().data.category === '7'
        // ) {
        //   categoryUser = 'ธุรกิจรถยนต์'
        // } else {
        //   categoryUser = this.$session.getAll().data.category
        // }
        // await this.getBookingDataList('no', this.searchOther)
        console.log('this.searchOther =>', this.searchOther)
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
            '/formpdf/getview?shopId=' +
            this.session.data.shopId +
            '&masBranchID=' +
            this.masBranchID +
            '&bookingDataCustomerName=' +
            this.searchOther
          )
          .then(async response => {
            console.log('getData', response.data.data.length)
            // console.log('dataItems', dataItems)
            if (response.data.data.length > 0) {
              for (let i = 0; i < response.data.data.length; i++) {
                let d = response.data.data[i]
                let s = {}
                if (
                  dataItems.filter(el => {
                    return el.bookNo === d.bookNo
                  }).length === 0
                ) {
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  let checkDeposit = this.DataFlowNameDefault.filter(el => {
                    return el.value === parseInt(d.flowId)
                  })
                  if (checkDeposit.length > 0) {
                    s.depositCheckStatus =
                      checkDeposit[0].allData.checkDeposit || 'False'
                  } else {
                    s.depositCheckStatus = 'False'
                  }
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate || ''
                  if (d.timeText === null || d.timeText === '') {
                    d.timeText = d.timeDue
                  }
                  if (s.dueDate === '') {
                    s.dueDateText = 'ไม่มีเวลานัดหมาย'
                  } else {
                    s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
                  }
                  s.shopId = d.shopId
                  if (d.CustomField === '') {
                    s.CustomFieldName = ''
                    s.CustomFieldTel = ''
                  } else {
                    s.allNameandTel = {}
                    d.CustomField.split(',').forEach(item => {
                      const [key, value] = item.split(':')
                      s.allNameandTel[key.trim()] = value.trim()
                    })
                    s.CustomFieldName = s.allNameandTel['ชื่อ']
                    s.CustomFieldTel = s.allNameandTel['เบอร์โทร']
                  }
                  s.empFirstNameTH_admin = d.empFirstNameTH_admin || ''
                  s.empFirstNameTH_mechanic = d.empFirstNameTH_mechanic || ''
                  s.receiptNo = d.receiptNo
                  s.LAST_DATE = this.convertDate(d.dueDate)
                  s.checkStatus = this.checkStatus(d.stepTitle, d.status, d.jobNo)
                  s.actionPrint = s.checkStatus
                  // console.log('checkStatus', s.checkStatus)
                  s.afterAir = d.afterAir
                  s.beforeAir = d.beforeAir
                  s.checkBox1 = d.checkBox1
                  s.checkBox2 = d.checkBox2
                  s.remarkCheckbox1 = d.remarkCheckbox1
                  s.remarkCheckbox2 = d.remarkCheckbox2
                  s.remarkDetail = d.remarkDetail
                  s.redio1 = d.redio1
                  s.dueDateDay = d.dueDateDay
                  s.statusVIP = d.statusVIP
                  s.checkDateConfirmJob = d.checkDateConfirmJob
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.depositTextTH = d.depositTextTH
                  s.CREATE_DATE_Status = d.CREATE_DATE_Status
                  s.CREATE_DATE = this.convertDate(d.CREATE_DATE)
                  s.menuShowStatus = d.menuShowStatus
                  s.dueDateTextDay = d.dueDateTextDay
                  s.remark = d.remark || ''
                  s.masBranchID = d.masBranchID
                  s.limitBookingCheck = d.limitBookingCheck
                  s.memberId = d.memberId || ''
                  s.countHourLimit = d.countHourLimit
                  s.empSelect = d.empSelect
                  s.empFull_NameTH = d.empFull_NameTH || ''
                  s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.address = d.address
                  s.addressLatLong = d.addressLatLong
                  s.jobNo = d.jobNo
                  s.timeText = d.timeText
                  s.remarkRemove = d.remarkRemove || ''
                  s.remarkConfirm1 =
                    d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
                  s.remarkConfirm2 =
                    d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.depositStatus = d.depositStatus || 'False'
                  s.depositImge = d.depositImge || ''
                  s.depositReturnImge = d.depositReturnImge || ''
                  s.depositPrice = d.depositPrice || ''
                  s.remarkDepositLinked = d.remarkDepositLinked || ''
                  s.lineUserId = d.lineUserId
                  s.memberPicture = d.memberPicture
                  s.memberName = d.memberName
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue
                  s.countChangeTime = d.countChangeTime || 0
                  s.remarkReturn = d.remarkReturn || ''
                  s.dateReturn = d.dateReturn || ''
                  s.packageId = d.packageId || ''
                  s.tokenPackage = d.tokenPackage || ''
                  s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
                  s.menuItem = d.menuItem || []
                  s.menuPrice = d.menuPrice || ''
                  this.countAll = this.countAll + 1
                  if (d.status === 'use' && d.status === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.status === 'use' && d.status === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.status || 'wait'
                  switch (d.status) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      this.countConfirm = this.countConfirm + 1
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      this.countCancel = this.countCancel + 1
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      this.countJob = this.countJob + 1
                      break
                    // default:
                    //   s.statusBtText = 'รายการนัดหมายใหม่'
                    //   this.countWaiting = this.countWaiting + 1
                    //   break
                  }
                  var chkTime = this.dataItemTime.filter(el => {
                    return el.timeDueHtext === s.timeDueHtext
                  })
                  if (chkTime.length === 0) {
                    dataItemTimes.push(s)
                  }
                  try {
                    s.memberDataTagName = []
                    s.memberDataTag = JSON.parse(d.memberDataTag) || []
                    if (s.memberDataTag.length > 0) {
                      s.tagDataShow = []
                      let memberDataTag = s.memberDataTag
                      for (let i = 0; i < memberDataTag.length; i++) {
                        let d = memberDataTag[i]
                        let x = {}
                        let checkTagItem = this.tagItem.filter(el => {
                          return el.value === d
                        })
                        if (checkTagItem.length > 0) {
                          x.text = checkTagItem[0].text
                          x.value = checkTagItem[0].value
                          s.tagDataShow.push(x)
                        }
                      }
                    }
                    // s.memberDataTagName = s.memberDataTagName.join(', ')
                  } catch (error) {
                    console.log(error)
                  }

                  // s.cusName = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'ชื่อ')
                  // s.cusReg = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เลขทะเบียน')
                  // s.tel = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เบอร์โทร')
                  // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
                  // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
                  // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
                  s.cusName = d.bookingDataCustomerName || ''
                  s.cusReg = d.bookingDataCustomerRegisNumber || ''
                  s.tel = d.bookingDataCustomerTel || ''
                  s.displayFlowName = d.displayFlowName || ''
                  dataItems.push(s)
                }
              }
            }
            if (dataItems.length === 0 || dataItems.status === false) {
              this.dataItem = []
              this.dataItemTime = []
              // await this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
              } else {
                this.getSelect(
                  'wait',
                  this.countWaiting,
                  this.filterCloseJobValue
                )
              }
              this.dataReady = true
              // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            } else {
              this.dataItem = dataItems
              var datause = dataItemTimes.sort((a, b) => {
                if (a.timeDueHtext < b.timeDueHtext) return -1
                return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              })
              console.log('datause', datause)
              for (var k = 0; k < datause.length; k++) {
                var t = datause[k]
                var h = {}
                h.timeDueHtext = t.timeDueHtext
                let chkTimes = this.dataItemTime.filter(el => {
                  return el.timeDueHtext === t.timeDueHtext
                })
                // console.log('chkTimes', chkTimes)
                if (chkTimes.length === 0) {
                  this.dataItemTime.push(h)
                }
              }
              // await this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
              } else {
                this.getSelect(
                  'wait',
                  this.countWaiting,
                  this.filterCloseJobValue
                )
              }
              // this.dataItemTime = dataItemTimes.sort((a, b) => {
              //   if (a.timeDueHtext < b.timeDueHtext) return -1
              //   return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              // })
              console.log('this.BookingDataList', this.BookingDataList)
              this.dataReady = true
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log(error)
            this.dataReady = true
            setTimeout(() => this.searchAny(), 3000)
            //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาใส่คำค้นหาให้มากว่า 1 ตัวอักษร', 'error')
      }
    },
    async getDataDefault () {
      this.loadingRefresh = true
      this.$route.query.bookNoNoti = 'None'
      this.searchAll2 = ''
      await this.getDataBranch()
      await this.getEmpSelectAdd()
      this.getCustomFieldStart()
      await this.getDataFlow()
      await this.getBookingList()
      // await this.getTimesChange('update')
      this.getSelect(
        this.getSelectText,
        this.getSelectCount,
        this.filterCloseJobValue
      )
      // this.getDataCalendaBooking()
      this.loadingRefresh = false
    },
    checkTimeFlow (dt) {
      this.timeavailable = []
      // let dtTime = this.branch.filter(item => { return item.value === this.masBranchID })
      let dtTime = this.DataFlowNameDefault.filter(item => {
        return item.value === dt.flowId
      })
      // console.log('dtTime', dtTime)
      if (dtTime.length > 0) {
        console.log(
          'dtTime',
          dtTime.filter(item => item.allData.setTime)
        )
        if (dtTime.filter(item => item.allData.setTime).length > 0) {
          if (dtTime.filter(item => item.allData.setTime)[0] === null) {
            this.timeavailable = []
            // this.$swal('แจ้งเตือน', 'เนื่องจากยังไม่ได้ตั้งค่าเวลา', 'info')
          } else {
            this.timeavailable = JSON.parse(
              dtTime.map(item => item.allData.setTime)
            )
          }
        } else {
          this.timeavailable = []
        }
      } else {
        this.timeavailable = []
      }
    },
    async confirmRemark (item, text) {
      console.log('item', item)
      let dt = null
      let errorMessage = ''
      if (text === 'inAdvance') {
        dt = {
          remarkConfirm1: item.remarkConfirm1,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'inDay') {
        dt = {
          remarkConfirm2: item.remarkConfirm2,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'extraJob') {
        dt = {
          fastTrack: item.extraJob ? false : item.fastTrack,
          extraJob: item.extraJob,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'fastTrack') {
        if (item.fastTrack === true) {
          let getcount = await this.getCountFastTrack(
            item.dueDate,
            this.flowSelect,
            this.masBranchID
          )
          let setCountFast = this.branch.filter(el => {
            return el.value === this.masBranchID
          })[0].allData.countFastTrack
          console.log('getcount', getcount)
          console.log('setCountFast', setCountFast)
          if (getcount < setCountFast) {
            dt = {
              extraJob: item.fastTrack ? false : item.extraJob,
              fastTrack: item.fastTrack,
              LAST_USER: this.session.data.userName
            }
          } else {
            dt = null
            item.fastTrack = false
            errorMessage = 'จำนวนงานด่วนต่อวัน เกินกว่าที่ตั้งไว้'
          }
        } else {
          dt = {
            extraJob: item.fastTrack ? false : item.extraJob,
            fastTrack: item.fastTrack,
            LAST_USER: this.session.data.userName
          }
        }
      }
      if (dt) {
        await axios
          .post(this.$DNS_IP + '/Booking/edit/' + item.bookNo, dt)
          .then(async response => {
            if (this.statusSearch === 'no') {
              await this.getBookingList()
            } else {
              await this.searchAny()
            }
            // this.getTimesChange('update')
            if (this.getSelectText) {
              this.getSelect(
                this.getSelectText,
                this.getSelectCount,
                this.filterCloseJobValue
              )
            }
            console.log(
              'getSelectText',
              this.getSelectText,
              this.getSelectCount
            )
          })
          .catch(error => {
            console.log('error function addData : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', errorMessage, 'error')
      }
    },
    async getCustomFieldStart () {
      this.editedItemSeleteField = []
      axios
        .get(
          this.$DNS_IP +
          '/customField/get?shopId=' +
          this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            let sortrs = rs.sort((a, b) => a.sortNoField - b.sortNoField)
            for (let i = 0; i < sortrs.length; i++) {
              let d = sortrs[i]
              let s = {}
              s.fieldId = d.fieldId
              s.fieldName = d.fieldName
              s.fieldType = d.fieldType
              s.optionField = d.optionField
              s.conditionField = d.conditionField
              s.conditionValue = d.conditionValue
              s.shopId = d.shopId
              s.showCard = d.showCard
              s.fieldValue = ''
              this.editedItemSeleteField.push(s)
            }
            // console.log('this.editedItemSeleteField', this.editedItemSeleteField)
          }
        })
    },
    async getDataFromAPI (url, fieldId, fieldName, param) {
      let result = []
      await axios
        .get(this.$DNS_IP + `${url}?shopId=${this.session.data.shopId}${param}`)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d[fieldName]
              s.value = d[fieldId]
              s.allData = d
              result.push(s)
              // console.log('this.DataFlowName', this.DataFlowName)
            }
          } else {
            result = []
          }
        })
      return result
    },
    async getDataFlow () {
      let result = []
      let resultOption = []
      await axios
        .get(
          this.$DNS_IP +
          `/flow/get?shopId=${this.session.data.shopId}${this.selectOnsite}`
        )
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            result.push({ text: 'ทั้งหมด', value: 'AllFlow' })
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d.flowName
              s.value = d.flowId
              s.menuShowStatus = d.menuShowStatus
              s.masBranchID = d.masBranchID
              s.allData = d
              result.push(s)
              resultOption.push(s)
              // console.log('this.DataFlowName', this.DataFlowName)
            }
          } else {
            result = []
            resultOption = []
          }
        })
      this.DataFlowNameDefault = result
      // this.DataFlowName = result
      console.log('getDataFlow', result)
      // console.log('masBranchID', this.masBranchID)
      // if (this.masBranchID !== '') {
      //   this.DataFlowName = result.filter(el => { return el.masBranchID === this.masBranchID })
      // } else {
      //   this.DataFlowName = result
      // }
      this.DataFlowNameMenu = result.filter(el => {
        return el.menuShowStatus === 'True'
      })
      this.dataFlowSelectAdd = resultOption
      this.dataFlowSelectEdit = resultOption
    },
    async getDataBranch () {
      let branchData = await this.getDataFromAPI(
        '/master_branch/get',
        'masBranchID',
        'masBranchName',
        ''
      )
      if (
        this.session.data.masBranchID === '' ||
        this.session.data.masBranchID === null
      ) {
        this.branch = branchData
      } else {
        let checkData = branchData.filter(el => {
          return el.value === this.session.data.masBranchID
        })
        if (checkData.length > 0) {
          this.branch = checkData
        } else {
          await this.getDataBranch()
          if (checkData.length > 0) {
            this.branch = checkData
          } else {
            this.branch = []
            this.$swal(
              'ผิดพลาด',
              'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
              'error'
            )
          }
        }
      }
      // console.log('TEST', this.branch)
    },
    getDataFromFieldName (data, key) {
      if (data !== undefined) {
        return data.filter(function (el) {
          return el.fieldName === key
        })
      } else {
        return []
      }
    },
    getSelect (text, count, filterCloseJobValue) {
      this.selectedStatus = true
      this.getSelectText = text
      this.getSelectCount = count || 0
      this.dataItemSelect = []
      this.columnsSelected = []
      console.log('text', text)
      console.log('filterCloseJobValue', filterCloseJobValue)
      if (text === 'all') {
        if (this.dataItem.length > 0) {
          this.checkSelectText = this.dataItem[0].statusBt
          console.log('this.checkSelectText => ', this.checkSelectText)
          for (let x = 0; x < this.dataItem.length; x++) {
            let t = this.dataItem[x]
            t.flowNameShow = t.displayFlowName
              ? t.flowName + ' : ' + t.displayFlowName
              : t.flowName
            this.dataItemSelect.push(t)
          }
        } else {
          this.dataItemSelect = []
        }
        console.log('dataItemSelect', this.dataItemSelect)
        this.columnsSelected = [
          { text: 'หมายเลข', value: 'receiptNo' },
          { text: 'บริการ', value: 'flowName' },
          { text: 'ชื่อ', value: 'cusName' },
          { text: 'เบอร์โทร', value: 'cusName' },
          { text: 'วันที่จองงาน', value: 'dateApp' },
          { text: 'วันที่จองงาน', value: 'dateApp' },
          { text: 'ที่อยู่', value: 'address' },
          { text: 'รายการ', value: 'flowList' },
          { text: 'ผู้ให้บริการ', value: 'empName' },
          {
            text: 'สถานะ',
            value: 'actionStatus',
            sortable: true,
            align: 'center'
          },
          { text: 'สังกัด', value: 'member' },
          { text: 'วันที่สร้าง', value: 'CREATE_DATE' }
        ]
      } else {
        var dataSelect = []
        // console.log('dataSelect => ', dataSelect)
        if (text === 'confirmSum') {
          dataSelect = this.dataItem.filter(el => {
            // console.log('el1 = ', el)
            return el.statusBt === 'confirm' || el.statusBt === 'confirmJob' || el.statusBt === 'cancel'
          })
          console.log(dataSelect)
          this.countJob = this.dataItem.filter(el => {
            // console.log('el2 = ', el)
            return el.statusBt === 'confirmJob'
          }).length
          this.filterCloseJobValue = 'ทั้งหมด'
        } else {
          if (text === 'confirmJob') {
            if (filterCloseJobValue) {
              if (filterCloseJobValue === 'ยังไม่ปิดงาน') {
                dataSelect = this.dataItem.filter(el => {
                  // console.log('el3 = ', el)
                  const isShopMatched = this.checkShopSigneture[el.shopId]
                  return el.statusBt === text && el.receiptNo && (isShopMatched ? el.RECORD_STATUS === 'N' : el.RECORD_STATUS_Job === 'N')
                })
                this.countJob = dataSelect.length
              } else if (filterCloseJobValue === 'ปิดงาน') {
                dataSelect = this.dataItem.filter(el => {
                  // console.log('el4 = ', el)
                  const isShopMatched = this.checkShopSigneture[el.shopId]
                  return el.statusBt === text && el.receiptNo && (isShopMatched ? el.RECORD_STATUS === 'D' : el.RECORD_STATUS_Job === 'D')
                })
                this.countJob = dataSelect.length
              } else {
                dataSelect = this.dataItem.filter(el => {
                  // console.log('el5 = ', el)
                  return el.statusBt === text
                })
                this.countJob = dataSelect.length
              }
            } else {
              dataSelect = this.dataItem.filter(el => {
                // console.log('el6 = ', el)
                return el.statusBt === text
              })
              this.countJob = dataSelect.length
            }
          } else {
            dataSelect = this.dataItem.filter(el => {
              // console.log('el7 = ', el)
              return el.statusBt === text
            })
          }
        }
        if (dataSelect.length > 0) {
          this.checkSelectText = dataSelect[0].statusBt
          for (let x = 0; x < dataSelect.length; x++) {
            let t = dataSelect[x]
            t.flowNameShow = t.displayFlowName
              ? t.flowName + ' : ' + t.displayFlowName
              : t.flowName

            this.dataItemSelect.push(t)
          }
        } else {
          this.dataItemSelect = []
        }
        if (text === 'cancel') {
          // ยกเลิก Airmate
          if (this.$session.getAll().data.shopId === this.shopNameData.ayasan) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else if (this.$session.getAll().data.shopId === this.shopNameData.ayasan || this.$session.getAll().data.shopId === this.shopNameData.assa) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              { text: 'Serial Number', value: 'remarkDetail' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'อุณหภูมิก่อนล้าง', value: 'beforeAir' },
              { text: 'อุณหภูมิหลังล้าง', value: 'afterAir' },
              { text: 'มีทรัพย์สินสูญหาย', value: 'checkBox1' },
              { text: 'หมายเหตุมีทรัพย์สินสูญหาย', value: 'remarkCheckbox1' },
              { text: 'มีทรัพย์สินเสียหาย', value: 'checkBox2' },
              { text: 'หมายเหตุมีทรัพย์สินเสียหาย', value: 'remarkCheckbox2' },
              { text: 'หน้างานสะอาดหรือไม่', value: 'redio1' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              // { text: 'สังกัด', value: 'memberName' },
              // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          }
        } else if (text === 'confirm') {
          // ยืนยันแล้ว Airmate
          if (this.$session.getAll().data.shopId === this.shopNameData.ayasan) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else if (this.$session.getAll().data.shopId === this.shopNameData.assa) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              { text: 'Seiral Number', value: 'remarkDetail' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else if (this.checkShopSigneture[this.$session.getAll().data.shopId]) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center'
              }
            ]
          } else {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'อุณหภูมิก่อนล้าง', value: 'beforeAir' },
              { text: 'อุณหภูมิหลังล้าง', value: 'afterAir' },
              { text: 'มีทรัพย์สินสูญหาย', value: 'checkBox1' },
              { text: 'หมายเหตุมีทรัพย์สินสูญหาย', value: 'remarkCheckbox1' },
              { text: 'มีทรัพย์สินเสียหาย', value: 'checkBox2' },
              { text: 'หมายเหตุมีทรัพย์สินเสียหาย', value: 'remarkCheckbox2' },
              { text: 'หน้างานสะอาดหรือไม่', value: 'redio1' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              // { text: 'สังกัด', value: 'memberName' },
              // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          }
        } else if (text === 'wait') {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: this.formResults[0].receiptNo },
              { text: 'ลูกค้า', value: 'cusName' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'รายการ', value: 'flowList' },
              { text: 'วันที่จองงาน', value: 'dateApp' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ผู้ให้บริการ', value: 'empName' },
              {
                text: 'สถานะ',
                value: 'actionStatus',
                sortable: true,
                align: 'center'
              },
              { text: 'สังกัด', value: 'member' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' }
            ]
          } else if (this.$session.getAll().data.shopId === this.shopNameData.ayasan) {
            // รอยืนยัน Airmate
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else if (this.$session.getAll().data.shopId === this.shopNameData.assa) {
            // รอยืนยัน Airmate
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              { text: 'Seiral Number', value: 'remarkDetail' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else {
            // รอยืนยัน Airmate
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'อุณหภูมิก่อนล้าง', value: 'beforeAir' },
              { text: 'อุณหภูมิหลังล้าง', value: 'afterAir' },
              { text: 'มีทรัพย์สินสูญหาย', value: 'checkBox1' },
              { text: 'หมายเหตุมีทรัพย์สินสูญหาย', value: 'remarkCheckbox1' },
              { text: 'มีทรัพย์สินเสียหาย', value: 'checkBox2' },
              { text: 'หมายเหตุมีทรัพย์สินเสียหาย', value: 'remarkCheckbox2' },
              { text: 'หน้างานสะอาดหรือไม่', value: 'redio1' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              // { text: 'สังกัด', value: 'memberName' },
              // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          }
        } else if (text === 'confirmJob') {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: this.formResults[0].receiptNo },
              { text: 'ลูกค้า', value: 'cusName' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'รายการ', value: 'flowList' },
              { text: 'วันที่จองงาน', value: 'dateApp' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ผู้ให้บริการ', value: 'empName' },
              {
                text: 'สถานะ',
                value: 'actionStatus',
                sortable: true,
                align: 'center'
              },
              { text: 'สังกัด', value: 'member' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' }
            ]
          } else {
            // เข้าใช้บริการแล้ว Airmate
            if (this.$session.getAll().data.shopId === this.shopNameData.ayasan || this.$session.getAll().data.shopId === this.shopNameData.assa) {
              this.columnsSelected = [
                { text: 'หมายเลข', value: 'receiptNo' },
                { text: 'บริการ', value: 'flowName' },
                { text: 'ชื่อ', value: 'CustomFieldName' },
                { text: 'เบอร์', value: 'CustomFieldTel' },
                { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
                { text: 'วันที่จอง', value: 'LAST_DATE' },
                { text: 'ที่อยู่', value: 'address' },
                { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
                { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
                { text: 'หมายเหตุ', value: 'remark' },
                {
                  text: 'สถานะ',
                  value: 'checkStatus',
                  sortable: true,
                  align: 'center'
                },
                {
                  text: 'ปริ้น PDF',
                  value: 'actionPrint',
                  sortable: false,
                  align: 'center'
                }
              ]
            } else {
              this.columnsSelected = [
                { text: 'หมายเลข', value: 'receiptNo' },
                { text: 'บริการ', value: 'flowName' },
                { text: 'ชื่อ', value: 'CustomFieldName' },
                { text: 'เบอร์', value: 'CustomFieldTel' },
                { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
                { text: 'วันที่จอง', value: 'LAST_DATE' },
                { text: 'ที่อยู่', value: 'address' },
                { text: 'อุณหภูมิก่อนล้าง', value: 'beforeAir' },
                { text: 'อุณหภูมิหลังล้าง', value: 'afterAir' },
                { text: 'มีทรัพย์สินสูญหาย', value: 'checkBox1' },
                { text: 'หมายเหตุมีทรัพย์สินสูญหาย', value: 'remarkCheckbox1' },
                { text: 'มีทรัพย์สินเสียหาย', value: 'checkBox2' },
                { text: 'หมายเหตุมีทรัพย์สินเสียหาย', value: 'remarkCheckbox2' },
                { text: 'หน้างานสะอาดหรือไม่', value: 'redio1' },
                { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
                { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
                { text: 'หมายเหตุ', value: 'remark' },
                {
                  text: 'สถานะ',
                  value: 'checkStatus',
                  sortable: true,
                  align: 'center'
                },
                // { text: 'สังกัด', value: 'memberName' },
                // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
                {
                  text: 'ปริ้น PDF',
                  value: 'actionPrint',
                  sortable: false,
                  align: 'center'
                }
              ]
            }
          }
        } else {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: this.formResults[0].receiptNo },
              { text: 'ลูกค้า', value: 'cusName' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'รายการ', value: 'flowList' },
              { text: 'วันที่จองงาน', value: 'dateApp' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ผู้ให้บริการ', value: 'empName' },
              {
                text: 'สถานะ',
                value: 'actionStatus',
                sortable: true,
                align: 'center'
              },
              { text: 'สังกัด', value: 'member' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' }
            ]
          } else if (this.$session.getAll().data.shopId === this.shopNameData.ayasan || this.$session.getAll().data.shopId === this.shopNameData.assa) {
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          } else {
            // รวมผู้เข้ารับบริการ Airmate
            this.columnsSelected = [
              { text: 'หมายเลข', value: 'receiptNo' },
              { text: 'บริการ', value: 'flowName' },
              { text: 'ชื่อ', value: 'CustomFieldName' },
              { text: 'เบอร์', value: 'CustomFieldTel' },
              { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              { text: 'วันที่จอง', value: 'LAST_DATE' },
              { text: 'ที่อยู่', value: 'address' },
              { text: 'อุณหภูมิก่อนล้าง', value: 'beforeAir' },
              { text: 'อุณหภูมิหลังล้าง', value: 'afterAir' },
              { text: 'มีทรัพย์สินสูญหาย', value: 'checkBox1' },
              { text: 'หมายเหตุมีทรัพย์สินสูญหาย', value: 'remarkCheckbox1' },
              { text: 'มีทรัพย์สินเสียหาย', value: 'checkBox2' },
              { text: 'หมายเหตุมีทรัพย์สินเสียหาย', value: 'remarkCheckbox2' },
              { text: 'หน้างานสะอาดหรือไม่', value: 'redio1' },
              { text: 'ช่าง', value: 'empFirstNameTH_mechanic' },
              { text: 'แอดมิน', value: 'empFirstNameTH_admin' },
              { text: 'หมายเหตุ', value: 'remark' },
              {
                text: 'สถานะ',
                value: 'checkStatus',
                sortable: true,
                align: 'center'
              },
              // { text: 'สังกัด', value: 'memberName' },
              // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
              {
                text: 'ปริ้น PDF',
                value: 'actionPrint',
                sortable: false,
                align: 'center'
              }
            ]
          }
        }
      }
      this.checkTypeSort()
    },
    convertDate (dateStr) {
      try {
        moment.locale('th') // Set locale to Thai

        const dateObj = moment.tz(dateStr, 'UTC')

        if (!dateObj.isValid()) {
          throw new Error('Invalid date format')
        }

        const yearTh = dateObj.year() + 543
        const formattedDate = dateObj.format(`[${dateObj.format('dddd')}ที่] D MMMM ${yearTh} [เวลา] HH:mm [น.]`)

        return formattedDate
      } catch (error) {
        console.log('error =>', error)
        return ''
      }
    },
    checkStatus (stepTitle, status, jobNo) {
      console.log('------------ stepTitle: ', stepTitle)
      console.log('------------ status: ', status)
      console.log('------------ jobNo: ', jobNo)
      try {
        let dataReturn = ''
        if (jobNo !== null && jobNo !== '') {
          if (status === 'cancel') {
            dataReturn = 'ยกเลิกงาน'
          } else {
            dataReturn = 'จบงาน'
          }
        } else {
          if (status === 'cancel') {
            dataReturn = 'ยกเลิกงาน'
          } else {
            if (status === 'confirm') {
              dataReturn = 'รอมอบหมายงาน'
            } else if (stepTitle === 'รอ') {
              dataReturn = 'รอเริ่มงาน'
            } else {
              dataReturn = 'กำลังดำเนินงาน'
            }
          }
        }
        return dataReturn
      } catch (error) {
        console.error('An error occurred:', error)
        return 'ข้อผิดพลาดในการตรวจสอบสถานะ'
      }
    },
    async getBookingList () {
      await this.getTagData()
      clearInterval(this.setTimerCalendar)
      this.setTimerCalendar = null

      if (
        this.session.data.masBranchID === '' ||
        this.session.data.masBranchID === null
      ) {
        this.statusBranchReadonly = false
        if (this.masBranchID) {
          this.masBranchID = this.masBranchID
        } else {
          if (this.branch.length > 0) {
            this.masBranchID = this.branch[0].value
          } else {
            await this.getDataBranch()
            if (this.branch.length > 0) {
              this.masBranchID = this.branch[0].value
            } else {
              this.masBranchID = ''
              this.$swal(
                'ผิดพลาด',
                'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
                'error'
              )
            }
          }
        }
      } else {
        this.statusBranchReadonly = true
        if (
          this.branch.filter(el => {
            return el.value === this.session.data.masBranchID
          }).length > 0
        ) {
          this.masBranchID = this.session.data.masBranchID
        } else {
          await this.getDataBranch()
          if (
            this.branch.filter(el => {
              return el.value === this.session.data.masBranchID
            }).length > 0
          ) {
            this.masBranchID = this.session.data.masBranchID
          } else {
            this.masBranchID = ''
            this.$swal(
              'ผิดพลาด',
              'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
              'error'
            )
          }
        }
      }
      console.log('masBranchID', this.masBranchID)
      if (this.flowSelect !== '') {
        this.flowSelect = this.flowSelect
      } else {
        this.DataFlowName = this.DataFlowNameDefault.filter(el => {
          return (
            parseInt(el.masBranchID) === this.masBranchID ||
            el.value === 'AllFlow' ||
            el.value === 'All'
          )
        })
        if (this.DataFlowName.length > 0) {
          console.log('masBranchID', this.DataFlowName)
          this.flowSelect = this.DataFlowName[0].value
        } else {
          this.flowSelect = ''
          await this.getDataFlow()
          console.log('masBranchID', this.DataFlowName)
          this.flowSelect = this.DataFlowName[0].value
        }
      }
      this.selectedStatus = true
      this.dataItem = []
      this.countWaiting = 0
      this.countConfirm = 0
      this.countCancel = 0
      this.countJob = 0
      this.countAll = 0
      var dataItemTimes = []
      var dataItems = []
      let urlApi = ''
      let urlApiFormpdf = ''
      if (this.flowSelect === 'AllFlow') {
        urlApiFormpdf =
          this.$DNS_IP +
          '/formpdf/get_all_jointable?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&dueDate=' +
          this.dateStart
        urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&dueDate=' +
          this.dateStart +
          this.selectOnsite
      } else {
        urlApiFormpdf =
          this.$DNS_IP +
          '/formpdf/get_all_jointable?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&flowId=' +
          this.flowSelect +
          '&dueDate=' +
          this.dateStart
        urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&dueDate=' +
          this.dateStart +
          '&flowId=' +
          this.flowSelect +
          this.selectOnsite
      }
      await axios
        .get(urlApi)
        .then(async response => {
          await axios
            .get(urlApiFormpdf)
            .then(async responseFormpdf => {
              console.log('responseFormpdf.data.data: ', responseFormpdf.data.data)
              this.getData0 = responseFormpdf.data.data
            })
          console.log('response.data >>', response.data)
          let newFormPDF = {}
          for (const n of this.getData0) {
            newFormPDF[n.bookNo] = n
          }
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              let d = response.data[i]
              let dFormpdf = null
              if (newFormPDF[d.bookNo]) {
                dFormpdf = newFormPDF[d.bookNo]
              } else {
                dFormpdf = {
                  'CustomField': '',
                  'StartDate': '',
                  'empFirstNameTH_admin': '',
                  'empFirstNameTH_mechanic': '',
                  'receiptNo': '',
                  'dueDate': '',
                  'LAST_DATE': '',
                  'afterAir': '',
                  'beforeAir': '',
                  'checkBox1': '',
                  'checkBox2': '',
                  'redio1': '',
                  'jobRemark': '',
                  'jobId': '',
                  'signatureURL': '',
                  'RECORD_STATUS': '',
                  'stepTitle': '',
                  'jobNo': ''
                }
              }

              // if (dFormpdf.receiptNo === '680128005') {
              //   console.log('>>>>>>>>>> 680128005', d.bookNo, dFormpdf.bookNo)
              // }
              let s = {}
              s.bookNo = d.bookNo
              s.flowId = d.flowId
              let checkDeposit = this.DataFlowNameDefault.filter(el => {
                return el.value === parseInt(d.flowId)
              })
              if (checkDeposit.length > 0) {
                s.depositCheckStatus =
                  checkDeposit[0].allData.checkDeposit || 'False'
              } else {
                s.depositCheckStatus = 'False'
              }
              s.flowName = d.flowName
              s.dueDate = this.convertDate(d.dueDate) || ''
              if (d.timeText === null || d.timeText === '') {
                d.timeText = d.timeDue
              }
              if (s.dueDate === '') {
                s.dueDateText = 'ไม่มีเวลานัดหมาย'
              } else {
                s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
              }
              s.cusName = d.bookingDataCustomerName || ''
              s.cusReg = d.bookingDataCustomerRegisNumber || ''
              s.tel = d.bookingDataCustomerTel || ''
              s.displayFlowName = d.displayFlowName || ''
              s.shopId = d.shopId
              s.dueDateDay = d.dueDateDay
              s.statusVIP = d.statusVIP
              s.checkDateConfirmJob = d.checkDateConfirmJob
              s.packageName = d.packageName
              s.packageDetails = d.packageDetails
              s.packageImage = d.packageImage
              s.packagePrice = d.packagePrice
              s.packageBalanceAmount = d.packageBalanceAmount
              s.packageAmount = d.packageAmount
              s.packagePoint = d.packagePoint
              s.packageExpire = d.packageExpire
              s.depositTextTH = d.depositTextTH
              s.CREATE_DATE_Status = d.CREATE_DATE_Status
              s.CREATE_DATE = this.convertDate(d.CREATE_DATE)
              s.menuShowStatus = d.menuShowStatus
              s.dueDateTextDay = d.dueDateTextDay
              s.remark = d.remark || ''
              s.masBranchID = d.masBranchID
              s.limitBookingCheck = d.limitBookingCheck
              s.memberId = d.memberId || ''
              s.countHourLimit = d.countHourLimit
              s.empSelect = d.empSelect
              s.empFull_NameTH = d.empFull_NameTH || ''
              s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
              s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
              s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
              s.userId = d.userId
              s.chkConfirm = false
              s.chkCancel = false
              s.address = d.address
              s.addressLatLong = d.addressLatLong
              s.jobNo = d.jobNo
              s.timeText = d.timeText
              s.remarkRemove = d.remarkRemove || ''
              s.remarkConfirm1 =
                d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
              s.remarkConfirm2 =
                d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
              s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
              s.fastTrack = d.fastTrack === 'true' || d.fastTrack === 'True'
              s.depositStatus = d.depositStatus || 'False'
              s.depositImge = d.depositImge || ''
              s.depositReturnImge = d.depositReturnImge || ''
              s.depositPrice = d.depositPrice || ''
              s.remarkDepositLinked = d.remarkDepositLinked || ''
              s.lineUserId = d.lineUserId
              s.checkDeposit = d.checkDeposit
              s.memberPicture = d.memberPicture
              s.memberName = d.memberName
              s.timeDueHtext = d.timeDueH + ':00'
              s.timeDuetext = d.timeDue
              s.countChangeTime = d.countChangeTime || 0
              s.remarkReturn = d.remarkReturn || ''
              s.dateReturn = d.dateReturn || ''
              s.packageId = d.packageId || ''
              s.tokenPackage = d.tokenPackage || ''
              s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
              s.menuItem = d.menuItem || []
              s.menuPrice = d.menuPrice || ''
              s.memberDataTagName = []
              if (dFormpdf.CustomField === '') {
                s.CustomFieldName = ''
                s.CustomFieldTel = ''
              } else {
                s.allNameandTel = {}
                try {
                  dFormpdf.CustomField.split(',').forEach(item => {
                    const [key, value] = item.split(':')
                    s.allNameandTel[key.trim()] = value.trim()
                  })
                  s.CustomFieldName = s.allNameandTel['ชื่อ']
                  s.CustomFieldTel = s.allNameandTel['เบอร์โทร']
                } catch (err) {
                  s.CustomFieldName = ''
                  s.CustomFieldTel = ''
                }
              }
              s.StartDate = dFormpdf.StartDate ? this.convertDate(dFormpdf.StartDate) : ''
              // console.log('s.StartDate ', s.StartDate)
              s.empFirstNameTH_admin = dFormpdf.empFirstNameTH_admin || ''
              s.empFirstNameTH_mechanic = dFormpdf.empFirstNameTH_mechanic || ''
              s.receiptNo = dFormpdf.receiptNo
              s.LAST_DATE = this.convertDate(dFormpdf.dueDate)
              s.DATE_LAST = this.convertDate(dFormpdf.LAST_DATE)
              s.afterAir = dFormpdf.afterAir
              s.beforeAir = dFormpdf.beforeAir
              s.checkBox1 = dFormpdf.checkBox1
              s.checkBox2 = dFormpdf.checkBox2
              s.remarkCheckbox1 = dFormpdf.remarkCheckbox1
              s.remarkCheckbox2 = dFormpdf.remarkCheckbox2
              s.remarkDetail = dFormpdf.remarkDetail
              s.redio1 = dFormpdf.redio1
              s.stepTitle = d.stepTitle
              s.jobRemark = dFormpdf.jobRemark
              s.jobId = dFormpdf.jobId
              s.signatureURL = dFormpdf.signatureURL
              s.RECORD_STATUS = dFormpdf.RECORD_STATUS
              console.log('send checkStatus', dFormpdf.stepTitle, d.statusBt, dFormpdf.jobNo)
              s.checkStatus = this.checkStatus(dFormpdf.stepTitle, d.statusBt, dFormpdf.jobNo)
              s.actionPrint = s.checkStatus
              try {
                s.memberDataTag = JSON.parse(d.memberDataTag) || []
                if (s.memberDataTag.length > 0) {
                  s.tagDataShow = []
                  let memberDataTag = s.memberDataTag
                  for (let i = 0; i < memberDataTag.length; i++) {
                    let d = memberDataTag[i]
                    let x = {}
                    let checkTagItem = this.tagItem.filter(el => {
                      return el.value === d
                    })
                    if (checkTagItem.length > 0) {
                      x.text = checkTagItem[0].text
                      x.value = checkTagItem[0].value
                      s.tagDataShow.push(x)
                      s.memberDataTagName.push(x.text)
                    }
                  }
                }
                s.memberDataTagName = s.memberDataTagName.join(', ')
              } catch (error) {
                s.tagDataShow = []
                console.log(error)
              }
              this.countAll = this.countAll + 1
              if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                s.chkConfirm = true
                s.chkCancel = false
              }
              if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                s.chkConfirm = false
                s.chkCancel = true
              }
              s.statusBt = d.statusBt || 'wait'
              switch (d.statusBt) {
                case 'confirm':
                  s.statusBtText = 'ยืนยันแล้ว'
                  this.countConfirm = this.countConfirm + 1
                  break
                case 'cancel':
                  s.statusBtText = 'ยกเลิก'
                  this.countCancel = this.countCancel + 1
                  break
                case 'confirmJob':
                  s.statusBtText = 'รับรถแล้ว'
                  this.countJob = this.countJob + 1
                  break
              }
              var chkTime = this.dataItemTime.filter(el => {
                return el.timeDueHtext === s.timeDueHtext
              })
              if (chkTime.length === 0) {
                dataItemTimes.push(s)
              }
              if (s.statusBt !== 'wait') {
                dataItems.push(s)
              }
            }
            console.log('dataItemsnn', dataItems)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
          //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
        })
      let urlApiwait = ''
      if (this.flowSelect === 'AllFlow') {
        urlApiwait =
          this.$DNS_IP +
          '/formpdf/getview?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&statusBt=null' +
          this.selectOnsite
      } else {
        urlApiwait =
          this.$DNS_IP +
          '/formpdf/getview?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&statusBt=null&flowId=' +
          this.flowSelect +
          this.selectOnsite
      }
      // console.log('abcccccccc')
      // console.log('urlApiwait', urlApiwait)
      await axios.get(urlApiwait).then(async responses => {
        if (responses.data.length > 0) {
          // console.log('length', responses.data.length)
          for (let i = 0; i < responses.data.length; i++) {
            let d = responses.data[i]
            console.log('d:abcccc =>', d)
            let s = {}
            // if (this.BookingDataList[d.bookNo] !== undefined) {
            // console.log('branch no flow', d.masBranchID, d.flowId)
            s.bookNo = d.bookNo
            s.flowId = d.flowId
            let checkDeposit = this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(d.flowId)
            })
            if (checkDeposit.length > 0) {
              s.depositCheckStatus =
                checkDeposit[0].allData.checkDeposit || 'False'
            } else {
              s.depositCheckStatus = 'False'
            }
            s.flowName = d.flowName
            s.dueDate = d.dueDate || ''
            if (d.timeText === null || d.timeText === '') {
              d.timeText = d.timeDue
            }
            if (s.dueDate === '') {
              s.dueDateText = 'ไม่มีเวลานัดหมาย'
            } else {
              s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
            }
            s.statusUpload1 = d.statusUpload1 || 'False'
            s.statusUpload2 = d.statusUpload2 || 'False'
            s.fileUpload1 = d.fileUpload1 || '[]'
            s.fileUpload2 = d.fileUpload2 || '[]'
            s.shopId = d.shopId
            s.dueDateDay = d.dueDateDay
            s.statusVIP = d.statusVIP
            s.checkDateConfirmJob = d.checkDateConfirmJob
            s.packageName = d.packageName
            s.packageDetails = d.packageDetails
            s.packageImage = d.packageImage
            s.packagePrice = d.packagePrice
            s.packageBalanceAmount = d.packageBalanceAmount
            s.packageAmount = d.packageAmount
            s.packagePoint = d.packagePoint
            s.packageExpire = d.packageExpire
            s.depositTextTH = d.depositTextTH
            s.CREATE_DATE_Status = d.CREATE_DATE_Status
            s.CREATE_DATE = d.CREATE_DATE
            s.menuShowStatus = d.menuShowStatus
            s.dueDateTextDay = d.dueDateTextDay
            s.remark = d.remark || ''
            s.masBranchID = d.masBranchID
            s.limitBookingCheck = d.limitBookingCheck
            s.memberId = d.memberId || ''
            s.countHourLimit = d.countHourLimit
            s.empSelect = d.empSelect
            s.empFull_NameTH = d.empFull_NameTH || ''
            s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
            s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
            s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
            s.userId = d.userId
            s.chkConfirm = false
            s.chkCancel = false
            s.address = d.address
            s.addressLatLong = d.addressLatLong
            s.jobNo = d.jobNo
            s.timeText = d.timeText
            s.remarkRemove = d.remarkRemove || ''
            s.remarkConfirm1 =
              d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
            s.remarkConfirm2 =
              d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
            s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
            s.fastTrack = d.fastTrack === 'true' || d.fastTrack === 'True'
            s.depositStatus = d.depositStatus || 'False'
            s.depositImge = d.depositImge || ''
            s.depositReturnImge = d.depositReturnImge || ''
            s.depositPrice = d.depositPrice || ''
            s.remarkDepositLinked = d.remarkDepositLinked || ''
            s.lineUserId = d.lineUserId
            s.memberPicture = d.memberPicture
            s.memberName = d.memberName
            s.timeDueHtext = d.timeDueH + ':00'
            s.timeDuetext = d.timeDue
            s.countChangeTime = d.countChangeTime || 0
            s.remarkReturn = d.remarkReturn || ''
            s.dateReturn = d.dateReturn || ''
            s.packageId = d.packageId || ''
            s.tokenPackage = d.tokenPackage || ''
            s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
            s.menuItem = d.menuItem || []
            s.menuPrice = d.menuPrice || ''
            this.countAll = this.countAll + 1
            if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
              s.chkConfirm = true
              s.chkCancel = false
            }
            if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
              s.chkConfirm = false
              s.chkCancel = true
            }
            s.statusBt = d.statusBt || 'wait'
            switch (s.statusBt) {
              case 'wait':
                s.statusBtText = 'รายการนัดหมายใหม่'
                this.countWaiting = this.countWaiting + 1
                break
            }
            var chkTime = this.dataItemTime.filter(el => {
              return el.timeDueHtext === s.timeDueHtext
            })
            if (chkTime.length === 0) {
              dataItemTimes.push(s)
            }
            s.cusName = d.bookingDataCustomerName || ''
            s.cusReg = d.bookingDataCustomerRegisNumber || ''
            s.tel = d.bookingDataCustomerTel || ''
            s.displayFlowName = d.displayFlowName || ''
            // s.cusName = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'ชื่อ')
            // s.cusReg = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เลขทะเบียน')
            // s.tel = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เบอร์โทร')
            // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
            // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
            // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
            s.memberDataTagName = []
            s.memberDataTag = JSON.parse(d.memberDataTag) || []
            if (s.memberDataTag.length > 0) {
              s.tagDataShow = []
              let memberDataTag = s.memberDataTag
              for (let i = 0; i < memberDataTag.length; i++) {
                let d = memberDataTag[i]
                let x = {}
                let checkTagItem = this.tagItem.filter(el => {
                  return el.value === d
                })
                if (checkTagItem.length > 0) {
                  x.text = checkTagItem[0].text
                  x.value = checkTagItem[0].value
                  s.tagDataShow.push(x)
                  s.memberDataTagName.push(x.text)
                }
              }
            }
            s.memberDataTagName = s.memberDataTagName.join(', ')
            dataItems.push(s)
            // console.log('this.countWaiting', this.countWaiting)
            // } else {
            //   console.log('BookingNo no bookingData', d.bookNo)
            // }
          }
        }
      })
      if (dataItems.length === 0 || dataItems.status === false) {
        this.dataItem = []
        this.dataItemTime = []
        // await this.getTimesChange('update')
        if (this.getSelectText) {
          this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
        } else {
          this.getSelect('wait', this.countWaiting, this.filterCloseJobValue)
        }
        this.dataReady = true
        // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
      } else {
        this.dataItem = dataItems
        var datause = dataItemTimes.sort((a, b) => {
          if (a.timeDueHtext < b.timeDueHtext) return -1
          return a.timeDueHtext > b.timeDueHtext ? 1 : 0
        })
        for (var k = 0; k < datause.length; k++) {
          var t = datause[k]
          var h = {}
          h.timeDueHtext = t.timeDueHtext
          let chkTimes = this.dataItemTime.filter(el => {
            return el.timeDueHtext === t.timeDueHtext
          })
          // console.log('chkTimes', chkTimes)
          if (chkTimes.length === 0) {
            // console.log('datause(H)', h)
            this.dataItemTime.push(h)
          }
        }
        console.log('dataItemTime2', this.dataItemTime)
        // await this.getTimesChange('update')
        if (this.$route.query.bookNoNoti) {
          let checkBook = dataItems.filter(el => {
            return el.bookNo === this.$route.query.bookNoNoti
          })
          if (checkBook.length > 0) {
            this.getSelectText = checkBook[0].statusBt
            this.searchAll2 = checkBook[0].cusName
          }
        }
        if (this.getSelectText) {
          this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
        } else {
          this.getSelect('wait', this.countWaiting, this.filterCloseJobValue)
        }
        this.dataReady = true
      }
    },
    async getEmpSelect (item) {
      console.log('item!!!!!!', item)
      this.empSelectStep = []
      await axios
        .get(
          this.$DNS_IP +
          '/empSelect/getUse?privacyPage=booking&shopId=' +
          item.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              // console.log('d', d)
              if (d.masBranchID === item.masBranchID) {
                var s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.empSelectStep.push(s)
              } else if (d.masBranchID === null || d.masBranchID === '') {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.empSelectStep.push(s)
              }
            }
            this.empSelect = this.empSelectStep[0].value
          }
        })
    },
    async getEmpSelectAddJob () {
      this.empSelectStepAdd = []
      await axios
        .get(
          this.$DNS_IP +
          '/empSelect/getUse?USER_ROLE=onsite&shopId=' +
          this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              console.log('DDDDDSFDSDFSDF', d)
              var s = {}
              s.text = d.empFull_NameTH
              s.value = d.empId
              this.empSelectStepAdd.push(s)
            }
          }
        })
    },
    async getEmpSelectAdd () {
      this.empSelectStepAdd = []
      await axios
        .get(
          this.$DNS_IP +
          '/empSelect/getUse?privacyPage=booking&shopId=' +
          this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              d.masBranchID = d.masBranchID || ''
              console.log(
                'this.$session.getAll().data.masBranchID',
                this.$session.getAll().data.masBranchID
              )
              if (
                this.$session.getAll().data.masBranchID === '' ||
                this.$session.getAll().data.masBranchID === null
              ) {
                // console.log('D', d)
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                s.masBranchID = d.masBranchID
                this.empSelectStepAdd.push(s)
              } else {
                if (
                  this.$session.getAll().data.masBranchID === d.masBranchID ||
                  d.masBranchID === ''
                ) {
                  let s = {}
                  s.text = d.empFirst_NameTH
                  s.value = d.empId
                  s.masBranchID = d.masBranchID
                  this.empSelectStepAdd.push(s)
                }
              }
            }
            console.log(
              '>>>>>>this.$session.getAll().data.empId',
              this.$session.getAll().data.empId
            )
            if (
              this.$session.getAll().data.empId !== '' &&
              this.$session.getAll().data.empId !== null
            ) {
              try {
                this.empSelectAdd = this.empSelectStepAdd.filter(
                  item =>
                    item.value === parseInt(this.$session.getAll().data.empId)
                )[0].value
              } catch (err) { }
            }
            console.log('this.empSelectStepAdd', this.empSelectStepAdd)
          }
        })
    },
    toggle () {
      this.timeTable = moment(moment(new Date(), 'YYYY-MM-DD').toDate()).format(
        'YYYY-MM-DD'
      )
      this.getTimesChange('update')
      this.drawer = !this.drawer
    },
    async getTimesChange (text) {
      try {
        this.dataItemTimesChange = []
        this.dataRemoveExport = []
        if (text === 'all') {
          this.dataItemTimesChange = this.dataItem
          this.dataRemoveExport = this.dataItemTimesChange.filter(el => {
            return el.statusBt === 'cancel'
          })
          this.BookingDataListTimechange = this.BookingDataList
        } else {
          if (this.masBranchID) {
            this.masBranchID = this.masBranchID
          } else {
            if (this.branch.length > 0) {
              this.masBranchID = this.branch[0].value
            } else {
              this.masBranchID = ''
            }
          }
          this.dataItemCheck = []
          var dataItems = []
          if (this.timeTable !== '') {
            var dateStart = moment(
              moment(this.timeTable, 'YYYY-MM-DD').toDate()
            ).format('YYYY-MM-DD')
            console.log('dateStartxx', dateStart)
            console.log('timeTable', this.timeTable)
            await this.getBookingDataListTimechange(dateStart)

            let urlApi = ''
            if (this.flowSelect === 'AllFlow') {
              urlApi =
                this.$DNS_IP +
                '/booking_view/get?shopId=' +
                this.session.data.shopId +
                '&masBranchID=' +
                this.masBranchID +
                '&dueDate=' +
                this.timeTable +
                this.selectOnsite
            } else {
              urlApi =
                this.$DNS_IP +
                '/booking_view/get?shopId=' +
                this.session.data.shopId +
                '&masBranchID=' +
                this.masBranchID +
                '&dueDate=' +
                this.timeTable +
                '&flowId=' +
                this.flowSelect +
                this.selectOnsite
            }
            await axios.get(urlApi).then(async response => {
              console.log('getData-------', response.data)
              this.dataToday = response.data
              if (response.data.length > 0) {
                for (let i = 0; i < response.data.length; i++) {
                  let d = response.data[i]
                  let s = {}
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate
                  s.dueDateTimeStamp = d.dueDateTimeStamp
                  s.remarkRemove = d.remarkRemove
                  s.remark = d.remark
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.jobNo = d.jobNo
                  s.statusUpload1 = d.statusUpload1 || 'False'
                  s.statusUpload2 = d.statusUpload2 || 'False'
                  s.fileUpload1 = d.fileUpload1 || '[]'
                  s.fileUpload2 = d.fileUpload2 || '[]'
                  s.empFull_NameTH = d.empFull_NameTH
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.remarkRemove = d.remarkRemove || ''
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue
                  if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.statusBt || 'wait'
                  switch (d.statusBt) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      break
                    default:
                      s.statusBtText = 'รายการนัดหมายใหม่'
                      break
                  }
                  s.cusName = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'ชื่อ'
                  )
                  s.cusReg = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'เลขทะเบียน'
                  )
                  s.tel = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'เบอร์โทร'
                  )
                  s.cusName =
                    s.cusName.length > 0 ? s.cusName[0].fieldValue : ''
                  s.cusReg = s.cusReg.length > 0 ? s.cusReg[0].fieldValue : ''
                  s.tel = s.tel.length > 0 ? s.tel[0].fieldValue : ''

                  s.memberDataTag = JSON.parse(d.memberDataTag) || []
                  if (s.memberDataTag.length > 0) {
                    s.tagDataShow = []
                    let memberDataTag = s.memberDataTag
                    for (let i = 0; i < memberDataTag.length; i++) {
                      let d = memberDataTag[i]
                      let x = {}
                      let checkTagItem = this.tagItem.filter(el => {
                        return el.value === d
                      })
                      if (checkTagItem.length > 0) {
                        x.text = checkTagItem[0].text
                        x.value = checkTagItem[0].value
                        s.tagDataShow.push(x)
                      }
                    }
                  }
                  dataItems.push(s)
                }
              }
              if (dataItems.length === 0 || dataItems.status === false) {
                this.dataItemCheck = []
              } else {
                console.log('month new if', dataItems)
                this.dataItemCheck = dataItems
                this.dataItemTimesChange = this.dataItemCheck.sort((a, b) => {
                  if (a.timeDuetext < b.timeDuetext) return -1
                  return a.timeDuetext > b.timeDuetext ? 1 : 0
                })
                this.dataRemoveExport = this.dataItemTimesChange.filter(el => {
                  return el.statusBt === 'cancel'
                })
              }
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getBookingDataListTimechange (dateStart) {
      this.BookingDataListTimechange = []
      if (this.masBranchID) {
        this.masBranchID = this.masBranchID
      } else {
        if (this.branch.length > 0) {
          this.masBranchID = this.branch[0].value
        } else {
          this.masBranchID = ''
        }
      }
      let url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&dueDate=${dateStart}`
      await axios.get(url).then(async response => {
        if (response.data.status !== false) {
          response.data.forEach(row => {
            if (
              typeof this.BookingDataListTimechange[row.bookNo] === 'undefined'
            ) {
              this.BookingDataListTimechange[row.bookNo] = []
            }
            this.BookingDataListTimechange[row.bookNo].push(row)
          })
        }
      })
      console.log('data excel', this.BookingDataListTimechange)
    },
    exportExcel () {
      let dataExport = []
      this.dataexport = []
      let runNo = 0
      var datause = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      console.log('datause1', datause)
      for (let i = 0; i < datause.length; i++) {
        let d = datause[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            el.fastTrack &&
            (el.statusBtText === 'ยืนยันแล้ว' ||
              el.statusBtText === 'รับรถแล้ว')
          )
        })
        if (dataSelect.length > 0) {
          var datauseSelect = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          console.log('datauseSelect', datauseSelect)
          for (let x = 0; x < datauseSelect.length; x++) {
            runNo++
            let t = datauseSelect[x]
            let s = {}
            console.log('t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              let convertTextField = ''
              if (tempField.length > 0) {
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            console.log('serviceDetail', serviceDetail)

            s.type = this.dataTypeJob3
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            s.flowName = t.flowName
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.tel = t.tel
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            s.packageName = t.packageName || ''
            s.packageDetails = t.packageDetails || ''
            s.packageImage = t.packageImage || ''
            s.packagePrice = t.packagePrice || ''
            s.packageBalanceAmount = t.packageBalanceAmount || ''
            s.packageAmount = t.packageAmount || ''
            s.packagePoint = t.packagePoint || ''
            s.packageExpire = t.packageExpire || ''
            s.empFull_NameTH = t.empFull_NameTH || ''
            s.statusUpload1 = t.statusUpload1 || 'False'
            s.statusUpload2 = t.statusUpload2 || 'False'
            s.fileUpload1 = t.fileUpload1 || '[]'
            s.fileUpload2 = t.fileUpload2 || '[]'
            dataExport.push(s)
          }
        }
      }
      let s = {}
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.cusReg = ''
      s.flowName = ''
      s.remark = ''
      s.tel = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      s.packageName = ''
      s.packageDetails = ''
      s.packageImage = ''
      s.packagePrice = ''
      s.packageBalanceAmount = ''
      s.packageAmount = ''
      s.packagePoint = ''
      s.packageExpire = ''
      s.empFull_NameTH = ''
      s.statusUpload1 = 'False'
      s.statusUpload2 = 'False'
      s.fileUpload1 = '[]'
      s.fileUpload2 = '[]'
      dataExport.push(s)
      runNo = 0

      var datause2 = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      // console.log('datause2 >>', datause2)
      for (let i = 0; i < datause2.length; i++) {
        let d = datause2[i]
        // console.log('this.dataItemTimesChange >>', this.dataItemTimesChange)
        // console.log('d.timeDueHtext >>', d.timeDueHtext)
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            !el.fastTrack &&
            (el.statusBtText === 'ยืนยันแล้ว' ||
              el.statusBtText === 'รับรถแล้ว')
          )
        })
        if (dataSelect.length > 0) {
          console.log('dataSelect >>', dataSelect)
          var datauseSelect2 = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })

          console.log('datauseSelect2 >>>', datauseSelect2)

          for (let x = 0; x < datauseSelect2.length; x++) {
            runNo++
            let t = datauseSelect2[x]
            let s = {}
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              let convertTextField = ''
              if (tempField.length > 0) {
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            serviceDetail = serviceDetail.trim() || t.flowName
            console.log('t2', t)
            s.type = 'ปกติ'
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.cusName = t.cusName
            s.remark = t.remark
            s.cusReg = t.cusReg
            s.flowName = t.flowName
            s.tel = t.tel
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? 'Extra Job' : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            s.packageName = t.packageName || ''
            s.packageDetails = t.packageDetails || ''
            s.packageImage = t.packageImage || ''
            s.packagePrice = t.packagePrice || ''
            s.packageBalanceAmount = t.packageBalanceAmount || ''
            s.packageAmount = t.packageAmount || ''
            s.packagePoint = t.packagePoint || ''
            s.packageExpire = t.packageExpire || ''
            s.empFull_NameTH = t.empFull_NameTH || ''
            s.statusUpload1 = t.statusUpload1 || 'False'
            s.statusUpload2 = t.statusUpload2 || 'False'
            s.fileUpload1 = t.fileUpload1 || '[]'
            s.fileUpload2 = t.fileUpload2 || '[]'
            dataExport.push(s)
          }
        }
      }
      this.dataexport = dataExport
      console.log('this.dataexport push', this.dataexport)
      this.onExport()
    },
    exportExcelMazda () {
      const url = `${window.location.origin}/mazda/report?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&timeTable=${this.timeTable}${this.selectOnsite}`
      window.open(url, '_blank').focus()
    },
    exportExcelRemove () {
      let dataExport = []
      this.dataexportRemove = []
      let runNo = 0
      var datause = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause.length; i++) {
        let d = datause[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            el.fastTrack &&
            el.statusBtText === 'ยกเลิก'
          )
        })
        if (dataSelect.length > 0) {
          var datauseSelect = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          for (let x = 0; x < datauseSelect.length; x++) {
            runNo++
            let t = datauseSelect[x]
            let s = {}
            console.log('fastTrack')
            console.log('s.t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              let convertTextField = ''
              if (tempField.length > 0) {
                console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  console.log('optionField', row.optionField)
                  console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            s.type = this.dataTypeJob3
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.remarkRemove = t.remarkRemove
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            s.flowName = t.flowName
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
            s.tel = t.tel
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            dataExport.push(s)
          }
        }
      }
      let s = {}
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.cusReg = ''
      s.remarkRemove = ''
      s.tel = ''
      s.remark = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      dataExport.push(s)
      runNo = 0
      var datause2 = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause2.length; i++) {
        let d = datause2[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            !el.fastTrack &&
            el.statusBtText === 'ยกเลิก'
          )
        })
        if (dataSelect.length > 0) {
          var datauseSelect2 = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          for (let x = 0; x < datauseSelect2.length; x++) {
            runNo++
            let t = datauseSelect2[x]
            let s = {}
            console.log('normal')
            console.log('s.t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              let convertTextField = ''
              if (tempField.length > 0) {
                console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  console.log('optionField', row.optionField)
                  console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            s.type = 'ปกติ'
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.remarkRemove = t.remarkRemove
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            s.flowName = t.flowName
            s.tel = t.tel
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? 'Extra Job' : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            dataExport.push(s)
          }
        }
      }
      this.dataexportRemove = dataExport
      this.onExportRemove()
      console.log('dataEportCancel', JSON.stringify(dataExport))
    },
    updateTimeTablefromChild (timeTable) {
      this.timeTable = timeTable
    },
    onExport () {
      let dataexport = []
      console.log('this.dailyItems from table', this.dailyItems)
      console.log('this.dataToday from v-expansion-panel-content', this.dataToday)
      // this.timeTable
      let newExports = this.dataItem.filter(e => e.dueDateDay === this.timeTable)
      for (const item of newExports) {
        console.log('>>>>', item)
        let row = {
          receiptNo: item.receiptNo,
          บริการ: item.flowName,
          ชื่อลูกค้า: item.CustomFieldName,
          เบอร์โทร: item.CustomFieldTel,
          ที่อยู่: item.address,
          หมายเหตุ: item.remark,
          เวลาที่ลงนัด: item.CREATE_DATE,
          เวลากดเริ่มงาน: item.StartDate,
          สถานะ: item.checkStatus,
          ช่าง: item.empFirstNameTH_mechanic,
          ทดสอบ: item.dueDateDay
        }
        // const matchingPackage = this.dataToday.find(el => el.bookNo === item.bookNo)
        // console.log('matchingPackage', matchingPackage)
        // if (matchingPackage) {
        dataexport.push(row)
        // }
        // console.log('row', row)
      }
      // this.dailyItems.forEach(item => {
      //   console.log('>>>>', item)
      //   let row = {
      //     receiptNo: item.receiptNo,
      //     บริการ: item.flowName,
      //     ชื่อลูกค้า: item.CustomFieldName,
      //     เบอร์โทร: item.CustomFieldTel,
      //     ที่อยู่: item.address,
      //     หมายเหตุ: item.remark,
      //     เวลาที่ลงนัด: item.CREATE_DATE,
      //     เวลากดเริ่มงาน: item.StartDate,
      //     สถานะ: item.checkStatus,
      //     ช่าง: item.empFirstNameTH_mechanic
      //   }
      //   const matchingPackage = this.dataToday.find(el => el.bookNo === item.bookNo)
      //   console.log('matchingPackage', matchingPackage)
      //   if (matchingPackage) {
      //     dataexport.push(row)
      //   }
      //   console.log('row', row)
      // })
      const dataWS = XLSX.utils.json_to_sheet(dataexport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, `export_${this.format_dateNotime(this.timeTable)}.xlsx`)
    },
    // Make sure to implement this method if it doesn't exist
    format_dateNotime (date) {
      // Check if date is a valid Date object, if not, create one
      const d = date instanceof Date ? date : new Date(date)

      // Check if the date is valid
      if (isNaN(d.getTime())) {
        console.error('Invalid date provided to format_dateNotime')
        return 'Invalid Date'
      }

      // Get day, month, and year
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const year = d.getFullYear()

      // Return the formatted date string
      return `${day}-${month}-${year}`
    },
    // --- start function ตรวจสอบคิวจองรายเดือน ---
    async addDataSet () {
      this.statusdepositPrice = false
      this.datailLinkDeposit = ''
      this.remark = ''
      let _this = this
      this.setTimerCalendar = setInterval(function () {
        _this.getDataCalendaBookingAdd()
      }, 20000)
      // var _this = this
      // this.setTimerCalendar = setInterval(function () { _this.getDataCalendaBooking() }, 30000)
      this.dialogAdd = true
      setTimeout(() => this.getDataCalendaBookingAdd(), 1000)
      if (this.branch.length === 0) {
        this.getDataBranch()
      }
      this.getBookingField()
      this.checkTime()
      this.setFlowAdd()
      this.$refs.CalendarBooking.setdataReturnReady()
    },
    async getBookingField () {
      // this.bookingField = []
      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.formAdd.bookingId = rs[0].bookingId
            let bookingData = []
            bookingData = JSON.parse(rs[0].flowfieldName)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await this.getCustomField(itemIncustomField)
          } else {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.dialogAdd = false
                this.clearDataAdd()
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.dialogAdd = false
                this.clearDataAdd()
              })
          }
        })
        .catch(error => {
          this.$swal(
            'พบความผิดพลาดระหว่างดำเนินการ',
            'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
            'info'
          )
            .then(result => {
              this.dialogAdd = false
              this.clearDataAdd()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.dialogAdd = false
              this.clearDataAdd()
            })
          console.log('error function addData : ', error)
        })
    },
    async getDataCalendaBookingAdd () {
      console.log('this.$session.id()', this.$session.id())
      if (this.$session.id() !== undefined) {
        console.log('getDataCalendaBooking')
        let masBranchID = this.formAdd.masBranchID || this.masBranchID
        let flowSelect = this.formAdd.flowId || this.flowSelect
        console.log('masBranchID', masBranchID)
        console.log('flowSelect', flowSelect)
        try {
          await this.$refs.CalendarBooking.getDataReturn(
            this.selectOnsite,
            this.dateStart,
            masBranchID,
            flowSelect
          )
        } catch (e) {
          console.log(e)
        }
        // this.$refs.CalendarBooking.getDataBranch()
        // this.$refs.CalendarBooking.getBookingList()
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    checkTime () {
      this.timeavailable = []
      let dtTime = this.dataFlowSelectAdd.filter(item => {
        return item.value === this.formAdd.flowId
      })
      if (dtTime.length > 0) {
        if (dtTime[0].menuShowStatus === 'True') {
          this.showMenu = 'True'
          this.dataMenuAdd = JSON.parse(dtTime[0].allData.menuItem) || []
        } else {
          this.showMenu = 'False'
          this.dataMenuAdd = []
        }
        // let dtTime = this.branch.filter(item => { return item.value === this.formAdd.masBranchID })
        // console.log('test', dtTime)
        // this.timeavailable = JSON.parse(dtTime.map(item => item.allData.setTime))
        // console.log('timevailable', this.timeavailable)
        if (dtTime.map(item => item.allData.setTime) === null) {
          this.timeavailable = []
          // this.$swal('แจ้งเตือน', 'เนื่องจากยังไม่ได้ตั้งค่าเวลา', 'info')
        } else {
          this.timeavailable = JSON.parse(
            dtTime.map(item => item.allData.setTime)
          )
        }
      }
    },
    setFlowAdd () {
      if (
        this.dataFlowSelectAdd.filter(el => {
          return el.value === this.formAdd.flowId
        }).length > 0
      ) {
        this.checkDepositAdd =
          this.dataFlowSelectAdd.filter(el => {
            return el.value === this.formAdd.flowId
          })[0].allData.checkDeposit || 'False'
        this.statusShowMap =
          this.dataFlowSelectAdd.filter(el => {
            return el.value === this.formAdd.flowId
          })[0].allData.checkOnsite || 'False'
      } else {
        this.checkDepositAdd = 'False'
        this.statusShowMap = 'False'
      }
    },
    // --- end function ตรวจสอบคิวจองรายเดือน ---
    // --- start function ปุ่มมอบหมายงาน ---
    async getBookingDataJob (dt, text) {
      console.log('item!!!!!!', dt)
      this.masBranchIDAddJob = dt.masBranchID
      this.dataEmpOnsite = dt
      this.dueDateText = dt.dueDateText
      let dateCurrent = moment().format('YYYY-MM-DD')
      let dueDate = dt.dueDateDay
      console.log(dateCurrent, dueDate)
      if (dt.checkDateConfirmJob === 'True') {
        this.statusConfirmJob = true
      } else {
        if (dateCurrent >= dueDate) {
          this.statusConfirmJob = true
        } else {
          this.statusConfirmJob = false
        }
      }
      // console.log('this.statusConfirmJob', this.statusConfirmJob)
      let checkStep = await axios.get(
        this.$DNS_IP + '/flowStep/get?flowId=' + dt.flowId
      )
      console.log('checkStep', checkStep)
      if (checkStep.data.status === false) {
        this.endDate = moment().format('YYYY-MM-DD')
        this.endTime = moment().format('HH:mm')
        this.statusShowDateConfiremjob = false
      } else {
        this.statusShowDateConfiremjob = true
      }
      this.dueDate = dt.dueDateTextDay
      if (this.statusConfirmJob && this.showOnsite === 'แสดง') {
        this.jobCheckPackage = false
        console.log('dt', dt)
        this.dateTimestamp = moment().unix()
        this.remark = dt.remark
        console.log('getBookingDataJob1 okna', dt.userId, typeof dt.userId)
        this.userId = dt.userId
        this.lineUserId = dt.lineUserId
        console.log(this.userId, this.lineUserId)
        if (dt.packageId !== '') {
          this.dataPackageDefault = true
        } else {
          this.dataPackageDefault = false
        }
        await this.getPackage(dt)
        if (this.dataPackage.length > 0) {
          console.log(
            'dataPackage',
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
          )
          if (
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            }).length > 0
          ) {
            let dataPack = this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
            this.dataPackageDefault = true
            // this.packageId = dataPack[0].value
            this.UpdatePackage(
              dataPack[0].value,
              'ตกลง',
              dataPack[0].text,
              dataPack[0],
              dt.tokenPackage
            )
          } else {
            this.UpdatePackage('', 'ยกเลิก', '', '', '')
            this.dataPackageDefault = false
          }
        }
        this.checkTimeFlow(dt)
        console.log('this.BookingDataItem6144')
        this.BookingDataItem = []
        let itemIncustomField = []

        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response1 => {
            let rs2 = response1.data
            console.log('BookingField', rs2)
            if (rs2.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(rs2[0].flowfieldName)
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                    '/customField/fieldId?fieldId=' +
                    itemIncustomField
                )
                .then(async responses => {
                  let rs1 = responses.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      if (rs.length > 0) {
                        console.log('BookingDataSelect', rs)
                        console.log('customField', rs1)
                        let sortrs = rs1.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          // var s = {}
                          var dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          if (dataBD.length > 0) {
                            if (dt.flowId === dataBD[0].flowId) {
                              d.bookNo = dataBD[0].bookNo
                              d.bookingFieldId = rs2[0].bookingFieldId
                              d.bookingDataId = dataBD[0].bookingDataId
                              d.flowId = dataBD[0].flowId
                              d.masBranchID = dataBD[0].masBranchID
                              // d.dueDate = dt.dueDate
                              // d.conditionField = d.conditionField
                              // d.fieldId = d.fieldId
                              // d.fieldType = d.fieldType
                              d.fieldValue = dataBD[0].fieldValue
                              d.packageId = dataBD[0].packageId
                              // d.fieldName = d.fieldName
                              // d.conditionField = d.conditionField
                              // d.conditionValue = d.conditionValue
                              // d.requiredField = d.requiredField
                              // d.optionField = d.optionField
                              // d.userId = d.userId
                              console.log('rs[0]6207', rs[0])
                              if (rs[0].userId === 'user-skip') {
                                d.userId = ''
                                console.log('if sm okna', d.userId, typeof d.userId)
                              } else {
                                d.userId = rs[0].userId
                                console.log('else sm okna', d.userId, typeof d.userId)
                              }
                              d.shopId = this.session.data.shopId
                              d.userName = this.$session.getAll().data.userName
                              console.log('this.BookingDataItem6216', this.BookingDataItem)
                              this.BookingDataItem.push(d)
                              console.log('this.BookingDataItem6218', this.BookingDataItem)
                            }
                          }
                        }
                        if (text === 'qrcode') {
                          this.dataQrcode = dt
                        }
                        // await this.getBookingField()
                        await this.getflowfield(dt)
                      }
                    })
                })
            }
          })
      }
      if (this.showOnsite === 'ไม่แสดง') {
        this.jobCheckPackage = false
        console.log('dt', dt)
        this.dateTimestamp = moment().unix()
        this.remark = dt.remark
        console.log('getBookingDataJob2 okna', dt.userId, typeof dt.userId)
        this.userId = dt.userId
        this.lineUserId = dt.lineUserId
        console.log(this.userId, this.lineUserId)
        if (dt.packageId !== '') {
          this.dataPackageDefault = true
        } else {
          this.dataPackageDefault = false
        }
        await this.getPackage(dt)
        if (this.dataPackage.length > 0) {
          console.log(
            'dataPackage',
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
          )
          if (
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            }).length > 0
          ) {
            let dataPack = this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
            this.dataPackageDefault = true
            // this.packageId = dataPack[0].value
            this.UpdatePackage(
              dataPack[0].value,
              'ตกลง',
              dataPack[0].text,
              dataPack[0],
              dt.tokenPackage
            )
          } else {
            this.UpdatePackage('', 'ยกเลิก', '', '', '')
            this.dataPackageDefault = false
          }
        }
        this.checkTimeFlow(dt)
        console.log('this.BookingDataItem6278', this.BookingDataItem)
        this.BookingDataItem = []
        let itemIncustomField = []

        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response1 => {
            let rs2 = response1.data
            console.log('BookingField', rs2)
            if (rs2.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(rs2[0].flowfieldName)
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                    '/customField/fieldId?fieldId=' +
                    itemIncustomField
                )
                .then(async responses => {
                  let rs1 = responses.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      if (rs.length > 0) {
                        console.log('BookingDataSelect', rs)
                        console.log('customField', rs1)
                        let sortrs = rs1.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          // var s = {}
                          let dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          if (dataBD.length > 0) {
                            if (dt.flowId === dataBD[0].flowId) {
                              d.bookNo = dataBD[0].bookNo
                              d.bookingFieldId = rs2[0].bookingFieldId
                              d.bookingDataId = dataBD[0].bookingDataId
                              d.flowId = dataBD[0].flowId
                              d.masBranchID = dataBD[0].masBranchID
                              // d.dueDate = dt.dueDate
                              // d.conditionField = d.conditionField
                              // d.fieldId = d.fieldId
                              // d.fieldType = d.fieldType
                              d.fieldValue = dataBD[0].fieldValue
                              d.packageId = dataBD[0].packageId
                              // d.fieldName = d.fieldName
                              // d.conditionField = d.conditionField
                              // d.conditionValue = d.conditionValue
                              // d.requiredField = d.requiredField
                              // d.optionField = d.optionField
                              // d.userId = d.userId
                              console.log('getBookingDataJob2 if okna rs[0]', rs[0])
                              if (rs[0].userId === 'user-skip') {
                                d.userId = ''
                                console.log('getBookingDataJob2 if okna', d.userId, typeof d.userId)
                              } else {
                                d.userId = rs[0].userId
                                console.log('getBookingDataJob2 else okna', d.userId, typeof d.userId)
                              }
                              d.shopId = this.session.data.shopId
                              d.userName = this.$session.getAll().data.userName
                              console.log('this.BookingDataItem6350', this.BookingDataItem)
                              this.BookingDataItem.push(d)
                              console.log('this.BookingDataItem6352', this.BookingDataItem)
                            }
                          }
                        }
                        if (text === 'qrcode') {
                          this.dataQrcode = dt
                        }
                        // await this.getBookingField()
                        await this.getflowfield(dt)
                      }
                    })
                })
            }
          })
      }
    },
    async getPackage (dt) {
      this.dataPackage = []
      await axios
        .get(
          this.$DNS_IP_Loyalty +
            '/PackageLog/get?shopId=' +
            dt.shopId +
            '&userId=' +
            dt.lineUserId +
            '&flowId=' +
            dt.flowId
        )
        .then(response => {
          console.log('PackageLog', response.data)
          let rs = response.data
          if (rs.status !== false) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              d.text = d.packageName
              d.value = d.packageId
              this.dataPackage.push(d)
            }
          } else {
            this.dataPackage = []
          }
        })
        .catch(error => {
          this.dataPackage = []
          console.log(error)
        })
    },
    async getflowfield (item) {
      this.flowfieldNameitem = []
      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP +
            '/flowField/get?flowId=' +
            item.flowId +
            '&shopId=' +
            this.session.data.shopId
        )
        .then(response => {
          let tt = response.data
          console.log('tt', tt)
          if (tt.length > 0) {
            let flowId = tt[0].flowId
            let flowfieldName = []
            flowfieldName = JSON.parse(tt[0].flowfieldName)
            console.log('flowfieldName', flowfieldName)
            if (flowfieldName.length > 0) {
              for (let a = 0; a < flowfieldName.length; a++) {
                let d = flowfieldName[a]
                itemIncustomField.push(d.fieldId)
                console.log('itemIncustomField', itemIncustomField)
              }
              this.getCustomfieldFlow(itemIncustomField, flowId)
            }
          }
          // console.log('itemIncustomField', itemIncustomField)
        })
    },
    async checkEmpJob () {
      this.today = moment().format('YYYY-MM-DD')
      // console.log('this.dateStart => ', this.dateStart)
      // console.log('this.today => ', this.today)
      const dateSplit = this.today.split('-')
      const year = String(dateSplit[0])
      const month = String(dateSplit[1])
      var flowId = this.dataEmpOnsite.flowId
      // if (this.flowId !== '') {
      //   flowId = this.flowId
      // } else {
      //   flowId = this.dataEmpOnsite.flowId
      // }
      this.eventInfo = []
      await axios
        .get(
          this.$DNS_IP +
            '/booking_view/getCountNotimeJob?shopId=' +
            this.session.data.shopId +
            '&empStep=' +
            this.empSelectJob +
            '&flowId=' +
            flowId +
            '&dueDate=' +
            year +
            '-' +
            month +
            '&checkOnsite=True'
        )
        .then(async responses => {
          console.log('this.responses', responses.data)
          if (responses.data.status === false) {
            this.eventInfo = []
            this.checkEventInfo = []
          } else {
            for (var x = 0; x < responses.data.length; x++) {
              var d = responses.data[x]
              // var s = {}
              let dueDate = d.start
              // s.start = d.start
              // s.name = d.name.toString()
              // s.color = 'blue'
              // this.events.push(s)
              if (typeof this.eventInfo[dueDate] === 'undefined') {
                this.eventInfo[dueDate] = {
                  sortNo1: 0,
                  sortNo2: 0,
                  sortNo3: 0
                }
              }
              if (d.sortNo === 1) {
                this.eventInfo[dueDate].sortNo1++
              } else if (d.sortNo === 2) {
                this.eventInfo[dueDate].sortNo2++
              } else if (d.sortNo === 3) {
                this.eventInfo[dueDate].sortNo3++
              }
            }
            this.checkEventInfo = responses.data
            console.log('this.eventInfo', this.eventInfo)
            console.log('this.checkEventInfo', this.checkEventInfo)
          }
        })
      // this.$refs.calendaronsite.checkChange()
      //   }
      // })
    },
    addEmpJob () {
      this.validate('UPDATE')
      setTimeout(() => this.addEmpJobSubmit(), 500)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break
        case 'EDIT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_edit.validate()
          })
          break
        case 'REMOVE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_remove.validate()
          })
          break
        case 'CHANGE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_change.validate()
          })
          break
        case 'EXPORT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_export.validate()
          })
          break
        case 'DEPOSIT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_deposit.validate()
          })
          break
        case 'BOOKAGAIN':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_bookingAgain.validate()
          })
          break

        default:
          break
      }
    },
    async addEmpJobSubmit () {
      console.log('this.BookingDataItem6555', this.BookingDataItem[0])
      if (this.$session.id() !== undefined) {
        if (this.validUpdate === true) {
          this.dataEditJobReady = false
          let checkJobno = ''
          await axios
            .get(
              this.$DNS_IP +
                '/booking_view/get?bookNo=' +
                this.BookingDataItem[0].bookNo
            )
            .then(async response => {
              let rs = response.data
              console.log('checkJobNoInBooking', rs)
              if (rs.status === false) {
                checkJobno = 'ไม่มีข้อมูล'
              } else {
                checkJobno = rs[0].jobNo || ''
              }
            })
          if (checkJobno === '') {
            let Add = []
            let fielditem = this.flowfieldNameitem
            console.log('fielditem', fielditem)
            console.log('this.BookingDataItem6579', this.BookingDataItem)
            for (var i = 0; i < this.BookingDataItem.length; i++) {
              console.log('this.BookingDataItem6581', this.BookingDataItem[i])
              var d = this.BookingDataItem[i]
              let update = {}
              let addData = false
              var dataField = this.editedItemSeleteField.filter(el => {
                return parseInt(el.fieldId) === parseInt(d.fieldId)
              })
              if (
                dataField[0].conditionField === '' ||
                dataField[0].conditionField === null
              ) {
                addData = true
              } else {
                if (
                  fielditem.filter(row => {
                    return row.fieldId === parseInt(d.conditionField)
                  }).length > 0
                ) {
                  console.log('this', fielditem)
                  if (
                    d.conditionValue ===
                    fielditem.filter(row => {
                      return row.fieldId === parseInt(d.conditionField)
                    })[0].fieldValue
                  ) {
                    addData = true
                  } else if (d.conditionField === 'flow') {
                    addData = true
                  }
                } else if (d.conditionField === 'flow') {
                  addData = true
                }
              }
              if (addData) {
                if (d.fieldValue !== '') {
                  update.masBranchID =
                    this.BookingDataItem[0].masBranchID || ''
                  update.CREATE_USER = d.userName
                  update.LAST_USER = d.userName
                  update.packageId = d.packageId
                  update.checkCar = ''
                  // update.userId = d.userId
                  update.endDate = this.endDate
                  update.endTime = this.endTime.value
                  update.fieldId = d.fieldId
                  update.fieldName = d.fieldName
                  update.fieldType = dataField[0].fieldType || ''
                  update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                  update.flowId = d.flowId
                  update.empSelect = this.empSelectJob
                  update.empStep = this.empSelectJob
                  update.conditionField = dataField[0].conditionField || ''
                  update.conditionValue = dataField[0].conditionValue || ''
                  update.optionField = dataField[0].optionField || ''
                  update.shopId = dataField[0].shopId || ''
                  update.showCard = dataField[0].showCard || ''
                  update.bookNo = this.BookingDataItem[0].bookNo || ''
                  update.tokenPackage = this.tokenPackage || ''
                  console.log('Add push6643', Add)
                  Add.push(update)
                  console.log('Add push6644', Add)
                }
              }
            }
            for (var x = 0; x < fielditem.length; x++) {
              var t = fielditem[x]
              if (
                Add.filter(row => {
                  return row.fieldId === t.fieldId
                }).length === 0
              ) {
                let update = {}
                let dataField = this.editedItemSeleteField.filter(el => {
                  return parseInt(el.fieldId) === parseInt(t.fieldId)
                })
                update.masBranchID = this.BookingDataItem[0].masBranchID || ''
                update.CREATE_USER = Add[0].CREATE_USER
                update.LAST_USER = Add[0].CREATE_USER
                update.packageId = Add[0].packageId
                update.checkCar = ''
                // update.userId = Add[0].userId
                update.endDate = this.endDate
                update.endTime = this.endTime.value
                update.fieldId = t.fieldId
                update.fieldName = t.fieldName
                update.fieldType = dataField[0].fieldType || ''
                update.fieldValue = (t.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                update.flowId = d.flowId
                update.empSelect = this.empSelectJob
                update.empStep = this.empSelectJob
                update.conditionField = dataField[0].conditionField || ''
                update.conditionValue = dataField[0].conditionValue || ''
                update.optionField = dataField[0].optionField || ''
                update.shopId = dataField[0].shopId || ''
                update.showCard = dataField[0].showCard || ''
                update.bookNo = this.BookingDataItem[0].bookNo || ''
                update.tokenPackage = this.tokenPackage || ''
                console.log('Add push6642', Add)
                Add.push(update)
                console.log('Add push6683', Add)
              }
            }
            this.swalConfig.title = 'ต้องการนำรายการนี้ เข้าตารางใช่หรือไม่?'
            this.$swal(this.swalConfig)
              .then(async (result) => {
                this.dataEditJobReady = false
                await axios
                  .post(this.$DNS_IP + '/job/addOneStep', Add)
                  .then(async response => {
                    this.endDate = ''
                    this.endTime = ''
                    this.empSelectJob = ''
                    this.statusShowDateConfiremjob = true
                    if (response.data.status) {
                      // var dt = {
                      //   bookNo: this.BookingDataItem[0].bookNo,
                      //   statusJob: 'job',
                      //   jobNo: response.data.jobNo
                      // }
                      // await axios
                      //   .post(this.$DNS_IP + '/Booking/editStatus/' + this.BookingDataItem[0].bookNo, dt)
                      //   .then(async response1 => {
                      //     var dtt = {
                      //       bookNo: this.BookingDataItem[0].bookNo,
                      //       contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                      //       status: 'confirmJob',
                      //       statusUse: 'use',
                      //       shopId: this.$session.getAll().data.shopId,
                      //       CREATE_USER: this.session.data.userName,
                      //       LAST_USER: this.session.data.userName,
                      //       packageId: this.packageId,
                      //       tokenPackage: this.tokenPackage
                      //     }
                      //     axios
                      //       .post(this.$DNS_IP + '/booking_transaction/add', dtt)
                      //       .then(async response => {
                      this.lineNotifyGroupOnsite(
                        this.BookingDataItem[0].bookNo
                      )
                      if (this.jobCheckPackage) {
                        await this.usePackage(
                          this.BookingDataItem[0].bookNo,
                          this.BookingDataItem[0].masBranchID
                        )
                      }
                      this.$swal('เรียบร้อย', 'นำเข้าสำเร็จ', 'success')
                      // hereja
                      console.log('this.statusSearch', this.statusSearch)
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      this.dialogOnsite = false
                      this.dataEditJobReady = true
                      console.log('this.dataItem jojo', this.dataItem)
                      console.log('this.dataQrcode jojo', this.dataQrcode)
                      var dataJob = this.dataItem.filter(el => {
                        return el.bookNo === this.dataQrcode.bookNo
                      })
                      console.log('dataJob', dataJob)
                      this.getjob(dataJob[0])
                      this.dialogJob = true
                      //     })
                      // })
                    } else {
                      this.$swal('ผิดพลาด', 'กรุณาทำรายการใหม่', 'error')
                      this.dialogOnsite = false
                      this.clearOnsiteChange()
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      // this.getTimesChange('update')
                      if (this.getSelectText) {
                        this.getSelect(
                          this.getSelectText,
                          this.getSelectCount,
                          this.filterCloseJobValue
                        )
                      }
                    }
                  })
              })
              .catch(error => {
                console.log('>>>>>>>>> swal catch <<<<<<<< : ', error)
                if (error === 'cancel') {
                  this.dataEditJobReady = true
                } else {
                  this.checkSwal++
                  if (this.checkSwal <= 3) {
                    setTimeout(() => this.addEmpJobSubmit(), 3000)
                    console.log('error function updateJobNo : ', error)
                  } else {
                    this.dataEditJobReady = true
                    return false
                  }
                }
              })
          } else {
            this.$swal(
              'ผิดพลาด',
              'รายการนี้ได้นำเข้ากระดานการทำงานแล้ว',
              'error'
            )
              .then(async response => {
                this.dialogOnsite = false
                this.clearOnsiteChange()
                if (this.statusSearch === 'no') {
                  await this.getBookingList()
                } else {
                  await this.searchAny()
                }
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.dialogOnsite = false
                this.clearOnsiteChange()
                if (this.statusSearch === 'no') {
                  this.getBookingList()
                } else {
                  this.searchAny()
                }
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
              })
          }
        }
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async lineNotifyGroupOnsite (bookNo) {
      await axios
        .post(this.$DNS_IP + '/Booking/LineNotifyGroupOnsite/' + bookNo)
        .then(async response => {
          if (this.lineUserId !== '') {
            var dt = {
              updateStatusSend: 'false'
            }
            await axios
              .post(
                this.$DNS_IP + '/BookingOnsite/pushEmpCustomer/' + bookNo,
                dt
              )
              .then(async response1 => {})
          }
        })
    },
    async getjob (item) {
      console.log('item getjob', item)
      console.log(item)
      this.bookNo = item.bookNo
      this.dataGetJob = item
      this.jobitem = []
      if (item.jobNo !== '') {
        this.getCoin(item)
        // var lineUserId = ''
        // if (item.lineUserId === null || item.lineUserId === '' || item.lineUserId === 'user-skip' || item.lineUserId === undefined) {
        //   lineUserId = ''
        // } else {
        //   lineUserId = item.lineUserId
        // }
        // this.lineUserId = lineUserId
        let checkBookingMember = ''
        const result = await axios
          .get(
            this.$DNS_IP +
              '/member/get?shopId=' +
              this.session.data.shopId +
              '&liffUserId=' +
              item.userId
          )
          .catch(error => {
            console.log('error function addData : ', error)
          })
        console.log('result', result.data)
        if (result.data.status === false) {
          checkBookingMember = ''
        } else {
          checkBookingMember = result.data[0]
        }
        await axios
          .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + item.jobNo)
          .then(response => {
            let rs = response.data
            let Id = ''
            let memberPicture = ''
            console.log('getJobNo', rs)
            if (rs.length > 0) {
              for (var i = 0; i < rs.length; i++) {
                let d = rs[i]
                let s = {
                  Id: d.jobId,
                  value: d.fieldValue,
                  name: d.fieldName,
                  showCard: d.showCard,
                  jobNo: d.jobNo,
                  checkPayment: d.checkPayment,
                  recordStatus: d.RECORD_STATUS
                }
                Id = d.userId || ''
                memberPicture = d.memberPicture || ''
                this.jobitem.push(s)
              }
              console.log('getjob okna', Id, typeof Id)
              this.userId = Id
              this.memberPicture = memberPicture
              if (checkBookingMember !== '' && this.memberPicture === '') {
                this.checkShowSelectUser = true
                this.dataSelectUser = checkBookingMember
              } else {
                this.checkShowSelectUser = false
                this.dataSelectUser = ''
              }
              this.value =
                this.pathToweb +
                this.jobitem[0].Id +
                '&shopId=' +
                this.$session.getAll().data.shopId
              this.recordStatusJob = this.jobitem[0].recordStatus
              this.checkPayment = this.jobitem[0].checkPayment
              this.formCloseJob.jobNo = this.jobitem[0].jobNo
              this.formCloseJob.jobId = this.jobitem[0].Id
              console.log('this.value', this.value)
              // this.getUserId()
            }
          })
      }
    },
    async getCoin (dt) {
      if (dt.lineUserId !== '') {
        let checkLine = await this.getDataLineConfig(dt.shopId)
        let urlLoyalty = ''
        if (checkLine.checkLineConfig === false) {
          urlLoyalty =
            this.$DNS_IP_Loyalty +
            '/member/get?shopId=' +
            dt.shopId +
            '&lineUserId=' +
            dt.lineUserId
        } else {
          urlLoyalty =
            this.$DNS_IP_Loyalty +
            '/member/get?shopId=' +
            dt.shopId +
            '&liffUserId=' +
            dt.lineUserId
        }
        await axios
          .get(urlLoyalty)
          .then(response => {
            let rs = response.data
            if (rs.status !== false) {
              if (checkLine.checkLineConfig === false) {
                this.lineUserId = rs[0].lineUserId || ''
              } else {
                this.lineUserId = rs[0].liffUserId || ''
              }
              this.memberTel = rs[0].tel || ''
            } else {
              this.lineUserId = ''
              this.memberTel = ''
            }
          })
          .catch(error => {
            this.lineUserId = ''
            this.memberTel = ''
            console.log('error function member : ', error)
          })
        if (this.lineUserId !== '') {
          this.dataCoin = []
          await axios
            .get(
              this.$DNS_IP_Loyalty +
                '/productExchangeRate/get?shopId=' +
                dt.shopId +
                '&flowId=' +
                dt.flowId
            )
            .then(response => {
              console.log('productExchangeRate', response.data)
              let rs = response.data
              if (rs.status !== false) {
                for (var i = 0; i < rs.length; i++) {
                  let d = rs[i]
                  d.text = d.name
                  d.value = d.productExchangeRateId
                  this.dataCoin.push(d)
                  // console.log('this.DataFlowName', this.DataFlowName)
                }
              } else {
                this.dataCoin = []
              }
            })
            .catch(error => {
              this.dataCoin = []
              console.log('error function productExchangeRate : ', error)
            })
        }
      }
    },
    async jobConfirm () {
      console.log('jobConfirm call')
      this.swalConfig.title = 'ต้องการ ยืนยันข้อมูล ใช่หรือไม่?'
      this.$swal(this.swalConfig).then(async () => {
        if (this.$session.id() !== undefined) {
          await axios
            .post(this.$DNS_IP + '/job/update/' + this.jobitem[0].Id, this.skip)
            .then(async response => {
              console.log(response)
              if (response.data.status) {
                this.getDataCalendaBooking()
                this.$swal('เรียบร้อย', 'ปรับปรุงเรียบร้อย', 'success')
                this.dialogJob = false
              } else {
                this.$swal(
                  'ผิดพลาด',
                  'เนื่องจากรายการนี้มีคนนำเข้าแล้ว',
                  'error'
                )
                this.dialogJob = false
              }
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      })
    },
    async pushMsgSelectUser () {
      let statusSend = {
        statusSend: 'false'
      }
      await axios.post(
        this.$DNS_IP + '/job/updateJobNo/' + this.jobitem[0].jobNo,
        statusSend
      )
      console.log('statusSend', 'false')
      let updateStatusSend = {
        updateStatusSend: 'false'
      }
      await axios
        .post(
          this.$DNS_IP + '/job/NotifyQrcode/' + this.jobitem[0].jobNo,
          updateStatusSend
        )
        .then(async response => {
          this.$swal(
            'เรียบร้อย',
            'ส่ง QR Code กลุ่มของท่านเรียบร้อย',
            'success'
          )
          this.dialogJob = false
          // this.clearData()
          // this.$router.push('/Master/FlowStep')
        })
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    FunCopyQrcode (text) {
      // var copyText = document.getElementById('myInput')
      // copyText.select()
      // copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(text)
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิงก์สำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
    },
    async printQrcodeComfirmJob (value, jobitem) {
      let valueStep =
        'https://betask-linked-admin.web.app/AdminStampStep?jobNo=' +
        this.dataGetJob.jobNo +
        '&shopId=' +
        this.$session.getAll().data.shopId
      this.$refs.PrintQrCodeConfirmJobLINE.printQrcode(
        value,
        jobitem,
        this.dataGetJob,
        valueStep
      )
    },
    async setCloseJob (item) {
      console.log('item', item)
      // await this.getCoin(item)
      await this.setCloseJobItem(item[0].jobNo)
      console.log('this.ItemendStepStanby', this.ItemendStepStanby)
      await this.getStepFlowCloseJob(
        this.ItemendStepStanby.flowId,
        this.ItemendStepStanby.shopId
      )
    },
    async setCloseJobItem (jobNo) {
      await axios
        .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + jobNo)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.ItemendStepStanby = rs[0]
          }
        })
    },
    async UpdatePackage (
      packageId,
      StatusPackage,
      packageName,
      data,
      tokenPackage
    ) {
      if (StatusPackage === 'ตกลง') {
        this.packageId = packageId
        this.tokenPackage = tokenPackage
        // this.StatusPackage.status = 'ยกเลิก'
        // this.StatusPackage.color = 'red'
        this.StatusPackage.packageName = packageName
        this.StatusPackage.token = data.token
        // console.log(this.dataPackage.findIndex(x => x.token === tokenPackage && x.packageId === packageId))
        this.modelPackageIndexConfirm =
          this.dataPackage.findIndex(
            x => x.token === tokenPackage && x.packageId === packageId
          ) - 1
        this.modelPackageIndexConfirmJob =
          this.dataPackage.findIndex(
            x => x.token === tokenPackage && x.packageId === packageId
          ) - 1
      } else {
        this.packageId = ''
        this.tokenPackage = ''
        // this.StatusPackage.status = 'ตกลง'
        // this.StatusPackage.color = 'green'
        this.StatusPackage.packageName = ''
        this.StatusPackage.token = ''
        this.modelPackageIndexConfirm = null
        this.modelPackageIndexConfirmJob = null
      }
    },
    async getCustomfieldFlow (item, flowId) {
      let flowfieldNameitems = []
      this.flowfieldNameitem = []
      await axios
        .get(this.$DNS_IP + '/customField/fieldId?fieldId=' + item)
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          let sortrs = rs.sort((a, b) => a.sortNoField - b.sortNoField)
          for (var i = 0; i < sortrs.length; i++) {
            let d = sortrs[i]
            let s = {}
            s.fieldId = d.fieldId
            s.flowId = flowId
            s.fieldName = d.fieldName
            s.optionField = d.optionField
            s.conditionField = d.conditionField || ''
            s.fieldType = d.fieldType
            s.fieldValue = ''
            s.CREATE_USER = ''
            s.LAST_USER = ''
            s.showCard = d.showCard
            s.shopId = this.$session.getAll().data.shopId
            s.endDate = ''
            s.endTime = ''
            s.checkCar = 'False'
            s.conditionValue = d.conditionValue
            s.requiredField = d.requiredField
            flowfieldNameitems.push(s)
          }
          var data1 = flowfieldNameitems.filter(
            el => parseInt(el.conditionField || 0) > 0
          )
          // var data2 = []
          for (let i = 0; i < data1.length; i++) {
            let d = data1[i]
            let indexC = flowfieldNameitems.findIndex(function (o) {
              return o.fieldId === d.fieldId
            })
            let indexF = flowfieldNameitems.findIndex(function (o) {
              return o.fieldId === parseInt(d.conditionField)
            })
            flowfieldNameitems.splice(
              indexF + 1,
              0,
              flowfieldNameitems.splice(indexC, 1)[0]
            )
            // data2.push({'indexC': indexC, 'indexF': indexF})
          }
          // console.log('data1', data1)
          // console.log('data2', data2)
          for (var x = 0; x < flowfieldNameitems.length; x++) {
            var s = flowfieldNameitems[x]
            var chk = this.BookingDataItem.filter(el => {
              return parseInt(el.fieldId) === s.fieldId
            })
            console.log('cccxxx', s)
            console.log('chk', chk)
            if (chk.length === 0) {
              this.flowfieldNameitem.push(s)
            }
          }
          // console.log('flowfieldNameitems', this.flowfieldNameitem)
          // console.log('flowfieldNameitems', flowfieldNameitems)
          // console.log('BookingDataItem', this.BookingDataItem)
          // setTimeout(() => this.validate('ADD'), 500)
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    async usePackage (bookNo, masBranchID) {
      let params = {
        amountOf: 1
      }
      await axios({
        method: 'post',
        headers: {
          shopId: this.$session.getAll().data.shopId,
          lineUserId: this.lineUserId,
          lineId: this.userId
        },
        url:
          this.$DNS_IP_Loyalty +
          '/use_package/edit?shopId=' +
          this.$session.getAll().data.shopId +
          '&token=' +
          this.StatusPackage.token,
        // url: this.$DNS_IP_Loyalty + '/use_package/edit?shopId=' + this.$session.getAll().data.shopId + '&token=' + this.StatusPackage.token + '&branchBeLinked=' + masBranchID,
        data: params
      }).then(response => {})
      await this.updatePackageInBooking(
        this.$session.getAll().data.shopId,
        this.StatusPackage.token,
        this.packageId,
        bookNo
      )
    },
    clearOnsiteChange () {
      this.getDataDefault()
      this.searchOther = ''
      this.showColorSearch = false
      this.statusSearch = 'no'
      this.empSelectJob = ''
    },
    async getDataCalendaBooking () {
      console.log('this.$session.id()', this.$session.id())
      if (this.$session.id() !== undefined) {
        console.log('getDataCalendaBooking')
        try {
          // เอาค่าที่เลือกตอน onChange v-autocomplete ในส่วน component CalendarBooking ที่อยู่ในหน้า BookingListBeauty ส่งไปที่ component CalendarBooking function: getDataReturn
          await this.$refs.CalendarBooking.getDataReturn(
            this.selectOnsite,
            this.dateStart,
            this.masBranchID,
            this.flowSelect
          )
        } catch (e) {
          console.log(e)
        }
        // this.$refs.CalendarBooking.getDataBranch()
        // this.$refs.CalendarBooking.getBookingList()
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async getStepFlowCloseJob (flowId, shopId) {
      await axios
        .get(
          this.$DNS_IP + '/flowStep/get?flowId=' + flowId + '&shopId=' + shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.endStepItem = rs.filter(
              endItem => endItem.sortNo === rs.length
            )
            console.log('this.endStepItem', this.endStepItem)
          }
        })
    },
    async updatePackageInBooking (shopId, token, packageId, bookNo) {
      console.log(shopId, token, packageId, bookNo)
      await axios
        .get(
          this.$DNS_IP_Loyalty +
            '/PackageLog/get?shopId=' +
            shopId +
            '&token=' +
            token +
            '&packageId=' +
            packageId
        )
        .then(async response => {
          console.log('updatePackageInBooking', response.data)
          let rs = response.data
          if (rs.status !== false) {
            var dt = {
              packageName: rs[0].packageName,
              packageDetails: rs[0].packageDetail,
              packageImage: rs[0].packageImg,
              packagePrice: rs[0].packagePrice,
              packageBalanceAmount: rs[0].balanceAmount,
              packageAmount: rs[0].amount,
              packagePoint: rs[0].packagePoint,
              packageExpire: rs[0].packageExpire
            }
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.$DNS_IP + "/Booking/edit/" + bookNo,
                dt
              )
              .then(async response => {})
              .catch(error => {
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async prev () {
      this.$refs.calendaronsite.prev()
      // this.getBookingList()
      await this.checkEmpJobCalenda()
    },
    async next () {
      this.$refs.calendaronsite.next()
      // this.getBookingList()
      await this.checkEmpJobCalenda()
    },
    async openCalendaList (date, text) {
      this.dataSummary = []
      this.dataCalendar = []
      let dataJobData = []
      if (text === 'sortNo1') {
        // let jobNo = this.checkEventInfo.filter(el => { return el.start === date && el.sortNo === 2 })[0].jobNo
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/job/get?shopId=' +
              this.session.data.shopId +
              '&empStepId=' +
              this.empSelectJob +
              '&dueDate=' +
              date +
              '&sortNo=1' +
              '&checkOnsite=True'
          )
          .then(async response => {
            if (response.data.status === false) {
              dataJobData = []
            } else {
              // dataJobData = response.data
              response.data.forEach(row => {
                if (typeof dataJobData[row.jobNo] === 'undefined') {
                  dataJobData[row.jobNo] = []
                }
                dataJobData[row.jobNo].push(row)
              })
              console.log('dataJobData', dataJobData)
              console.log(
                'checkEventInfo',
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                })
              )
              for (
                let i = 0;
                i <
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                }).length;
                i++
              ) {
                var d = this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                })[i]
                d.name = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'ชื่อ'
                })
                d.licenseNo = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เลขทะเบียน'
                })
                d.tel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เบอร์โทร'
                })
                d.carModel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'รุ่นรถ'
                })
                d.name = d.name.length > 0 ? d.name[0].fieldValue : ''
                d.licenseNo =
                  d.licenseNo.length > 0 ? d.licenseNo[0].fieldValue : ''
                d.tel = d.tel.length > 0 ? d.tel[0].fieldValue : ''
                d.carModel =
                  d.carModel.length > 0 ? d.carModel[0].fieldValue : ''
                d.timeDue = dataJobData[d.jobNo][0].timeDue
                d.dueDate = dataJobData[d.jobNo][0].dueDate
                d.bgcolor = 'orange'
                this.dataCalendar.push(d)
              }

              this.dataCalendar.sort((a, b) => {
                let keyA = new Date(a.dueDate)
                let keyB = new Date(b.dueDate)
                if (keyA < keyB) return -1
                if (keyA > keyB) return 1
                return 0
              })
              console.log('this.dataCalendar', this.dataCalendar)
              this.dataSummary = this.dataCalendar.reduce((r, a) => {
                r[a.bgcolor] = r[a.bgcolor] || {}
                r[a.bgcolor][a.timeDue] = r[a.bgcolor][a.timeDue] || []
                r[a.bgcolor][a.timeDue].push(a)
                return r
              }, Object.create(null))
              console.log('this.dataSummary', this.dataSummary)
            }
          })
        this.dialogCalenda = true
      } else {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/job/get?shopId=' +
              this.session.data.shopId +
              '&empStepId=' +
              this.empSelectJob +
              '&dueDate=' +
              date +
              '&sortNo=2' +
              '&checkOnsite=True'
          )
          .then(async response => {
            if (response.data.status === false) {
              dataJobData = []
            } else {
              // dataJobData = response.data
              response.data.forEach(row => {
                if (typeof dataJobData[row.jobNo] === 'undefined') {
                  dataJobData[row.jobNo] = []
                }
                dataJobData[row.jobNo].push(row)
              })
              console.log('dataJobData', dataJobData)
              console.log(
                'checkEventInfo',
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                })
              )
              for (
                let i = 0;
                i <
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                }).length;
                i++
              ) {
                var d = this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                })[i]
                d.name = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'ชื่อ'
                })[0].fieldValue
                d.licenseNo = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เลขทะเบียน'
                })[0].fieldValue
                d.tel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เบอร์โทร'
                })[0].fieldValue
                d.timeDue = dataJobData[d.jobNo][0].timeDue
                d.dueDate = dataJobData[d.jobNo][0].dueDate
                d.bgcolor = 'blue'
                this.dataCalendar.push(d)
              }

              this.dataCalendar.sort((a, b) => {
                let keyA = new Date(a.dueDate)
                let keyB = new Date(b.dueDate)
                if (keyA < keyB) return -1
                if (keyA > keyB) return 1
                return 0
              })
              console.log('this.dataCalendar', this.dataCalendar)
              this.dataSummary = this.dataCalendar.reduce((r, a) => {
                r[a.bgcolor] = r[a.bgcolor] || {}
                r[a.bgcolor][a.timeDue] = r[a.bgcolor][a.timeDue] || []
                r[a.bgcolor][a.timeDue].push(a)
                return r
              }, Object.create(null))
              console.log('this.dataSummary', this.dataSummary)
            }
          })
        this.dialogCalenda = true
      }
    },
    getQrCOde (item) {
      this.bookNo = item.bookNo
      this.value = this.Redirect + '&bookNo=' + this.bookNo
      this.dialogQrCode = true
    },
    async confirmChk (item) {
      this.dateTimestamp = moment().unix()
      this.dataConfirm = item
      this.remark = item.remark
      console.log('confirmChk sen', item.userId, typeof item.userId)
      this.userId = item.userId
      this.lineUserId = item.lineUserId
      console.log(this.userId, this.lineUserId)
      await this.getEmpSelect(item)
      await this.getPackage(item)
      if (this.dataPackage.length > 0) {
        if (
          this.dataPackage.filter(el => {
            return el.packageId === item.packageId
          }).length > 0
        ) {
          var dataPack = this.dataPackage.filter(el => {
            return el.packageId === item.packageId
          })
          // this.packageId = dataPack[0].value
          this.UpdatePackage(
            dataPack[0].value,
            'ตกลง',
            dataPack[0].text,
            dataPack[0],
            item.tokenPackage
          )
        } else {
          this.UpdatePackage('', 'ยกเลิก', '', '', '')
        }
      }
      this.statusPushEndConfirm = false
      this.dialogConfirm = true
    },
    async setDataChang (item) {
      try {
        if (await this.checkJobLog(item)) {
        // clear Limit
          console.log('setDataChang', item)
          this.statusVIPChang = item.statusVIP
          this.limitCountBranch = []
          this.limitCountBranchOld = []
          this.masBranchIDLimit = ''
          this.flowIDLimit = ''
          this.countBookingLimit = 0
          this.selectCountBookingLimit = 1
          this.limitBookingCheck = 'False'
          this.limitBookingSelect = 'False'
          /// /////////////////////
          this.userId = item.userId || ''
          this.limitBookingCheck = item.limitBookingCheck || 'False'
          item.countHourLimit = item.countHourLimit || 0
          this.countBookingLimit = 0
          this.dueDateOld = item.dueDateDay
          this.dueDateTimeOld = item.timeDuetext
          this.masBranchIDLimit = item.masBranchID
          this.flowIDLimit = item.flowId
          this.checkSelectText = item.statusBt
          this.checkTimeFlow(item)
          this.dataChange = item
          this.remark = item.remark
          this.formChange.date = item.dueDateDay
          this.setLimitBookingChange(item.dueDateDay)
          console.log('this.timeavailable', this.timeavailable)
          // if (this.timeavailable.length > 0) {
          //   if (this.timeavailable.filter(el => { return el.text === item.timeText }).length > 0) {
          //     if (item.timeText) {
          //       this.formChange.time = { text: item.timeText, value: item.timeDuetext }
          //     } else {
          //       this.formChange.time = { text: item.timeDuetext, value: item.timeDuetext }
          //     }
          //   } else {
          //     this.formChange.time = { text: item.timeDuetext, value: item.timeDuetext }
          //   }
          // } else {
          //   this.formChange.time = ''
          // }

          let limitCountBranchOld = 0
          if (
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(item.flowId)
            }).length > 0
          ) {
            let setTimeOld = JSON.parse(
              this.DataFlowNameDefault.filter(el => {
                return el.value === parseInt(item.flowId)
              })[0].allData.setTime
            )
            console.log('setTimeOld', setTimeOld)
            if (setTimeOld === '' || setTimeOld === null) {
              this.limitCountBranchOld = []
            } else {
            // let setTimeOld = JSON.parse(this.branch.filter(el => { return el.value === parseInt(item.masBranchID) })[0].allData.setTime)
              let indexOld = setTimeOld.findIndex(
                element => element.value === item.timeDuetext
              )
              limitCountBranchOld = setTimeOld.slice(
                indexOld,
                indexOld + item.countHourLimit
              )
              this.limitCountBranchOld = limitCountBranchOld
            }
          }

          // checkSelectText จะเป็น confirm หรือ !confirm จะเปิด dialogChange เปลี่ยนเวลานัดหมาย แล้วจะเช็คการโชว์ปุ่มอีกที
          this.dialogChange = true
          console.log(this.formChange)
          if (this.formChange.time !== '') {
            this.setCountTime(item)
          }
          this.SetallowedDatesChange(item.flowId)
        } else {
          this.$swal('คำเตือน', 'รายการนี้ได้เริ่มงานไปแล้ว', 'warning')
        }
      } catch (error) {
        console.log('error setDataChang', error)
      }
    },
    async checkEmpJobCalenda () {
      console.log('this.today', this.today)
      // this.dataEmpOnsite = []
      // this.today = moment(moment(new Date()), 'YYYY-MM-DD').format('YYYY-MM-DD')
      const dateSplit = this.today.split('-')
      const year = String(dateSplit[0])
      const month = String(dateSplit[1])
      var flowId = this.dataEmpOnsite.flowId
      // if (this.flowId !== '') {
      //   flowId = this.flowId
      // } else {
      //   flowId = this.dataEmpOnsite.flowId
      // }
      this.eventInfo = []
      await axios
        .get(
          this.$DNS_IP +
            '/booking_view/getCountNotimeJob?shopId=' +
            this.session.data.shopId +
            '&empStep=' +
            this.empSelectJob +
            '&flowId=' +
            flowId +
            '&dueDate=' +
            year +
            '-' +
            month +
            '&checkOnsite=True'
        )
        .then(async responses => {
          if (responses.data.status === false) {
            this.eventInfo = []
            this.checkEventInfo = []
          } else {
            for (var x = 0; x < responses.data.length; x++) {
              var d = responses.data[x]
              // var s = {}
              let dueDate = d.start
              // s.start = d.start
              // s.name = d.name.toString()
              // s.color = 'blue'
              // this.events.push(s)
              if (typeof this.eventInfo[dueDate] === 'undefined') {
                this.eventInfo[dueDate] = {
                  sortNo1: 0,
                  sortNo2: 0,
                  sortNo3: 0
                }
              }
              if (d.sortNo === 1) {
                this.eventInfo[dueDate].sortNo1++
              } else if (d.sortNo === 2) {
                this.eventInfo[dueDate].sortNo2++
              } else if (d.sortNo === 3) {
                this.eventInfo[dueDate].sortNo3++
              }
            }
            this.checkEventInfo = responses.data
            console.log('this.eventInfo', this.eventInfo)
            console.log('this.checkEventInfo', this.checkEventInfo)
          }
        })
      // this.$refs.calendaronsite.checkChange()
    },
    async checkJobLog (item) {
      try {
        console.log('call checkJobLog')
        if (this.checkShopSigneture[this.session.data.shopId]) {
          if (item.jobNo) {
            const resdata = await axios.get(this.$DNS_IP + '/job_log/get?jobNo=' + item.jobNo)
            console.log('resdata.data', resdata.data)
            if (resdata.data.length <= 1) {
              console.log('รอช่างกดเริ่มงาน')
              return true
            } else if (resdata.data.length > 1) {
              console.log('ช่างกดเริ่มงานไปแล้ว')
              return false
            } else {
              return true
            }
          } else {
            console.log('ยังไม่ได้มอบหมายงานให้ช่าง')
            return true
          }
        } else {
          return true
        }
      } catch (error) {
        console.log('error checkJobLog', error)
        return true
      }
    },
    async setLimitBookingChange (dateitem) {
      this.time = ''
      this.timeavailable = []
      this.limitBookingCheck = 'False'
      let setTime = []
      console.log('!!!_____', this.formChange)
      // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dateitem).getDay())
        setTime = timeJson[0].setTime || []
        console.log('IF')
      } else {
        console.log('ELSE')
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.flowIDLimit)
            })[0].allData.setTime
          ) || []
      }
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        }).length > 0
      ) {
        this.limitBookingCheck =
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          })[0].allData.limitBookingCheck || 'False'
      } else {
        this.limitBookingCheck = 'False'
      }
      if (this.limitBookingCheck === 'True') {
        let TimeData = []
        let currentDate = setTime
        TimeData = currentDate
        if (this.statusVIPChang === 'False') {
          this.timeavailable = TimeData.filter(
            item => parseInt(item.limitBooking) > 0
          )
          console.log('TimeData', TimeData)
          if (this.timeavailable.length > 0) {
            let LimitBooking = await this.getLimitBookingChang()
            console.log('LimitBooking!!!!!!!', LimitBooking)
            if (LimitBooking.status !== false) {
              if (LimitBooking.length > 0) {
                LimitBooking.forEach((i, n) => {
                  this.timeavailable.forEach((v, k) => {
                    if (i.bookingTime === v.value) {
                      if (i.countBooking >= parseInt(v.limitBooking)) {
                        this.timeavailable.splice(k, 1)
                      }
                    }
                  })
                })
                if (this.timeavailable.length === 0) {
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.date = ''
                }
              }
              console.log('this.timeavailable IF', this.timeavailable)
            } else {
              this.timeavailable = TimeData.filter(
                item => parseInt(item.limitBooking) > 0
              )
              console.log('this.timeavailable ELSE', this.timeavailable)
            }
          } else {
            this.$swal('คิวเต็มแล้ว', 'กรุณาเลือกวันที่ใหม่อีกครั้ง', 'error')
            this.date = ''
          }
        } else {
          this.timeavailable = TimeData
        }
      } else {
        console.log('this.timeavailable ELSEEEEE', this.timeavailable)
        // LimitBookingBy Flow
        // this.timeavailable = JSON.parse(this.flowItemLimit.filter(item => { return item.flowId === this.flowIDLimit })[0].setTime) || []

        // LimitBookingBy masBranch
        if (
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          }).length > 0
        ) {
          this.timeavailable = setTime
        } else {
          this.timeavailable = []
        }
      }
    },
    async setCountTime (dt) {
      console.log('this.formChange.time', this.formChange.time)
      let limitCountBranch = 0
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(dt.flowId)
        }).length > 0
      ) {
        // let setTime = JSON.parse(this.branch.filter(el => { return el.value === parseInt(this.masBranchIDLimit) })[0].allData.setTime)
        let setTime = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(dt.flowId)
          })[0].allData.setTime
        )
        let index = setTime.findIndex(
          element => element.value === this.formChange.time.value
        )
        limitCountBranch = setTime.slice(
          index,
          index + this.selectCountBookingLimit
        )
        this.limitCountBranch = limitCountBranch
        await this.getDataLimitBooking(dt)
      }
    },
    SetallowedDatesChange (flowId) {
      let dataFlow = this.dataFlowSelectAdd.filter(el => {
        return el.value === flowId
      })
      if (dataFlow.length > 0) {
        dataFlow.forEach((v, k) => {
          console.log('v', v)
          if (v.allData.flowId === flowId) {
            // console.log('Value', v.dateDayoffValue)
            v.allData.dateDayCustom = v.allData.dateDayCustom || ''
            v.allData.dateDayoffValue = v.allData.dateDayoffValue || ''
            if (v.allData.dateDayoffValue !== '') {
              console.log('if')
              this.dateDayoff = JSON.parse(v.allData.dateDayoffValue)
            } else {
              console.log('else')
              this.dateDayoff = []
            }
            if (v.dateDayCustom !== '') {
              this.dateDayCustom = JSON.parse(v.allData.dateDayCustom)
            } else {
              this.dateDayCustom = []
            }
          }
        })
      } else {
        this.dateDayoff = []
        this.dateDayCustom = []
      }
    },
    async getLimitBookingChang () {
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
            '/LimitBookingDate/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&flowId=' +
            this.flowIDLimit +
            '&bookingDate=' +
            this.formChange.date
        )
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          return rs
        })
      return LimitBooking
    },
    async getDataLimitBooking (dt) {
      this.dataLimitBookingDate = []
      // let setTime = JSON.parse(this.branch.filter(el => { return el.value === parseInt(this.masBranchIDLimit) })[0].allData.setTime)
      let setTime = JSON.parse(
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(dt.flowId)
        })[0].allData.setTime
      )
      let limitBooking = 0
      if (setTime.length > 0) {
        if (
          setTime.filter(el => {
            return el.value === this.formChange.time.value
          }).length > 0
        ) {
          limitBooking = setTime.filter(el => {
            return el.value === this.formChange.time.value
          })[0].limitBooking
        } else {
          limitBooking = 0
        }
      } else {
        limitBooking = 0
      }
      if (limitBooking !== 0) {
        await axios
          .get(
            this.$DNS_IP +
              '/LimitBookingDate/get?shopId=' +
              this.session.data.shopId +
              '&bookingDate=' +
              this.formChange.date
          )
          .then(async response => {
            let rs = response.data
            if (rs.status === false) {
              this.dataLimitBookingDate = []
            } else {
              for (let i = 0; i < rs.length; i++) {
                let d = rs[i]
                let s = {}
                s.bookingTime = d.bookingTime
                s.countBookingLimit = d.countBooking + '/' + limitBooking
                s.countBooking = d.countBooking
                // if (d.countBooking === parseInt(limitBooking)) {
                //   s.color = 'orange darken-1'
                // } else
                if (d.countBooking > parseInt(limitBooking)) {
                  s.color = 'red darken-1'
                } else if (d.countBooking <= parseInt(limitBooking)) {
                  s.color = 'blue darken-1'
                }
                this.dataLimitBookingDate.push(s)
              }
              for (let i = 0; i < this.limitCountBranch.length; i++) {
                let s = {}
                let d = this.limitCountBranch[i]
                if (
                  this.dataLimitBookingDate.filter(el => {
                    return el.bookingTime === d.value
                  }).length > 0
                ) {
                  let index = this.dataLimitBookingDate.findIndex(
                    element => element.bookingTime === d.value
                  )
                  this.dataLimitBookingDate[index].countBooking =
                    this.dataLimitBookingDate[index].countBooking + 1
                  this.dataLimitBookingDate[index].countBookingLimit =
                    this.dataLimitBookingDate[index].countBooking +
                    '/' +
                    limitBooking
                  // if (this.dataLimitBookingDate[index].countBooking === parseInt(limitBooking)) {
                  //   this.dataLimitBookingDate[index].color = 'orange darken-1'
                  // } else
                  if (
                    this.dataLimitBookingDate[index].countBooking >
                    parseInt(limitBooking)
                  ) {
                    this.dataLimitBookingDate[index].color = 'red darken-1'
                  } else if (
                    this.dataLimitBookingDate[index].countBooking <=
                    parseInt(limitBooking)
                  ) {
                    this.dataLimitBookingDate[index].color = 'blue darken-1'
                  }
                } else {
                  s.bookingTime = d.value
                  s.countBooking = 1
                  s.countBookingLimit = 1 + '/' + limitBooking
                  s.color = 'blue darken-1'
                  this.dataLimitBookingDate.push(s)
                }
              }
              this.dataLimitBookingDate = this.dataLimitBookingDate.sort(
                (a, b) => {
                  if (a.bookingTime < b.bookingTime) return -1
                  return a.bookingTime > b.bookingTime ? 1 : 0
                }
              )
              console.log(
                ' this.dataLimitBookingDate',
                this.dataLimitBookingDate
              )
              console.log('limitBooking', limitBooking)
            }
          })
      }
    },
    async scanQrcode () {
      if (this.$route.query.shopId === this.session.data.shopId) {
        let dt = {
          bookNo: this.$route.query.bookNo
        }
        await axios
          .get(this.$DNS_IP + '/booking_view/getJob?bookNo=' + dt.bookNo)
          .then(async response => {
            let rs = response.data
            console.log('rsJob', rs)
            if (rs.length > 0) {
              await this.getBookingListJob(rs[0])
              this.dialogEdit = true
            } else {
              this.$swal(
                'ผิดพลาด',
                'นัดหมายนี้ไม่ได้อยู่ในร้านของคุณ หรือ อยู่ในกระดานการทำงานแล้ว',
                'error'
              )
              this.$router.push('/Master/BookingListBeauty')
            }
          })
      } else {
        this.$swal('ผิดพลาด', 'นัดหมายนี้ไม่ได้อยู่ในร้านของคุณ', 'error')
        this.$router.push('/Core/Login')
      }
    },
    async getBookingListJob (item) {
      console.log('doit')
      let dateCurrent = moment().format('YYYY-MM-DD')
      let dueDate = item.dueDateDay
      if (dateCurrent >= dueDate) {
        this.statusConfirmJob = true
      } else {
        this.dueDate = item.dueDate
        this.statusConfirmJob = false
      }
      if (this.statusConfirmJob) {
        let checkStep = await axios.get(
          this.$DNS_IP + '/flowStep/get?flowId=' + item.flowId
        )
        console.log('checkStep', checkStep)
        if (checkStep.data.status === false) {
          this.endDate = moment().format('YYYY-MM-DD')
          this.endTime = moment().format('HH:mm')
          this.statusShowDateConfiremjob = false
        } else {
          this.statusShowDateConfiremjob = true
        }
        this.dataQrcode = item
        this.dataReady = false
        this.selectedStatus = true
        // this.getSelectText = ''
        this.dataItem = []
        this.countWaiting = 0
        this.countConfirm = 0
        this.countCancel = 0
        this.countJob = 0
        this.countAll = 0
        // Clear ช่องค้นหา
        this.searchAll2 = ''
        // this.dataItemSelect = []
        var dataItemTimes = []
        var dataItems = []
        this.BookingDataList = []
        if (this.branch.length === 0) {
          await this.getDataBranch()
        }
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/booking_view/getJob?shopId=' +
              this.session.data.shopId +
              '&bookNo=' +
              item.bookNo
          )
          .then(async response => {
            // console.log('getData', response.data)
            if (response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                let d = response.data[i]
                let s = {}
                if (
                  dataItems.filter(el => {
                    return el.bookNo === d.bookNo
                  }).length === 0
                ) {
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate
                  s.shopId = d.shopId
                  s.dueDateDay = d.dueDateDay
                  s.statusVIP = d.statusVIP
                  s.checkDateConfirmJob = d.checkDateConfirmJob
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.depositTextTH = d.depositTextTH
                  s.CREATE_DATE_Status = d.CREATE_DATE_Status
                  s.CREATE_DATE = d.CREATE_DATE
                  s.menuShowStatus = d.menuShowStatus
                  s.dueDateTextDay = d.dueDateTextDay
                  s.remark = d.remark || ''
                  s.masBranchID = d.masBranchID
                  s.empSelect = d.empSelect
                  s.empFull_NameTH = d.empFull_NameTH || ''
                  s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
                  console.log('getBookingListJob sen', d.userId, typeof d.userId)
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.jobNo = d.jobNo
                  s.remarkRemove = d.remarkRemove || ''
                  s.remarkConfirm1 =
                    d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
                  s.remarkConfirm2 =
                    d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.lineUserId = d.lineUserId
                  s.memberPicture = d.memberPicture
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue

                  if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.statusBt || 'wait'
                  switch (d.statusBt) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      this.countConfirm = this.countConfirm + 1
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      this.countCancel = this.countCancel + 1
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      this.countJob = this.countJob + 1
                      break
                    default:
                      s.statusBtText = 'รายการนัดหมายใหม่'
                      this.countWaiting = this.countWaiting + 1
                      break
                  }
                  var chkTime = this.dataItemTime.filter(el => {
                    return el.timeDueHtext === s.timeDueHtext
                  })
                  if (chkTime.length === 0) {
                    dataItemTimes.push(s)
                  }
                  // let dataBookingData = []
                  // await axios
                  //   .get(
                  //     // eslint-disable-next-line quotes
                  //     this.$DNS_IP + "/BookingData/getView?bookNo=" + d.bookNo
                  //   )
                  //   .then(async responses => {
                  //     console.log('getDataData', responses.data)
                  //     dataBookingData = responses.data
                  //     if (responses.data.status !== false) {
                  //       responses.data.forEach((row) => {
                  //         if (typeof (this.BookingDataList[row.bookNo]) === 'undefined') {
                  //           this.BookingDataList[row.bookNo] = []
                  //         }
                  //         this.BookingDataList[row.bookNo].push(row)
                  //       })
                  //     }
                  //   })
                  // s.cusName = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'ชื่อ'
                  // })
                  // s.cusReg = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'เลขทะเบียน'
                  // })
                  // s.tel = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'เบอร์โทร'
                  // })
                  // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
                  // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
                  // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
                  s.cusName = d.bookingDataCustomerName || ''
                  s.cusReg = d.bookingDataCustomerRegisNumber || ''
                  s.tel = d.bookingDataCustomerTel || ''
                  s.displayFlowName = d.displayFlowName || ''
                  dataItems.push(s)
                }
              }
            }
            if (dataItems.length === 0 || dataItems.status === false) {
              this.dataItem = []
              this.dataItemTime = []
              this.dataReady = true
              // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            } else {
              this.dataItem = dataItems
              var datause = dataItemTimes.sort((a, b) => {
                if (a.timeDueHtext < b.timeDueHtext) return -1
                return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              })
              for (var k = 0; k < datause.length; k++) {
                var t = datause[k]
                var h = {}
                h.timeDueHtext = t.timeDueHtext
                let chkTimes = this.dataItemTime.filter(el => {
                  return el.timeDueHtext === t.timeDueHtext
                })
                // console.log('chkTimes', chkTimes)
                if (chkTimes.length === 0) {
                  // console.log('datause(H)', h)
                  this.dataItemTime.push(h)
                }
              }
              this.masBranchID = this.dataItem[0].masBranchID
              console.log('dtTime', this.dataItem[0].masBranchID)
              await this.getBookingData(this.dataItem[0])
              this.checkTimeFlow(item)
              // this.timeavailable = []
              // console.log('dtTime', this.dataItem[0].masBranchID)
              // let dtTime = this.branch.filter(item => { return item.value === this.dataItem[0].masBranchID })
              // console.log('dtTime', this.dataItem[0].masBranchID)
              // this.timeavailable = JSON.parse(dtTime.map(item => item.allData.setTime))
              this.dialogEdit = true
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log(error)
            this.dataReady = true
            //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          })
      }
    },
    async jobConfirmUser () {
      console.log('this.jobitem', this.jobitem)
      console.log('this.BookingDataItem', this.BookingDataItem)
      this.swalConfig.title = 'ต้องการ ยืนยันข้อมูล ใช่หรือไม่?'
      this.$swal(this.swalConfig).then(async () => {
        if (this.$session.id() !== undefined) {
          let dt = {
            userId: this.dataSelectUser.liffUserId
          }
          await axios
            .post(this.$DNS_IP + '/job/update/' + this.jobitem[0].Id, dt)
            .then(async response => {
              console.log(response)
              if (response.data.status) {
                let statusSend = {
                  statusSend: 'true'
                }
                await axios
                  .post(
                    this.$DNS_IP + '/job/updateJobNo/' + this.jobitem[0].jobNo,
                    statusSend
                  )
                  .then(async response => {
                    // let lineUserId = result.data[0].lineUserId
                    console.log('statusSend', 'true')
                    let updateStatusSend = {
                      updateStatusSend: 'false'
                    }
                    await axios
                      .post(
                        this.$DNS_IP + '/job/pushMsg/' + response.data.jobId,
                        updateStatusSend
                      )
                      .catch(error => {
                        console.log('error function addData : ', error)
                      })
                  })
                this.getDataCalendaBooking()
                this.$swal('เรียบร้อย', 'ปรับปรุงเรียบร้อย', 'success')
                this.dialogJob = false
              } else {
                this.$swal(
                  'ผิดพลาด',
                  'เนื่องจากรายการนี้มีคนนำเข้าแล้ว',
                  'error'
                )
                this.dialogJob = false
              }
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      })
    }
    // --- end function ปุ่มมอบหมายงาน ---
  }
}
</script>

<style scoped>
.flex-container {
  display: flex;
  height: 100%;
}

iframe {
  flex: 1;
}

.sendOrder {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  width: 100%;
  height: 112px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
  justify-content: flex-end;
}

.buttomMenuplusminus {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  width: 32px;
  height: 32px;
  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.buttomMenu {
  /* display: flex;
  flex-direction: row;
  align-items: flex-end; */
  padding: 0px;
  gap: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 32px;
  height: 100px;
  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
}

.textTitelMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

.textSubTitelMenu {
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 22px;
}

.cardTextMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 15px;

  width: 147px;
  height: 104px;
  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 1;
}

.textOneBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  width: 147px;
  height: 64px;
  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#autocompleteMap {
  border: 1px solid rgba(0, 60, 255, 0.329);
  background: #fff;
  font-size: 18px;
  height: 35px;
  /* left: 40%; */
  padding: 0 10px;
  /* position: absolute; */
  top: 0;
  width: 90%;
  z-index: 1;
}

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.border-active {
  border-style: solid;
  border-color: red;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.toggle {
  margin: 1em;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.slidein {
  max-width: 40%;
  padding: 2em 1em;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  overflow: scroll;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease-in-out;
}

button {
  padding: 0.5em 1em;
  /* border-radius: 3em; */
  font-size: 1.1em;
}

/* before the element is shown, start off the screen to the right */

/* General styles unrelated to slide in */
body {
  font-family: "Mulish", sans-serif;
}

.toggle {
  margin: 1em;
}

.InputData {
  margin: 0px !important;
  padding: 0px !important;
}

.v-card--link:focus::before {
  opacity: 0;
}

.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  background-color: white !important;
}

.v-list-item__title {
  color: #73777b !important;
  /* font-family: KittithadaBold;
  font-size: 22px !important; */
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}

.bottomAdd {
  background: linear-gradient(3.82deg, #1093ff 0.25%, #66baff 99.75%);
}

.v-data-table__wrapper {
  min-height: 400px !important;
}

.textPriceMenu {
  /* Price/Small */
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  color: #ff7b2c;
}

.textTitelPriceMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
}

.textTitelMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

.textSubTitelMenu {
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 22px;
}

.pictureMenu {
  width: 40px;
  height: 40px;

  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.7));

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.pictureMenuEdit {
  width: 100px;
  height: 100px;

  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.7));

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.cardMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  gap: 12px;

  width: 327px;
  height: 70px;

  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.03),
    0px 4px 20px -2px rgba(50, 50, 71, 0.04);
  border-radius: 16px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
}

.cardMenuEdit {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 20px 10px 20px 10px;
  width: 327px;
  min-height: auto;

  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.03),
    0px 4px 20px -2px rgba(50, 50, 71, 0.04);
  border-radius: 16px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
}

.v-input--selection-controls {
  margin-top: 0px !important;
}

.status-cloumn {
  width: 150px;
  border-radius: 20px;
  /* มุมโค้ง */
  padding: 10px 20px;
  /* ระยะห่างภายใน */
  color: white;
  /* สีข้อความ */
  font-size: 16px;
  /* ขนาดตัวอักษร */
  text-align: center;
  /* จัดข้อความให้อยู่กลาง */
  text-decoration: none;
  /* ลบเส้นขีดล่างของลิงค์ */
  display: inline-block;
  /* แสดงผลเป็นบล็อกแบบอินไลน์ */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* เงา */
  margin: 10px;
  /* ระยะห่างภายนอก */
}
</style>



// WEBPACK FOOTER //
// src/components/Master/BookingJob.vue